import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Spinner, Modal, Accordion, Image } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { shipmentUploadsTableCustomStyles, importExportTableCustomStyles, hazardousDataTableCustomStyles } from "../../utils/TableCustomStyles";
import { PortSequenceSelectCustomStyles, smallFormSelectCustomStyles } from "../../utils/SelectCustomStyles";
import "../../components/css/StepperForm.css";
import "../../components/css/ToolTipForm.css";
import Select from "react-select";
import ContainerImage from "../../images/container.png";
import IsoTankImage from "../../images/iso_tank.png";
import ExcelIcon from "../../images/excel_icon.jpg";
import { ConvertPdfToImage } from "../../utils/ConvertPdfToImage";
import { FormatCurrency } from "../../utils/FormatCurrency";
import DeadFreightDraftBookingRequest from "./DeadFreightDraftBookingRequest";
import { format } from "date-fns";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


function DraftBookingRequest() {
  const navigate = useNavigate()

  const shipmentUploadFileInputRef = useRef(null);
  const shipmentHazardousUploadFileInputRef = useRef(null);
  const inputExtraImportChargeTextRef = useRef(null);
  const inputExtraExportChargeTextRef = useRef(null);
  const shipmentHazardousClassFormRef = useRef(null);
  const shipmentHazardousRequestFormRef = useRef(null);
  const shipmentHazardousCargoRequestFormRef = useRef(null);
  const params = useParams();
  const shipment_id = params?.id

  const [shipmentData, setShipmentData] = useState("");
  const [shipmentExist, setShipmentExist] = useState(false);
  const [showExtraImportChargeSelect, setShowExtraImportChargeSelect] = useState(true);
  const [showExtraExportChargeSelect, setShowExtraExportChargeSelect] = useState(true);
  const [showExtraImportChargeText, setShowExtraImportChargeText] = useState("");
  const [showExtraExportChargeText, setShowExtraExportChargeText] = useState("");
  const [newShipmentImportExtraCharge, setNewShipmentImportExtraCharge] = useState(false);
  const [newShipmentExportExtraCharge, setNewShipmentExportExtraCharge] = useState(false);
  const [hideDestinationPort, setHideDestinationPort] = useState(false);
  const [updateHideDestinationPort, setUpdateHideDestinationPort] = useState("");
  const [hideFdPort, setHideFdPort] = useState(false);
  const [updateHideFdPort, setUpdateHideFdPort] = useState(false);
  const [hiddenFdOrigin, setHiddenFdOrigin] = useState(false);
  const [updateHiddenFdOrigin, setUpdateHiddenFdOrigin] = useState(false);

  const [showDraftBookingLoader, setShowDraftBookingLoader] = useState(false);
  const [showUpdateDraftBookingLoader, setShowUpdateDraftBookingLoader] = useState(false);
  const [tarrifChargeDataPending, setTarrifChargeDataPending] = useState(false);
  const [enableSearchButton, setEnableSearchButton] = useState(false);
  const [enableCreateButton, setEnableCreateButton] = useState(false);
  const [showKYCDocumentForm, setShowKYCDocumentForm] = useState(false);
  const [portList, setPortList] = useState([]);
  const [terminalList, setTerminalList] = useState([]);
  const [vesselScheduleList, setVesselScheduleList] = useState([]);
  const [shipmentTypeList, setShipmentTypeList] = useState([
    { "value": "THROUGH", "label": "THROUGH" },
    { "value": "VIA", "label": "VIA" },
    { "value": "DIRECT", "label": "DIRECT" }
  ]);
  const [containerSizeList, setContainerSizeList] = useState([]);
  const [cargoTypeList, setCargoTypeList] = useState([
    { "value": "HAZARDOUS", "label": "HAZARDOUS" },
    { "value": "NON_HAZARDOUS", "label": "NON_HAZARDOUS" },
    { "value": "MIX_HAZARDOUS", "label": "MIX_HAZARDOUS" },
    { "value": "EMPTY", "label": "EMPTY" }
  ]);
  const [onAccountList, setOnAccountList] = useState([
    { "value": "SHIPPER", "label": "SHIPPER" },
    { "value": "CONSIGNEE", "label": "CONSIGNEE" }
  ]);

  const [commodityList, setCommodityList] = useState([]);
  const [principalList, setPrincipalList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [salesUserList, setSalesUserList] = useState([]);
  const [slotAgreementList, setSlotAgreementList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [shipmentExtraChargeList, setShipmentExtraChargeList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [chargeList, setChargeList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [usdRate, setUSDRate] = useState(0.0);
  const [icdExportCurrency, setIcdExportCurrency] = useState("");
  const [icdImportCurrency, setIcdImportCurrency] = useState("");
  const [transhipmentList, setTranshipmentList] = useState([]);
  const [vesselTranshipmentRoute, setVesselTranshipmentRoute] = useState([]);
  const [transhipmentVessel, setTranshipmentVessel] = useState([]);
  const [portStorageFreeDays, setPortStorageFreeDays] = useState([]);
  const [transhipmentStorageFreeDays, setTranshipmentStorageFreeDays] = useState([]);
  const [slotRateList, setSlotRateList] = useState([]);

  const [blTypeList, setBlTypeList] = useState([
    { "value": "ORIGINAL", "label": "ORIGINAL" },
    { "value": "SEA_WAY", "label": "SEA_WAY" },
    { "value": "SURRENDER", "label": "SURRENDER" }
  ]);
  const [blSubTypeList, setBlSubTypeList] = useState([
    { "value": "NA", "label": "NA" },
    { "value": "PART_BL", "label": "PART_BL" },
    { "value": "SWITCH_BL", "label": "SWITCH_BL" }
  ]);

  const [paymentTypeList, setPaymentTypeList] = useState([
    { "value": "COLLECT", "label": "COLLECT" },
    { "value": "PREPAID", "label": "PREPAID" }
  ]);

  const [balanced20ftSlots, setBalanced20ftSlots] = useState(0);
  const [balanced40ftSlots, setBalanced40ftSlots] = useState(0);
  const [balancedTonnage, setBalancedTonnage] = useState(0.0);
  const [slotsOverload, setSlotsOverload] = useState(false);
  const [tonnageOverload, setTonnageOverload] = useState(false);


  // ----------- Add State Variables
  const [selectedPoa, setSelectedPoa] = useState("");
  const [selectedPol, setSelectedPol] = useState("");
  const [selectedPolTerminal, setSelectedPolTerminal] = useState("");
  const [selectedPodTerminal, setSelectedPodTerminal] = useState("");
  const [selectedPod, setSelectedPod] = useState("");
  const [selectedFd, setSelectedFd] = useState("");
  const [selectedVesselSchedule, setSelectedVesselSchedule] = useState("");
  const [selectedShipmentType, setSelectedShipmentType] = useState("");
  const [showTranshipment, setShowTranshipment] = useState(false);
  const [selectedTranshipment, setSelectedTranshipment] = useState([]);
  const [selectedVesselTranshipmentRoute, setSelectedVesselTranshipmentRoute] = useState("");
  const [selectedTranshipmentSequence, setSelectedTranshipmentSequence] = useState([]);
  const [selectedPrincipal, setSelectedPrincipal] = useState("");
  const [selectedBookingAgent, setSelectedBookingAgent] = useState("");
  const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState("");
  const [selectedBookingParty, setSelectedBookingParty] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [shipper, setShipper] = useState("");
  const [selectedBlType, setSelectedBlType] = useState("");
  const [selectedBlSubType, setSelectedBlSubType] = useState("");
  const [switchAt, setSwitchAt] = useState("")
  const [collectAt, setCollectAt] = useState("")
  const [onAccount, setOnAccount] = useState("")
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [selectedSlotAgreement, setSelectedSlotAgreement] = useState("");
  const [selectedSlotPaymentAgent, setSelectedSlotPaymentAgent] = useState("");
  const [selectedSalesPerson, setSelectedSalesPerson] = useState("");
  const [selectedRateApprovedBy, setSelectedRateApprovedBy] = useState("");
  const [selectedSpaceConfirmedBy, setSelectedSpaceConfirmedBy] = useState("");
  const [poaDetentionFreeDays, setPoaDetentionFreeDays] = useState(7);
  const [podDetentionFreeDays, setPodDetentionFreeDays] = useState(14);
  const [poaTerminalStorageFreeDays, setPoaTerminalStorageFreeDays] = useState(1);
  const [podTerminalStorageFreeDays, setPodTerminalStorageFreeDays] = useState(1);
  const [transhipmentTerminalFreeDays, setTranshipmentTerminalFreeDays] = useState(1);
  const [showDefaultPoaPodFreeDays, setShowDefaultPoaPodFreeDays] = useState(false);
  const [importLocal, setImportLocal] = useState([]);
  const [exportLocal, setExportLocal] = useState([]);
  const [marginPerImport, setMarginPerImport] = useState(0.0);
  const [marginPerExport, setMarginPerExport] = useState(0.0);
  const [totalImportCharge, setTotalImportCharge] = useState(0.0);
  const [totalExportCharge, setTotalExportCharge] = useState(0.0);
  const [totalImportExpense, setTotalImportExpense] = useState(0.0);
  const [totalExportExpense, setTotalExportExpense] = useState(0.0);
  const [remarks, setRemarks] = useState("");
  const [ihcExportRoute, setIhcExportRoute] = useState("");
  const [ihcImportRoute, setIhcImportRoute] = useState("");
  const [importIHCPaymentType, setImportIHCPaymentType] = useState("NA");
  const [exportIHCPaymentType, setExportIHCPaymentType] = useState("NA");
  const [freightCharge, setFreightCharge] = useState(0.0);


  // ----------- Update State Variables
  const [updateSelectedPoa, setUpdateSelectedPoa] = useState("");
  const [updateSelectedPol, setUpdateSelectedPol] = useState("");
  const [updateSelectedPolTerminal, setUpdateSelectedPolTerminal] = useState("");
  const [updateSelectedPodTerminal, setUpdateSelectedPodTerminal] = useState("");
  const [transhipmentPortTerminal, setTranshipmentPortTerminal] = useState("");
  const [updateSelectedPod, setUpdateSelectedPod] = useState("");
  const [updateSelectedFd, setUpdateSelectedFd] = useState("");
  const [updateSelectedVesselSchedule, setUpdateSelectedVesselSchedule] = useState("");
  const [updateSelectedShipmentType, setUpdateSelectedShipmentType] = useState("");
  const [updateSelectedTranshipment, setUpdateSelectedTranshipment] = useState("");
  const [transhipmentPortsForUpdate, setTranshipmentPortsForUpdate] = useState({});
  const [transhipmentUpdatePorts, setTranshipmentUpdatePorts] = useState([]);
  const [transhipmentPortSequence, setTranshipmentPortSequence] = useState({});
  const [totalTranshipmentCharge, setTotalTranshipmentCharge] = useState(0);



  const [updateSelectedPrincipal, setUpdateSelectedPrincipal] = useState("");
  const [updateSelectedBookingAgent, setUpdateSelectedBookingAgent] = useState("");
  const [updateSelectedDeliveryAgent, setUpdateSelectedDeliveryAgent] = useState("");
  const [updateSelectedBookingParty, setUpdateSelectedBookingParty] = useState("");
  const [updateSelectedCustomer, setUpdateSelectedCustomer] = useState("");
  const [updateShipper, setUpdateShipper] = useState("");
  const [updateSelectedBlType, setUpdateSelectedBlType] = useState("");
  const [updateSelectedBlSubType, setUpdateSelectedBlSubType] = useState("");
  const [updateSwitchAt, setUpdateSwitchAt] = useState("")
  const [updateCollectAt, setUpdateCollectAt] = useState("")
  const [updateOnAccount, setUpdateOnAccount] = useState("")
  const [updateSelectedPaymentType, setUpdateSelectedPaymentType] = useState("");
  const [updateSelectedSlotAgreement, setUpdateSelectedSlotAgreement] = useState("");
  const [updateSlotOperatorEmail, setUpdateSlotOperatorEmail] = useState("");
  const [updateEmailSubject, setUpdateEmailSubject] = useState("");
  const [updateEmailMessage, setUpdateEmailMessage] = useState("");
  const [updateSelectedSlotPaymentAgent, setUpdateSelectedSlotPaymentAgent] = useState("");
  const [updateSelectedSalesPerson, setUpdateSelectedSalesPerson] = useState("");
  const [updateSelectedRateApprovedBy, setUpdateSelectedRateApprovedBy] = useState("");
  const [updateSelectedSpaceConfirmedBy, setUpdateSelectedSpaceConfirmedBy] = useState("");
  const [updatePoaDetentionFreeDays, setUpdatePoaDetentionFreeDays] = useState(7);
  const [updatePodDetentionFreeDays, setUpdatePodDetentionFreeDays] = useState(14);
  const [updatePoaTerminalStorageFreeDays, setUpdatePoaTerminalStorageFreeDays] = useState(1);
  const [updatePodTerminalStorageFreeDays, setUpdatePodTerminalStorageFreeDays] = useState(1);
  const [updateTranshipmentTerminalFreeDays, setUpdateTranshipmentTerminalFreeDays] = useState({});
  const [transhipmentArray, setTranshipmentArray] = useState(1);
  const [updateImportLocal, setUpdateImportLocal] = useState([]);
  const [updateImportLocalData, setUpdateImportLocalData] = useState([]);
  const [updateExportLocal, setUpdateExportLocal] = useState([]);
  const [updateExportLocalData, setUpdateExportLocalData] = useState([]);
  const [updateMarginPerImport, setUpdateMarginPerImport] = useState(0.0);
  const [updateMarginPerExport, setUpdateMarginPerExport] = useState(0.0);
  const [updateRemarks, setUpdateRemarks] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [updateBookingLineItem, setUpdateBookingLineItem] = useState([]);
  const [bookingLineItemLoader, setBookingLineItemLoader] = useState(false);
  const [updateShipmentUploads, setUpdateShipmentUploads] = useState([]);
  const [updateMiscellaneousCharge, setUpdateMiscellaneousCharge] = useState([]);
  const [updateShippingId, setUpdateShippingId] = useState("");
  const [shipmentUploadsPerPage, setShipmentUploadsPerPage] = useState(5);
  const [updateImportIHCPaymentType, setUpdateImportIHCPaymentType] = useState("NA");
  const [updateExportIHCPaymentType, setUpdateExportIHCPaymentType] = useState("NA");
  const [updatePageLoader, setUpdatePageLoader] = useState(false);
  const [updatePageFirstLoad, setUpdatePageFirstLoad] = useState(false);
  const [transhipmentChargesPending, setTranshipmentChargesPending] = useState(false);
  const [updateFreightCharge, setUpdateFreightCharge] = useState(0.0);

  // --------------------- Dead Freight -----------------------------------
  const [isDeadFreight, setIsDeadFreight] = useState(false);

  useEffect(() => {
    if (!showExtraImportChargeSelect && inputExtraImportChargeTextRef.current) {
      inputExtraImportChargeTextRef.current.focus();
    }
  }, [showExtraImportChargeSelect]);

  useEffect(() => {
    if (!showExtraExportChargeSelect && inputExtraExportChargeTextRef.current) {
      inputExtraExportChargeTextRef.current.focus();
    }
  }, [showExtraExportChargeSelect]);

  const generateId = () => Date.now() + Math.random();

  // =========================================== Vessel Planning ============================================
  const [addVesselRouteModal, setAddVesselRouteModal] = useState(false);
  const [showAddNewVesselToRouteLoader, setShowAddNewVesselToRouteLoader] = useState(false);
  const [vesselLegFromPort, setVesselLegFromPort] = useState("");
  const [vesselLegToPort, setVesselLegToPort] = useState("");
  const [vesselLegSchedule, setVesselLegSchedule] = useState("");
  const [currentCargoIndex, setCurrentCargoIndex] = useState(0);
  const [currentVesselLegIndex, setCurrentVesselLegIndex] = useState(0);
  const [totalSlotRate, setTotalSlotRate] = useState(0);
  
  const [vesselPlanningRows, setVesselPlanningRows] = useState([
    {
      0:[{
          id: generateId,
          vessel: "",
          vessel_desciption: "",
          from: selectedPol,
          from_terminal: selectedPolTerminal,
          to: selectedPod,
          to_terminal: "",
          reached_destination: "",
          transhipment_port: "",
          operator: "",
          slot: 0
        }]
    },
  ]);

  const addVesselPlanningRow = (cargoIndex, vesselIndex) => {
    const from_port = vesselPlanningRows[0][cargoIndex][vesselIndex]['to']
    setVesselLegFromPort(from_port)

    vesselPlanningRows[0][cargoIndex] = [
      ...vesselPlanningRows[0][cargoIndex],
      {
        id: generateId,
        vessel: "",
        vessel_desciption: "",
        from: from_port,
        from_terminal: "",
        to: "",
        to_terminal: "",
        reached_destination: "",
        transhipment_port: "",
        operator: "",
        slot: 0
      },
    ]

    console.log("vesselPlanningRows---------", vesselPlanningRows)
    setVesselPlanningRows(vesselPlanningRows)
    refreshRows()
  };

  const addNewVesselToRoute = () => {
    setShowAddNewVesselToRouteLoader(true)
    const index = currentCargoIndex
    const vessel_index = currentVesselLegIndex + 1
    vesselPlanningRows[0][index][vessel_index]['from'] = vesselLegFromPort
    vesselPlanningRows[0][index][vessel_index]['from_terminal'] = vesselLegSchedule?.loading_port_terminal
    vesselPlanningRows[0][index][vessel_index]['to'] = vesselLegToPort
    vesselPlanningRows[0][index][vessel_index]['to_terminal'] = vesselLegSchedule?.destination_port_terminal
    vesselPlanningRows[0][index][vessel_index]['vessel'] = vesselLegSchedule?.value
    vesselPlanningRows[0][index][vessel_index]['vessel_desciption'] = vesselLegSchedule?.label
    setShowAddNewVesselToRouteLoader(false)
    setAddVesselRouteModal(false)
    refreshRows()
  }

  const removeVesselPlanningRow = (index, vesselIndex) => {
    vesselPlanningRows[0][index].splice(vesselIndex, 1);
    setVesselPlanningRows(vesselPlanningRows)
    refreshRows()
  };

  const calculateSlot = async () => {
    var total_slot_rate = 0
    for (let i=0; i<cargoRows.length; i++){
      var quantity = cargoRows[i]['quantity']

      for (let j=0; j<vesselPlanningRows[0][i].length; j++){
        var slot = vesselPlanningRows[0][i][j]['slot'] ?? 0
        total_slot_rate += quantity * slot
      }
    }

    const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment/gettranshipmentcharge?cargo='+ JSON.stringify(cargoRows) +'&vessel_plan=' + JSON.stringify(vesselPlanningRows[0]));
    setTotalTranshipmentCharge(response.data)
    setTranshipmentStorageFreeDays(response.data?.transhipment_port_free_days)

    setTotalSlotRate(total_slot_rate)
  }

  const updateCalculateSlot = async (updateBookingLineItem, vesselPlanningRows) => {
    if(updateBookingLineItem && Object.keys(vesselPlanningRows || {}).length != 0){
      var total_slot_rate = 0
      for (let i=0; i<updateBookingLineItem.length; i++){
        var quantity = parseInt(updateBookingLineItem?.[i]?.['container_quantity'] ?? updateBookingLineItem?.[i]?.['quantity'])

        for (let j=0; j<vesselPlanningRows?.[0]?.[i].length; j++){
          var slot = parseFloat(vesselPlanningRows?.[0]?.[i]?.[j]['slot']) ?? 0
          total_slot_rate += quantity * slot
        }
      }

      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment/getupdatetranshipmentcharge?cargo='+ JSON.stringify(updateBookingLineItem) +'&vessel_plan=' + JSON.stringify(vesselPlanningRows[0]));
      setTotalTranshipmentCharge(response.data)
      setTranshipmentStorageFreeDays(response.data?.transhipment_port_free_days)

      setTotalSlotRate(total_slot_rate)
      setVesselPlanningRows(vesselPlanningRows)

      console.log("updateBookingLineItem ******", updateBookingLineItem)
      console.log("totalTranshipmentCharge ******", totalTranshipmentCharge)
      console.log("vesselPlanningRows ******", vesselPlanningRows)
    }
  }

  // =========================================== Cargo Rows ============================================
  const [cargoRows, setCargoRows] = useState([
    {
      id: generateId,
      container_size: "",
      quantity: 1,
      weight: 0,
      tare_weight: 0,
      export_iso_tank_charge: 0,
      export_dg_surcharge: 0,
      export_bss_surcharge: 0,
      export_transport_charge: 0,
      export_iso_tank_charge_expense: 0,
      export_dg_surcharge_expense: 0,
      export_bss_surcharge_expense: 0,
      export_transport_charge_expense: 0,
      import_iso_tank_charge: 0,
      import_dg_surcharge: 0,
      import_bss_surcharge: 0,
      import_transport_charge: 0,
      import_iso_tank_charge_expense: 0,
      import_dg_surcharge_expense: 0,
      import_bss_surcharge_expense: 0,
      import_transport_charge_expense: 0,
      cargo_type: "",
      commodity: "",
      currency: ""
    },
  ]);

  const addRow = () => {
    setCargoRows([
      ...cargoRows,
      {
        id: generateId,
        container_size: "",
        quantity: 1,
        weight: 0,
        tare_weight: 0,
        export_iso_tank_charge: 0,
        export_dg_surcharge: 0,
        export_bss_surcharge: 0,
        export_transport_charge: 0,
        export_iso_tank_charge_expense: 0,
        export_dg_surcharge_expense: 0,
        export_bss_surcharge_expense: 0,
        export_transport_charge_expense: 0,
        import_iso_tank_charge: 0,
        import_dg_surcharge: 0,
        import_bss_surcharge: 0,
        import_transport_charge: 0,
        import_iso_tank_charge_expense: 0,
        import_dg_surcharge_expense: 0,
        import_bss_surcharge_expense: 0,
        import_transport_charge_expense: 0,
        cargo_type: "",
        commodity: "",
        currency: ""
      },
    ]);
  };

  const removeRow = (id) => {
    setCargoRows(cargoRows.filter((row) => row.id !== id));
  };

  const handleChange = (index, id, field, value, operation) => {
    if (operation == "UPDATE") {
      updateBookingLineItem[index][field] = value;
      setUpdateBookingLineItem(updateBookingLineItem)
    }
    else {
      if (field == "quantity") {
        if (cargoRows[index]["container_size"]["label"] == "20GP" && value > balanced20ftSlots) {
          toast.warning("Only " + balanced20ftSlots + " - 20ft slots available on vessel")
          setSlotsOverload(true)
        }
        else if (cargoRows[index]["container_size"]["label"] == "40GP" && value > balanced40ftSlots) {
          toast.warning("Only " + balanced40ftSlots + " - 40ft slots available on vessel")
          setSlotsOverload(true)
        }
        else {
          cargoRows[index][field] = value;
          setCargoRows(cargoRows);
          setSlotsOverload(false)
        }
      }
      else if (field == "weight" && value > balancedTonnage) {
        toast.warning("Only " + balancedTonnage + " MT can be loaded on vessel")
        setTonnageOverload(true)
      }
      else if(field == "cargo_type"){
        console.log("Commodity", commodityList)
        console.log("cargo_type", cargoRows[index]['cargo_type'])

        
        cargoRows[index][field] = value;
        setCargoRows(cargoRows);
      }
      else {
        cargoRows[index][field] = value;
        setCargoRows(cargoRows);
        setTonnageOverload(false)
      }
    }
  };

  const refreshRows = () => {
    addRow()
    setCargoRows(cargoRows => cargoRows.slice(0, -1))
  }


  const setShipmentDataForUpdate = (data) => {
    setUpdatePageLoader(true)
    setUpdateSelectedPoa(data?.poa_data)
    setUpdateSelectedPol(data?.pol_data)
    setUpdateSelectedPolTerminal(data?.pol_terminal_data)

    console.log("data?.pod_terminal_data", data?.get_pod_terminal)
    setUpdateSelectedPodTerminal({"id": data?.get_pod_terminal, "name": data?.get_pod_terminal})
    setUpdateSelectedPod(data?.pod_data)
    setUpdateHideDestinationPort(data?.pod_data?.hide_if_destination)
    setUpdateSelectedFd(data?.fd_data)
    setUpdateHideFdPort(data?.hide_fd)
    setUpdateHiddenFdOrigin(data?.origin_for_fd_data)

    const port_sequence = Object.values(data?.first_vessel_schedule_data?.service_data?.sequence || {});
    const loading_port = String(data?.pol_data?.id);
    const filteredLoadingPort = port_sequence.filter(port => port.id == loading_port);

    const destination_port = String(data?.pod_data?.id);
    const filteredDestinationPort = port_sequence.filter(port => port.id == destination_port);

    setUpdateSelectedVesselSchedule({  
                                      "value": data?.first_vessel_schedule_data?.id, 
                                      "label": data?.first_vessel_schedule_data?.vessel_data?.name + " - " + format(new Date(data?.first_vessel_schedule_data?.schedule_timeline?.[0]?.eta), "dd/MM/yyyy, hh:mm a") + " at " + data?.pol_data?.name + " (" + data?.pol_terminal_data?.name + ")", 
                                      "loading_port_terminal": filteredLoadingPort?.[0]?.terminal_name,
                                      "destination_port_terminal": filteredDestinationPort?.[0]?.terminal_name
                                    })

    setUpdateSelectedShipmentType({ "value": data?.shipment_type, "label": data?.shipment_type })
    setUpdateSelectedPrincipal({ "value": data?.principal_data?.id, "label": data?.principal_data?.name })
    setUpdateSelectedBookingAgent({ "value": data?.booking_agent_data?.id, "label": data?.booking_agent_data?.name })
    setUpdateSelectedDeliveryAgent({ "value": data?.delivery_agent_data?.id, "label": data?.delivery_agent_data?.name })
    setUpdateSelectedBookingParty({ "value": data?.booking_party_data?.id, "label": data?.booking_party_data?.name })
    setUpdateSelectedCustomer({ "value": data?.customer_data?.id, "label": data?.customer_data?.name })
    setUpdateShipper(data?.shipper)
    setUpdateSelectedBlType({ "value": data?.bl_type, "label": data?.bl_type })
    setUpdateSelectedBlSubType({ "value": data?.bl_sub_type, "label": data?.bl_sub_type })
    setUpdateSwitchAt({ "value": data?.switch_at_data?.id, "label": data?.switch_at_data?.name })
    setUpdateCollectAt({ "value": data?.collect_at_data?.id, "label": data?.collect_at_data?.name })
    setUpdateOnAccount({ "value": data?.on_account, "label": data?.on_account })
    setUpdateSelectedPaymentType({ "value": data?.payment, "label": data?.payment })
    setUpdateSelectedSlotAgreement({ "value": data?.slot_agreement_data?.id, "label": data?.slot_agreement_data?.operator_data?.name })
    setUpdateSlotOperatorEmail(data?.slot_agreement_data?.operator_data?.email)
    setUpdateSelectedSlotPaymentAgent({ "value": data?.slot_payment_agent_data?.id, "label": data?.slot_payment_agent_data?.name })
    setUpdateSelectedSalesPerson({ "value": data?.sales_person_data?.id, "label": data?.sales_person_data?.name })
    setUpdateSelectedRateApprovedBy({ "value": data?.rate_approved_by_data?.id, "label": data?.rate_approved_by_data?.name })
    setUpdateSelectedSpaceConfirmedBy({ "value": data?.space_confirmed_by_data?.id, "label": data?.space_confirmed_by_data?.name })
    setUpdatePoaDetentionFreeDays(data?.poa_detention_free_days)
    setUpdatePodDetentionFreeDays(data?.pod_detention_free_days)
    setUpdatePoaTerminalStorageFreeDays(data?.get_terminal_storage_free_days?.poa_terminal_storage_free_days)
    setUpdatePodTerminalStorageFreeDays(data?.get_terminal_storage_free_days?.pod_terminal_storage_free_days)
    setUpdateFreightCharge(data?.freight_charge)

    setTranshipmentArray(data?.transhipment)
    setUpdateTranshipmentTerminalFreeDays(data?.transhipment_terminal_storage_free_days)

    getUpdateVesselScheduleTranshipmentPort(data?.poa, data?.pol, data?.pod)

    setUpdateRemarks(data?.remarks)
    setUpdateStatus(data?.status)
    setUpdateMiscellaneousCharge(data?.miscellaneous_charge)

    getBookingLineItem(data?.id)
    getShipmentUploads(data?.id)
    getShipmentHazardousUploads(data?.id)
    getShipmentHazardousClassInformation(data?.id)
    getShipmentHazardousRequestInformation(data?.id)
    getUpdateVesselSchedule(data?.pol, data?.pod, data?.pol_data?.name, data?.pod_data?.name)
    getUpdateTrashipmentPort(data?.pol, data?.pod, data?.first_vessel_schedule)
    // setUpdateImportLocal(data?.total_import_local_amount)
    // setUpdateImportLocalData(data?.)
    // setUpdateExportLocal(data?.total_export_local_amount)
    // setUpdateExportLocalData(data?.)
    // setUpdateMarginPerImport(data?.approximate_mpi) 
    // setUpdateMarginPerExport(data?.approximate_mpe) 

    if(data?.transhipment_data){
      const tsp_data = data?.transhipment_data?.map(item => ({ value: item.id, label: item.name, type: item.type, hide_port: item.hide_if_destination }));
      const sorted_data = [...tsp_data].sort((a, b) => a.label.localeCompare(b.label));
      setUpdateSelectedTranshipment(sorted_data)
    }
    else{
      setUpdateSelectedTranshipment([])
    }
    
    updateCalculateSlot(data?.booking_line_item, data?.vessel_planning)

    getSlotRateAgreementOperator(data?.first_vessel_schedule_data?.id)

    const sequence_ports = data?.transhipment_sequence
    const orderedOptions = Object.values(sequence_ports).sort((a, b) => a.index - b.index);
    const selectOptions = orderedOptions.map(item => ({ value: item.id, label: item.name }));

    setTranshipmentPortsForUpdate(selectOptions)
    setTranshipmentUpdatePorts(selectOptions)
    setSelectedVesselTranshipmentRoute({ "value": data?.transhipment_vessel_route, "label": data?.transhipment_vessel_route })
    // handleUpdateTranshipmentVessel(data?.pol_data?.id, data?.pod_data?.id, data?.transhipment)

    const existing_transhipment_sequence = selectOptions.reduce((acc, item, index) => {
      acc[index] = {
        index: index + 1,
        id: item.value,
        name: item.label
      };
      return acc;
    }, {});

    setSelectedTranshipmentSequence(Object.values(data?.transhipment_sequence))
    setTranshipmentPortSequence(existing_transhipment_sequence)

    if (data?.poa_data?.type == "DRYPORT") {
      const export_icd = { 'value': data?.poa, 'type': data?.poa_data?.type }
      const pol = { 'value': data?.pol, 'type': data?.pol_data?.type }
      getIhcExportRoute(export_icd, pol)
    }

    if (data?.fd_data?.type == "DRYPORT") {
      const pod = { 'value': data?.pod, 'type': data?.pod_data?.type }
      const import_icd = { 'value': data?.fd, 'type': data?.fd_data?.type }
      getIhcImportRoute(pod, import_icd)
    }

    setUpdateExportIHCPaymentType(data?.ihc_export_payment_type)
    setUpdateImportIHCPaymentType(data?.ihc_import_payment_type)


    const icd_origin_currency = data?.poa_data?.currency_data
    const icd_export_currency = { "country": icd_origin_currency?.country_data?.long_name, "currency_value": icd_origin_currency?.current_value, "symbol": icd_origin_currency?.symbol }
    setIcdExportCurrency(icd_export_currency)

    const icd_destination_currency = data?.fd_data?.currency_data
    const icd_import_currency = { "country": icd_destination_currency?.country_data?.long_name, "currency_value": icd_destination_currency?.current_value, "symbol": icd_destination_currency?.symbol }
    setIcdImportCurrency(icd_import_currency)

    setImportChargeRows(data?.adhoc_import_charge)
    setExportChargeRows(data?.adhoc_export_charge)
    setMiscellaneousChargeRows(data?.miscellaneous_charge)

    const freight_charge = {
      product_data: { "product_name": "FreightCharge" },
      product_name: "FreightCharge",
      charge_type: "Amount",
      charge_name: "Freight Charge",
      amount: data?.freight_charge,
      expense: 0,
      amount_type: "AMOUNT",
      charge_basis: "PER_CONTAINER",
      currency_data: data?.freight_charge_currency_data,
      currency: data?.freight_charge_currency,
      quantity: data?.booking_line_item?.[0]?.container_quantity,
      total: parseFloat(updateFreightCharge) * parseFloat(data?.booking_line_item?.[0]?.container_quantity),
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    }

    const export_charges = data?.export_local_charge.filter(charge => !(charge.product_name == "Adhoc" | charge.product_name == "Miscellaneous"))
    const shipper_miscellaneous_charge = data?.miscellaneous_charge.filter(charge => charge.paid_by == "SHIPPER")
    var export_local = [
      ...(export_charges.length ? export_charges : []),
      ...(data?.adhoc_export_charge?.length ? data.adhoc_export_charge : []),
      ...(shipper_miscellaneous_charge?.length ? shipper_miscellaneous_charge : []),
    ]

    if(data?.payment == "PREPAID"){
      export_local.push(freight_charge)
    }

    console.log("export_local", export_local)

    setExportLocal(export_local);
    calculateMpe(export_local)

    const import_charges = data?.import_local_charge.filter(charge => !(charge.product_name == "Adhoc" | charge.product_name == "Miscellaneous"))
    const consignee_miscellaneous_charge = data?.miscellaneous_charge.filter(charge => charge.paid_by != "SHIPPER")
    var import_local = [
      ...(import_charges.length ? import_charges : []),
      ...(data?.adhoc_import_charge?.length ? data.adhoc_import_charge : []),
      ...(consignee_miscellaneous_charge?.length ? consignee_miscellaneous_charge : []),
    ]

    if(data?.payment == "COLLECT"){
      import_local.push(freight_charge)
    }

    setImportLocal(import_local);
    calculateMpi(import_local)

    const booking_items = data?.booking_line_item?.map(item => `${item.container_quantity} x ${item.container_type} (${item.commodity})`).join(', ');

    setUpdateEmailSubject(`Submission of DG Documents for ${data?.first_vessel_schedule_data?.vessel_data?.name} - ${data?.first_vessel_schedule_data?.voyage} (${format(new Date(data?.first_vessel_schedule_data?.schedule_timeline?.[0]?.eta), "dd/MM/yyyy, hh:mm a")})`)

    setUpdateEmailMessage(
      `<table cellpadding="0" cellspacing="0" width="100%" style="font-family: Arial, Helvetica, sans-serif; max-width:700px; margin:0 auto; border-collapse:collapse;">
        <tr>
          <td style="padding:18px; border:1px solid #e6e6e6; background:#ffffff;">
            <p style="margin:0 0 12px 0; color:#333333;">Dear <strong>${data?.slot_agreement_data?.operator_data?.name}</strong>,<br>
            ${data?.slot_agreement_data?.operator_data?.company_name}</p>

            <p style="margin:0 0 12px 0; color:#333333;">
              Greetings from Inox Shipping Line.
            </p>

            <p style="margin:0 0 12px 0; color:#333333;">
              Please find attached the following documents related to the DG shipment for your kind review and confirmation:
            </p>

            <ul style="margin:0 0 14px 20px; color:#333333;">
              <li>MSDS Sheet</li>
              <li>UN Certificate of Packaging</li>
              <li>DG Cargo Details (Excel)</li>
            </ul>

            <table cellpadding="6" cellspacing="0" width="100%" style="border:1px solid #f0f0f0; border-collapse:collapse; margin-bottom:14px;">
              <tr style="background:#fafafa;">
                <td style="font-weight:600; width:180px; border-right:1px solid #f0f0f0;">Booking No.</td>
                <td>${data?.reference_number}</td>
              </tr>
              <tr>
                <td style="font-weight:600; border-top:1px solid #f0f0f0; border-right:1px solid #f0f0f0;">Vessel / Voyage</td>
                <td>${data?.first_vessel_schedule_data?.vessel_data?.name} / ${data?.first_vessel_schedule_data?.voyage}</td>
              </tr>
              <tr style="background:#fafafa;">
                <td style="font-weight:600; border-top:1px solid #f0f0f0; border-right:1px solid #f0f0f0;">POL / POD</td>
                <td>${data?.pol_data?.name} / ${data?.pod_data?.name}</td>
              </tr>
              <tr>
                <td style="font-weight:600; border-top:1px solid #f0f0f0; border-right:1px solid #f0f0f0;">Container / Cargo</td>
                <td>
                  ${booking_items}
                </td>
              </tr>
            </table>

            <p style="margin:0 0 12px 0; color:#333333;">
              Kindly review and confirm if any further information is required. Your prompt confirmation is appreciated to proceed with booking formalities.
            </p>

            <p style="margin:16px 0 0 0; color:#333333;">
              Best regards,<br>
              <strong>Inox Shipping Line</strong><br>
              Email: <a href="mailto:support@inoxshipping.com">support@inoxshipping.com</a> | Mob: <a href="tel:+919000000010">+91 9000000010</a><br>
              A - 108, Hermes Atrium, Sector - 11, C.B.D Belapur,NAVI MUMBAI, MAHARASTRA 400614
            </p>
          </td>
        </tr>
      </table>`)

    setUpdatePageLoader(false)
    setUpdatePageFirstLoad(true)
    setEnableSearchButton(true)
    setVesselPlanningRows(data?.vessel_planning)
    console.log("vesselPlanningRows ******", vesselPlanningRows)
  }

  useEffect(() => {
    const container_type = updateBookingLineItem[0]?.container_size?.id
    const cargo_type = updateBookingLineItem[0]?.cargo_type

    if(container_type && cargo_type){
      getTariffCharges()
    }
  }, [updateSelectedPoa, updateSelectedPol, updateSelectedPolTerminal, updateSelectedPodTerminal, updateSelectedPod, updateSelectedFd, updateSelectedBlType, updateBookingLineItem])

  useEffect(() => {
    if (shipmentExist && updatePageFirstLoad && !vesselPlanningRows?.[0]?.[0]?.['vessel'] == "" && 
      !vesselPlanningRows?.[0]?.[0]?.['operator'] == "" && 
      !vesselPlanningRows?.[0]?.[0]?.['transhipment_port'] == ""
    ) {
      console.log("updateSelectedVesselSchedule ******", updateSelectedVesselSchedule)
      
      setVesselPlanningRows([
        {
          0:[{
              id: generateId,
              vessel: updateSelectedVesselSchedule,
              vessel_desciption: updateSelectedVesselSchedule?.label,
              from: {"value": updateSelectedPol?.id, "label": updateSelectedPol?.name},
              from_terminal: updateSelectedVesselSchedule?.loading_port_terminal,
              to: {"value": updateSelectedPod?.id, "label": updateSelectedPod?.name},
              to_terminal: updateSelectedVesselSchedule?.destination_port_terminal,
              reached_destination: "",
              transhipment_port: "",
              operator: "",
              slot: 0
            }]
        },
      ])
      setUpdatePageFirstLoad(false)
    }
  }, [vesselScheduleList]);

  useEffect(() => {
    if (shipmentExist) {
      if (updateBookingLineItem.length > 0) {
        getTariffCharges()
      }
    }
  }, [shipmentExist]);

  // useEffect(() => {
  //   if (shipmentExist) {
  //     if (updateBookingLineItem.length > 0) {
  //       getTotalTranshipmentCharges(updateSelectedSlotAgreement?.label, JSON.stringify(transhipmentPortTerminal), JSON.stringify(updateBookingLineItem), 'UPDATE')
  //     }
  //   }
  // }, [shipmentExist, updateSelectedSlotAgreement, transhipmentPortTerminal, updateBookingLineItem]);

  const getShipment = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/' + id);
      if (response) {
        setShipmentData(response.data)
        if (response?.data) {
          setShipmentExist(true)
          setShipmentDataForUpdate(response?.data)
        }
      }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
  }

  const getSlotRateAgreementOperator = async (vessel_schedule_id) => {
    try {
      const vessel_schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/' + vessel_schedule_id);

      console.log("vessel_schedule_response", vessel_schedule_response)

      if (vessel_schedule_response) {
        const schedule_data = vessel_schedule_response?.data
        const service = schedule_data?.service
        const agreement_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotagreement?service=' + service);
        if (agreement_response) {
          const data = agreement_response.data.map(item => ({ value: item.id, label: item.operator_data?.name, }));
          setSlotAgreementList(data)
        }
      }
    }
    catch (err) {
      toast.error("Error in fetching slot agreements! Try again.");
    }
  }

  const getVesselSlotAndTonnage = async (vessel_schedule_id) => {
    try {
      const vessel_schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/' + vessel_schedule_id);
      if (vessel_schedule_response) {
        const schedule_data = vessel_schedule_response?.data
        // -------------- Checking Balanced Tonnage Capacity of Vessel ------------
        const max_tonnage = schedule_data?.max_tonnage

        const shipment_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment?first_vessel_schedule=' + vessel_schedule_id);
        const booked_shipment_response = shipment_response?.data?.filter(shipment => shipment.slot_number != 0)

        if (booked_shipment_response) {
          const used_tonnage = booked_shipment_response.reduce((sum, shipment) => sum + (shipment.total_tonnage || 0), 0);
          setBalancedTonnage(max_tonnage - used_tonnage)
          console.log("BALANCE Tonnage", max_tonnage - used_tonnage)
        }


        // -------------- Checking Balanced Slots on Vessel 20ft and 40ft ------------
        const loading_port = selectedPol?.value
        const delivery_port = selectedPod?.value

        const similar_20ft_shipment_response = booked_shipment_response.filter(shipment =>
          (Object.values(shipment.shipment_port_route).find(port => port.id == loading_port) || Object.values(shipment.shipment_port_route).find(port => port.id == delivery_port)) &&
          shipment.slot_size == "SIZE_20");

        if (similar_20ft_shipment_response) {
          const balanced_20ft_slots = schedule_data?.dead_freight_20ft - similar_20ft_shipment_response.length
          setBalanced20ftSlots(balanced_20ft_slots)
        }

        const similar_40ft_shipment_response = booked_shipment_response.filter(shipment =>
          (Object.values(shipment.shipment_port_route).find(port => port.id == loading_port) || Object.values(shipment.shipment_port_route).find(port => port.id == delivery_port)) &&
          shipment.slot_size == "SIZE_40");
        if (similar_40ft_shipment_response) {
          const balanced_40ft_slots = schedule_data?.dead_freight_20ft - similar_40ft_shipment_response.length
          setBalanced40ftSlots(balanced_40ft_slots)
        }
      }
    }
    catch (err) {
      console.log("err", err)
      toast.error("Error in fetching Vessel Slot Details! Try again.");
    }
  }

  const getShipmentUploads = async (id) => {
    try {
      setShipmentUploadDataPending(true)
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentdocument?shipment=' + id);
      if (response) {
        setUpdateShipmentUploads(response.data)
      }
      setShipmentUploadDataPending(false)
    } catch (err) {
      toast.error("Error in fetching shipment documents! Try again.");
    }
  }

  const getTotalTranshipmentCharges = async (operator, terminal, cargo_rows, indicator) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment/gettotaltranshipmentcharge?operator=' + operator + '&terminal=' + terminal + '&cargo=' + cargo_rows + '&indicator=' + indicator);
      if (response) {
        setTotalTranshipmentCharge(response.data)
        console.log("response.data-------", response.data)
      }
    } catch (err) {
      toast.error("Error in fetching transhipment charge! Try again.");
    }
  }

  useEffect(() => {
    if (shipment_id != undefined) {
      getShipment(shipment_id)
    }
  }, [shipment_id]);

  const getCurrentTotalTranshipmentCharges = async (operator, terminal, cargoRows, indicator) => {
    setTranshipmentChargesPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment/gettotaltranshipmentcharge?operator=' + operator + '&terminal=' + terminal + '&cargo=' + cargoRows + '&indicator=' + indicator);
      if (response) {
        setTotalTranshipmentCharge(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching ttranshipment charge! Try again.");
    }
    setTranshipmentChargesPending(false)
  }

  // useEffect(() => {
  //   const container_size = cargoRows?.[0]?.container_size?.value
  //   const cargo_type = cargoRows?.[0]?.cargo_type

  //   if (selectedTranshipment?.length > 0 && container_size != "" && cargo_type != "") {
  //     getCurrentTotalTranshipmentCharges(selectedSlotAgreement?.label, JSON.stringify(transhipmentPortTerminal), JSON.stringify(cargoRows), 'NEW')
  //   }
  //   else {
  //     setTotalTranshipmentCharge(0)
  //   }
  // }, [selectedTranshipment, cargoRows]);

  useEffect(() => {
    const container_size = cargoRows?.[0]?.container_size?.value
    const cargo_type = cargoRows?.[0]?.cargo_type

    if (selectedTranshipment?.length > 0 && container_size != "" && cargo_type != "") {
      getCurrentTotalTranshipmentCharges(selectedSlotAgreement?.label, JSON.stringify(transhipmentPortTerminal), JSON.stringify(cargoRows), 'NEW')
    }
    else {
      setTotalTranshipmentCharge(0)
    }
  }, [selectedTranshipment, cargoRows]);


  const [showAddImportModal, setShowAddImportModal] = useState(false);
  const [showUpdateImportModal, setShowUpdateImportModal] = useState(false);
  const [showAddExportModal, setShowAddExportModal] = useState(false);
  const [showUpdateExportModal, setShowUpdateExportModal] = useState(false);

  const [showRouteError, setShowRouteError] = useState(false);
  const [showStakeholderError, setShowStakeholderError] = useState(false);
  const [showBlError, setShowBlError] = useState(false);
  const [showLogisticError, setShowLogisticError] = useState(false);
  const [poaDetentionFreeDaysError, setPoaDetentionFreeDaysError] = useState(false);
  const [podDetentionFreeDaysError, setPodDetentionFreeDaysError] = useState(false);
  const [updatePoaDetentionFreeDaysError, setUpdatePoaDetentionFreeDaysError] = useState(false);
  const [updatePodDetentionFreeDaysError, setUpdatePodDetentionFreeDaysError] = useState(false);
  const [poaTerminalStorageFreeDaysError, setPoaTerminalStorageFreeDaysError] = useState(false);
  const [podTerminalStorageFreeDaysError, setPodTerminalStorageFreeDaysError] = useState(false);

  const [routeFormOpen, setRouteFormOpen] = useState(false);
  const [routeInputDisabled, setRouteInputDisabled] = useState(false);
  const [cargoFormOpen, setCargoFormOpen] = useState(false);
  const [cargoInputDisabled, setCargoInputDisabled] = useState(false);
  const [stakeholderFormOpen, setStakeholderFormOpen] = useState(false);
  const [stakeholderInputDisabled, setStakeholderInputDisabled] = useState(false);
  const [chargesFormOpen, setChargesFormOpen] = useState(false);
  const [chargesInputDisabled, setChargesInputDisabled] = useState(false);
  const [logisticFormOpen, setLogisticFormOpen] = useState(false);
  const [logisticInputDisabled, setLogisticInputDisabled] = useState(false);
  const [handlingFormOpen, setHandlingFormOpen] = useState(false);
  const [handlingInputDisabled, setHandlingInputDisabled] = useState(false);

  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const triggerRouteFormRef = useRef(null);
  const triggerCargoFormRef = useRef(null);
  const triggerStakeholderFormRef = useRef(null);
  const triggerChargesFormRef = useRef(null);
  const triggerLogisticFormRef = useRef(null);
  const triggerHandlingFormRef = useRef(null);

  const tooltipRouteFormRef = useRef(null);
  const tooltipCargoFormRef = useRef(null);
  const tooltipStakeholderFormRef = useRef(null);
  const tooltipChargesFormRef = useRef(null);
  const tooltipLogisticFormRef = useRef(null);
  const tooltipHandlingFormRef = useRef(null);

  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [submitOption, setSubmitOption] = useState("draft");
  const [updateOption, setUpdateOption] = useState("draft");
  const [multipleBookingCount, setMultipleBookingCount] = useState(1);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const user_role = sessionStorage['userrole']
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);


  // ============================================ Add New Import Charge ===================================================
  const [importChargeRows, setImportChargeRows] = useState([
    {
      id: generateId,
      product_data: "Adhoc",
      product_name: "Adhoc",
      charge_data: "",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "AMOUNT",
      charge_type: "IMPORT",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 1,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    },
  ]);

  const addImportChargeRow = () => {
    setImportChargeRows([
      ...importChargeRows,
      {
        id: generateId,
        product_data: "Adhoc",
        product_name: "Adhoc",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_type: "IMPORT",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        approved_by: ""
      },
    ]);
  };

  const removeImportChargeRow = (id) => {
    setImportChargeRows(importChargeRows.filter((row) => row.id !== id));
  };

  const handleImportChargeChange = (index, id, field, value) => {
    importChargeRows[index][field] = value;
    setImportChargeRows(importChargeRows);
  };

  const setExtraImportChargeDetails = (index, charge) => {
    importChargeRows[index]['amount'] = parseFloat(charge?.amount);
    importChargeRows[index]['currency_data'] = { "value": charge?.currency_value, "label": charge?.currency_label, "current_value": charge?.currency_current_value }
    addImportChargeRow()
    setImportChargeRows(chargeRows => chargeRows.slice(0, -1))
  }

  const clearImportChargeRow = () => {
    setImportChargeRows([
      {
        id: generateId,
        product_data: "Adhoc",
        product_name: "Adhoc",
        charge_data: "",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_type: "IMPORT",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        approved_by: ""
      },
    ]);
  }

  // =========================================== Update Import Charge ====================================================
  const [updateImportChargeRows, setUpdateImportChargeRows] = useState(
    {
      id: generateId,
      product_data: "Adhoc",
      product_name: "Adhoc",
      charge_data: "",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "AMOUNT",
      charge_type: "IMPORT",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 1,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    });

  // ============================================ Add New Export Charge ===================================================
  const [exportChargeRows, setExportChargeRows] = useState([
    {
      id: generateId,
      product_data: "Adhoc",
      product_name: "Adhoc",
      charge_data: "",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "AMOUNT",
      charge_type: "EXPORT",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 1,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    },
  ]);

  const addExportChargeRow = () => {
    setExportChargeRows([
      ...exportChargeRows,
      {
        id: generateId,
        product_data: "Adhoc",
        product_name: "Adhoc",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_type: "EXPORT",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        approved_by: ""
      },
    ]);
  };

  const removeExportChargeRow = (id) => {
    setExportChargeRows(exportChargeRows.filter((row) => row.id !== id));
  };

  const handleExportChargeChange = (index, id, field, value) => {
    exportChargeRows[index][field] = value;
    setExportChargeRows(exportChargeRows);
  };

  const setExtraExportChargeDetails = (index, charge) => {
    exportChargeRows[index]['amount'] = charge?.amount;
    exportChargeRows[index]['currency_data'] = { "value": charge?.currency_value, "label": charge?.currency_label, "current_value": charge?.currency_current_value }
    addExportChargeRow()
    setExportChargeRows(chargeRows => chargeRows.slice(0, -1))
  }

  const clearExportChargeRow = () => {
    setExportChargeRows([
      {
        id: generateId,
        product_data: "Adhoc",
        product_name: "Adhoc",
        charge_data: "",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_type: "EXPORT",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        approved_by: ""
      },
    ]);
  }

  // =========================================== Update Export Charge ====================================================
  const [updateExportChargeRows, setUpdateExportChargeRows] = useState(
    {
      id: generateId,
      product_data: "Adhoc",
      product_name: "Adhoc",
      charge_data: "",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "AMOUNT",
      charge_type: "EXPORT",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 1,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    });

  // ============================================ Add New Miscellaneous Charge ===================================================
  const [miscellaneousChargeRows, setMiscellaneousChargeRows] = useState([
    {
      id: generateId,
      product_data: { "product_name": "Miscellaneous" },
      product_name: "Miscellaneous",
      charge_data: "",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "AMOUNT",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 1,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      paid_by: "",
      approved_by: ""
    },
  ]);

  const addMiscellaneousChargeRow = () => {
    setMiscellaneousChargeRows([
      ...miscellaneousChargeRows,
      {
        id: generateId,
        product_data: { "product_name": "Miscellaneous" },
        product_name: "Miscellaneous",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        paid_by: "",
        approved_by: ""
      },
    ]);
  };

  const removeMiscellaneousChargeRow = (row, index) => {
    if (index == 0 && miscellaneousChargeRows.length == 1) {
      setMiscellaneousChargeRows([{
        id: generateId,
        product_data: { "product_name": "Miscellaneous" },
        product_name: "Miscellaneous",
        charge_data: "",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_basis: "",
        currency_data: null,
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        paid_by: "",
        approved_by: ""
      }])

      document.getElementById("miscellaneous_charge_name0").value = "";
      document.getElementById("miscellaneous_charge_amount0").value = "";
      document.getElementById("miscellaneous_charge_quantity0").value = 1;
      document.getElementById("miscellaneous_charge_requested0").value = "";
      document.getElementById("miscellaneous_charge_approved0").value = "";
      document.getElementById("miscellaneous_charge_currency0").value = null;
      document.getElementById("miscellaneous_charge_paid_by0").value = "NA";

      var non_miscellaneous_export = exportLocal.filter(charge => !(charge.product_name == "Miscellaneous"))
      setExportLocal(non_miscellaneous_export)
      calculateMpe(non_miscellaneous_export)

      var non_miscellaneous_import = importLocal.filter(charge => !(charge.product_name == "Miscellaneous"))
      setImportLocal(non_miscellaneous_import)
      calculateMpi(non_miscellaneous_import)
    }
    else {
      var updated_miscellaneous_charges = miscellaneousChargeRows.filter(charge => !(charge.charge_name == row.charge_name))
      setMiscellaneousChargeRows(updated_miscellaneous_charges);

      if (row.paid_by == "SHIPPER") {
        const updated_export_local = exportLocal.filter(item => !(item.id === row.id))
        setImportLocal(updated_export_local)
        calculateMpi(updated_export_local)
      }
      else {
        const updated_import_local = importLocal.filter(item => !(item.id === row.id))
        setImportLocal(updated_import_local)
        calculateMpi(updated_import_local)
      }
    }
  };

  const handleMiscellaneousChargeChange = (index, id, field, value) => {
    if (field == 'amount') {
      miscellaneousChargeRows[index]['amount'] = parseFloat(value);
      setMiscellaneousChargeRows(miscellaneousChargeRows);
    }
    else {
      miscellaneousChargeRows[index][field] = value;
      setMiscellaneousChargeRows(miscellaneousChargeRows);
    }

    var export_local = exportLocal.filter(item => !(item.product_name === "Miscellaneous" && item.charge_name === miscellaneousChargeRows[index]['charge_name']));
    var import_local = importLocal.filter(item => !(item.product_name === "Miscellaneous" && item.charge_name === miscellaneousChargeRows[index]['charge_name']));

    if (miscellaneousChargeRows[index]['paid_by'] == "SHIPPER" && miscellaneousChargeRows[index]['currency_data']) {
      if (export_local.length === 0) {
        export_local.push(miscellaneousChargeRows[index]);
        setMarginPerExport(0)
        setTotalExportCharge(0)
        setTotalExportExpense(0)
      } else {
        console.log("export_local", export_local)
        export_local = [...export_local, ...miscellaneousChargeRows];
      }

      setExportLocal(export_local)
      setImportLocal(import_local)
      calculateMpe(export_local)
      calculateMpi(import_local)
    }
    else if (miscellaneousChargeRows[index]['paid_by'] != "SHIPPER" && miscellaneousChargeRows[index]['currency_data']) {
      if (import_local.length === 0) {
        import_local.push(miscellaneousChargeRows[index]);
        setMarginPerImport(0)
        setTotalImportCharge(0)
        setTotalImportExpense(0)
      } else {
        var import_local = importLocal.filter(item => !(item.product_name === "Miscellaneous"));
        console.log("miscellaneousChargeRows", miscellaneousChargeRows)
        import_local = [...import_local, ...miscellaneousChargeRows];
      }

      setExportLocal(export_local)
      setImportLocal(import_local)
      calculateMpe(export_local)
      calculateMpi(import_local)
    }
  };



  const clearMiscellaneousChargeRow = () => {
    setMiscellaneousChargeRows([
      {
        id: generateId,
        product_data: { "product_name": "Miscellaneous" },
        product_name: "Miscellaneous",
        charge_data: "",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        paid_by: "",
        approved_by: ""
      },
    ]);
  }

  // ============================================ Document Uploads ============================================
  const [updateId, setUpdateId] = useState("");
  const [uploadFiles, setUploadFiles] = useState([]);
  const [showUploadFilesLoader, setShowUploadFilesLoader] = useState(false);
  const [draftbookingUploads, setDraftbookingUploads] = useState(false);
  const [shipmentUploadDataPending, setShipmentUploadDataPending] = useState(false);
  const [deleteShippingUploadModal, setDeleteShippingUploadModal] = useState(false);
  const [uploadFilesSerialNumber, setUploadFilesSerialNumber] = useState(false);
  const [deleteUploadFileName, setDeleteShippingUploadFileName] = useState(false);
  const [showDeleteUploadFilesLoader, setShowDeleteShippingUploadFilesLoader] = useState(false);

  // ============================================ Document Uploads ============================================

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/role/getuserrolepermission?roles=' + roles);

      const role_permissions_array = []
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])) {
            role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
          }
        }
      }

      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array)
      }

    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  }

  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user/' + user_id);
      if (response) {
        setLoggedInUser(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getPort = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/port/');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, type: item.type, hide_port: item.hide_if_destination }));
        const sorted_data = [...data].sort((a, b) => a.label.localeCompare(b.label));
        // const sorted_data = data.sort((a, b) => a.label - b.label)
        setPortList(sorted_data)
      }
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  }

  const getTerminal = async (selectedPort) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/terminal?port=' + selectedPort.value);
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setTerminalList(data)
      }
    } catch (err) {
      toast.error("Error in fetching terminal data! Try again.");
    }
  }

  // const getVesselSchedule = async (pickup_port, destination_port) => {
  //   try {
  //     setVesselScheduleList([])
  //     if(pickup_port.value !="" && destination_port.value !=""){
  //       const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/getvesselschedule?pick_port='+pickup_port.value+'&next_port='+destination_port.value);
  //       if (response) {
  //         const port_sequence = Object.values(response.data[0]?.service_data?.sequence || {});
  //         const loading_port = String(selectedPol?.value);
  //         const filteredLoadingPort = port_sequence.filter(port => port.id == loading_port);
  //         setSelectedPolTerminal({"value": filteredLoadingPort?.[0]?.terminal_id?.[0], "label": filteredLoadingPort?.[0]?.terminal_name})

  //         const filteredDestinationPort = port_sequence.filter(port => port.id == destination_port?.value);
  //         setSelectedPodTerminal({"value": filteredDestinationPort?.[0]?.terminal_id?.[0], "label": filteredDestinationPort?.[0]?.terminal_name})

  //         const data = response.data.map(item => ({ value: item.id, label: item.vessel_data.name + " (" + format(new Date(item.schedule_timeline?.[0]?.['eta']), "dd/MM/yyyy, hh:mm a") + ") at "+ selectedPol?.label +" ("+ filteredLoadingPort?.[0]?.terminal_name +")", terminal: filteredLoadingPort?.[0]?.terminal_id?.[0] }));
  //         setVesselScheduleList(data)
  //       }
  //     }
  //   } catch (err) {
  //     // toast.error("Error in fetching vessel schedule data! Try again.");
  //   }
  // }

  const getEtaDate = (schedule_timeline, loading_port, destination_port) => {
    console.log("schedule_timeline", schedule_timeline)
    console.log("schedule_timeline", Array.isArray(schedule_timeline))
    console.log("loading_port", typeof(loading_port))
    console.log("destination_port", typeof(destination_port))

    if (!Array.isArray(schedule_timeline) || !loading_port) {
      return null;
    }

    const currentPort = schedule_timeline.find(p => String(p.port_id) == loading_port);
    const nextPort = [...schedule_timeline].reverse().find(p => String(p.port_id) === String(destination_port));

    if (!currentPort) {
      return null;
    }

    const lastIndex = !nextPort? 100: nextPort.index

    // index validation
    if (currentPort.index < lastIndex) {
      return currentPort?.eta ? format(new Date(currentPort?.eta), "dd/MM/yyyy, hh:mm a") : "null";
    }

    return null;
  }

  const getVesselSchedule = async (pickup_port, destination_port) => {
    try {
      setVesselScheduleList([])
      if (pickup_port?.value != "" && destination_port?.value != "") {
        

        // This update is to make sure that 
        // 1. all the schedules fetched are upcoming and not from the past
        // 2. all the vessel scheduled will be filtered based on pick port only so that we can select vessel for 1st leg in case if 2nd leg schedule is not there

        // const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/getupcomingvesselschedule?pick_port=' + pickup_port.value + '&pick_port_name='+ pickup_port.label);
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/getvesselschedule?pick_port=' + pickup_port.value + '&pick_port_name='+ pickup_port.label + '&next_port=' + destination_port.value);
        const schedules = response.data.schedules
        if (response?.data && schedules && schedules.length > 0) {

          console.log("schedules------", schedules)
          const port_sequence = Object.values(schedules[0].service_data?.sequence || {});
          const loading_port = String(selectedPol?.value);
          const filteredLoadingPort = port_sequence.filter(port => port.id == loading_port);
          setSelectedPolTerminal({ "value": filteredLoadingPort?.[0]?.terminal_id?.[0], "label": filteredLoadingPort?.[0]?.terminal_name })

          const filteredDestinationPort = port_sequence.filter(port => port.id == destination_port?.value);
          setSelectedPodTerminal({ "value": filteredDestinationPort?.[0]?.terminal_id?.[0], "label": filteredDestinationPort?.[0]?.terminal_name })

          // const data = response.data.schedules.map(item => ({ value: item.id, label: item.vessel_data.name + " (" + getEtaDate(item.schedule_timeline, pickup_port.value, destination_port.value) + ") at " + selectedPol?.label + " (" + filteredLoadingPort?.[0]?.terminal_name + ")", terminal: filteredLoadingPort?.[0]?.terminal_id?.[0] }));
          const data = Array.isArray(schedules)
                      ? schedules.map(item => {
                          const eta = getEtaDate(item.schedule_timeline, pickup_port?.value, destination_port?.value);

                          return {
                            value: item.id,
                            label: item.vessel_data.name + " on " + eta + " at " + selectedPol?.label + " (" + filteredLoadingPort?.[0]?.terminal_name + ")", 
                            terminal: filteredLoadingPort?.[0]?.terminal_id?.[0],
                            loading_port_terminal: filteredLoadingPort?.[0]?.terminal_name,
                            destination_port_terminal: filteredDestinationPort?.[0]?.terminal_name
                          };
                        })
                      : [];
          
          setVesselScheduleList(data)

          if (response.data.route_type == "VIA") {
            setSelectedShipmentType({ "value": "VIA", "label": "VIA" })
            setShowTranshipment(true)
          }
          else {
            setSelectedShipmentType({ "value": "DIRECT", "label": "DIRECT" })
            setShowTranshipment(false)
          }
        }
      }
    } catch (err) {
      console.log("Error ", err);
    }
  }

  const getUpdateVesselSchedule = async (pickup, destination, pickup_name, destination_name) => {
    try {
      setVesselScheduleList([])
      if (pickup != "" && destination != "") {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/getvesselschedule?pick_port=' + pickup + '&next_port=' + destination);
        if (response?.data && response.data.schedules && response.data.schedules.length > 0) {
          const port_sequence = Object.values(response.data.schedules[0].service_data?.sequence || {});
          const loading_port = pickup;
          const filteredLoadingPort = port_sequence.filter(port => port.id == loading_port);
          setUpdateSelectedPolTerminal({ "id": filteredLoadingPort?.[0]?.terminal_id?.[0], "name": filteredLoadingPort?.[0]?.terminal_name })

          const destination_port = destination;
          const filteredDestinationPort = port_sequence.filter(port => port.id == destination_port);
          setUpdateSelectedPodTerminal({ "id": filteredDestinationPort?.[0]?.terminal_id?.[0], "name": filteredDestinationPort?.[0]?.terminal_name })

          const data = response.data.map(item => ({ value: item.id, 
                                                    label: item.vessel_data.name + " (" + item.eta_date + ") at " + pickup_name + " (" + filteredLoadingPort?.[0]?.terminal_name + ")", 
                                                    terminal: filteredLoadingPort?.[0]?.terminal_id?.[0], 
                                                    loading_port_terminal: filteredLoadingPort?.[0]?.terminal_name,
                                                    destination_port_terminal: filteredDestinationPort?.[0]?.terminal_name
                                                  }));
          setVesselScheduleList(data)
        }
      }
    } catch (err) {
      // toast.error("Error in fetching vessel schedule data! Try again.");
    }
  }


  const getVesselLegSchedule = async (pickup_port, destination_port) => {
    try {
      setVesselScheduleList([])
      if (pickup_port?.value != "" && destination_port?.value != "") {
        // This update is to make sure that 
        // 1. all the schedules fetched are upcoming and not from the past
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/getvesselschedule?pick_port=' + pickup_port.value + '&pick_port_name='+ pickup_port.label + '&next_port=' + destination_port.value);
        const schedules = response.data.schedules
        if (response?.data && schedules && schedules.length > 0) {

          console.log("schedules------", schedules)
          const port_sequence = Object.values(schedules[0].service_data?.sequence || {});
          const loading_port = String(pickup_port?.value);
          const filteredLoadingPort = port_sequence.filter(port => port.id == loading_port);
          setSelectedPolTerminal({ "value": filteredLoadingPort?.[0]?.terminal_id?.[0], "label": filteredLoadingPort?.[0]?.terminal_name })

          const filteredDestinationPort = port_sequence.filter(port => port.id == destination_port?.value);
          setSelectedPodTerminal({ "value": filteredDestinationPort?.[0]?.terminal_id?.[0], "label": filteredDestinationPort?.[0]?.terminal_name })

          const data = Array.isArray(schedules)
                      ? schedules.map(item => {
                          const eta = getEtaDate(item.schedule_timeline, pickup_port?.value, destination_port?.value);

                          return {
                            value: item.id,
                            label: item.vessel_data.name + " on " + eta + " at " + pickup_port?.label + " (" + filteredLoadingPort?.[0]?.terminal_name + ")", 
                            terminal: filteredLoadingPort?.[0]?.terminal_id?.[0],
                            loading_port_terminal: filteredLoadingPort?.[0]?.terminal_name,
                            destination_port_terminal: filteredDestinationPort?.[0]?.terminal_name
                          };
                        })
                      : [];
          
          setVesselScheduleList(data)

          if (response.data.route_type == "VIA") {
            setSelectedShipmentType({ "value": "VIA", "label": "VIA" })
            setShowTranshipment(true)
          }
          else {
            setSelectedShipmentType({ "value": "DIRECT", "label": "DIRECT" })
            setShowTranshipment(false)
          }
        }
      }
    } catch (err) {
      console.log("Error ", err);
    }
  }

  const getContainerSize = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/product/getproducts?type=CONTAINER,TANK');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.product_name, type: item.type }));
        setContainerSizeList(data)
      }
    } catch (err) {
      toast.error("Error in fetching container size data! Try again.");
    }
  }

  const getCommodity = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/cargo');
      if (response) {
        const data = response.data.map(item => ({ value: item.name, label: item.name, type: item.cargo_type }));
        setCommodityList(data)
      }
    } catch (err) {
      toast.error("Error in fetching commodity data! Try again.");
    }
  }

  const getPrincipal = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/principal');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setPrincipalList(data)
      }
    } catch (err) {
      toast.error("Error in fetching principal data! Try again.");
    }
  }

  const getAgent = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/agent');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setAgentList(data)
      }
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    }
  }

  const getUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user');
      if (response) {
        const sales_user = response.data.filter(user => user.role_array.includes('sales'));
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        const sales_user_data = sales_user.map(item => ({ value: item.id, label: item.name, }));
        setUserList(data)
        setSalesUserList(sales_user_data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getOperator = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/operator');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setOperatorList(data)
      }
    } catch (err) {
      toast.error("Error in fetching operator data! Try again.");
    }
  }

  const getCustomer = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/customer');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setCustomerList(data)
      }
    } catch (err) {
      toast.error("Error in fetching customer data! Try again.");
    }
  }

  const getShipmentExtraCharge = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentextracharge');
      if (response) {
        const data = response.data.map(item => ({ value: item.name, label: item.name, amount: item.charge, currency_value: item.currency_data?.id, currency_label: item.currency_data?.symbol + " (" + item.currency_data?.name + ")", currency_current_value: item.currency_data?.current_value, charge_type: item.import_export_type }));
        setShipmentExtraChargeList(data)
      }
    } catch (err) {
      toast.error("Error in fetching extra charge data! Try again.");
    }
  }


  const getTariffCharges = async () => {
    if (shipmentExist) {
      try {
        setTarrifChargeDataPending(false)
        const container_type = updateBookingLineItem[0]?.container_size?.id
        const cargo_type = updateBookingLineItem[0]?.cargo_type

        console.log("updateSelectedPodTerminal----------", updateSelectedPodTerminal)
        const pod_terminal = updateSelectedPodTerminal?.id ?? updateSelectedPodTerminal

        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/tariffcharge/gettariffcharges?tariff__poa=' + updateSelectedPoa?.id +
          '&tariff__pol=' + updateSelectedPol?.id + '&tariff__pol_terminal=' + updateSelectedPolTerminal?.id + '&tariff__pod_terminal=' + pod_terminal +
          '&tariff__pod=' + updateSelectedPod?.id + '&tariff__fd=' + updateSelectedFd?.id +
          '&charge_type=' + cargo_type + '&product=' + container_type + '&bl_type=' + updateSelectedBlType?.value);

        if (response) {
          const importLocalCharges = response.data.filter(charge => charge.charge_category == "IMPORT_LOCAL").map(charge => ({
            product_data: charge?.product_data,
            product_name: charge?.product_data?.product_name,
            charge_type: charge?.charge_type,
            charge_name: charge?.charge_name,
            amount: charge?.amount,
            expense: charge?.expense,
            amount_type: charge?.amount_type || "",
            charge_basis: charge?.charge_basis || "",
            currency_data: charge?.currency_data,
            currency: charge?.currency_data?.symbol || "",
            quantity: 1,
            total: 0.0,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }));

          const exportLocalCharges = response.data.filter(charge => charge.charge_category == "EXPORT_LOCAL").map(charge => ({
            product_data: charge?.product_data,
            product_name: charge?.product_data?.product_name,
            charge_type: charge?.charge_type,
            charge_name: charge?.charge_name,
            amount: charge?.amount,
            expense: charge?.expense,
            amount_type: charge?.amount_type || "",
            charge_basis: charge?.charge_basis || "",
            currency_data: charge?.currency_data,
            currency: charge?.currency_data?.symbol || "",
            quantity: 1,
            total: 0.0,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }));

          const transhipment_charge = {
            product_data: { "product_name": "TSP" },
            product_name: "TSP",
            charge_type: "Amount",
            charge_name: "Transhipment Charge",
            amount: 0,
            expense: totalTranshipmentCharge?.total_transhipment_charge,
            amount_type: "AMOUNT",
            charge_basis: "PER_BL",
            currency_data: "",
            currency: totalTranshipmentCharge?.currency,
            quantity: 1,
            total: totalTranshipmentCharge?.total_transhipment_charge,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }

          const freight_charge = {
            product_data: { "product_name": "Freight" },
            product_name: "Freight",
            charge_type: "Amount",
            charge_name: "Freight Charge",
            amount: updateFreightCharge,
            expense: 0,
            amount_type: "AMOUNT",
            charge_basis: "PER_SHIPMENT",
            currency_data: { "current_value": 1, "symbol": "$" },
            currency: "$",
            quantity: 1,
            total: updateFreightCharge,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }

          exportLocalCharges.push(freight_charge)

          for (let i = 0; i < updateBookingLineItem.length; i++) {
            const slot = {
              product_data: { "product_name": updateBookingLineItem[i]?.container_size?.product_name },
              product_name: updateBookingLineItem[i]?.container_size?.product_name,
              charge_type: "Amount",
              charge_name: "Slot Charge (" + updateBookingLineItem[i]?.cargo_type + ")",
              amount: 0,
              expense: totalSlotRate / parseInt(updateBookingLineItem[i]?.quantity),
              amount_type: "AMOUNT",
              charge_basis: "PER_CONTAINER",
              currency_data: { "current_value": 1, "symbol": "$" },
              currency: "$",
              quantity: updateBookingLineItem[i]?.quantity,
              total: parseInt(totalSlotRate) / parseInt(updateBookingLineItem[i]?.quantity),
              requested: 0.0,
              approved: 0.0,
              approved_by: ""
            }
            exportLocalCharges.push(slot)
          }

          // Add IHC Import Local Charge
          getIhcImportRoute(updateSelectedPod, updateSelectedFd)

          if (updateSelectedFd?.type == "DRYPORT") {
            for (let i = 0; i < updateBookingLineItem.length; i++) {
              var ihc_import_charges = {
                product_data: { "product_name": updateBookingLineItem[i]?.container_size?.product_name },
                product_name: updateBookingLineItem[i]?.container_size?.product_name,
                charge_type: "Amount",
                charge_name: "IHC Charge (" + updateBookingLineItem[i]?.weight * updateBookingLineItem[i]?.quantity + " MT + " + updateBookingLineItem[i]?.tare_weight * updateBookingLineItem[i]?.quantity + " Tare Wt)",
                amount: (
                  Number(updateBookingLineItem[i]?.import_transport_charge) +
                  Number(updateBookingLineItem[i]?.import_iso_tank_charge) +
                  Number(updateBookingLineItem[i]?.import_bss_surcharge) +
                  Number(updateBookingLineItem[i]?.import_dg_surcharge) / Number(updateBookingLineItem[i]?.quantity)),
                expense: (
                  Number(updateBookingLineItem[i]?.import_transport_charge_expense) +
                  Number(updateBookingLineItem[i]?.import_iso_tank_charge_expense) +
                  Number(updateBookingLineItem[i]?.import_bss_surcharge_expense) +
                  Number(updateBookingLineItem[i]?.import_dg_surcharge_expense) / Number(updateBookingLineItem[i]?.quantity)),
                amount_type: "AMOUNT",
                charge_basis: "PER_CONTAINER",
                currency_data: { "current_value": parseFloat(icdImportCurrency?.currency_value), "symbol": icdImportCurrency?.symbol },
                currency: updateBookingLineItem[i]?.currency,
                quantity: updateBookingLineItem[i]?.quantity,
                total: updateBookingLineItem[i]?.import_transport_charge_expense,
                requested: 0.0,
                approved: 0.0,
                approved_by: ""
              }

              importLocalCharges.push(ihc_import_charges)
            }
          }

          // Add Existing Adhoc Import Charges and Miscellaneous Import Charges
          if (importChargeRows?.[0]?.amount > 0) {
            if (miscellaneousChargeRows?.[0]?.amount > 0) {
              var miscellaneous_import_charges = miscellaneousChargeRows.filter(charge => !(charge.paid_by == "SHIPPER"))
              var updated_import_local_charges = [...importLocalCharges, ...importChargeRows, ...miscellaneous_import_charges]
              setImportLocal(updated_import_local_charges)
            }
            else {
              var updated_import_local_charges = [...importLocalCharges, ...importChargeRows]
              setImportLocal(updated_import_local_charges)
            }
          }
          else {
            if (miscellaneousChargeRows?.[0]?.amount > 0) {
              var miscellaneous_import_charges = miscellaneousChargeRows.filter(charge => !(charge.paid_by == "SHIPPER"))
              var updated_import_local_charges = [...importLocalCharges, ...miscellaneous_import_charges]
              setImportLocal(updated_import_local_charges)
            }
            else {
              setImportLocal(importLocalCharges)
            }
          }

          var mpi = 0
          var total_import_charge = 0
          var total_import_expense = 0

          for (let i = 0; i < importLocal.length; i++) {
            if (importLocal[i]['amount_type'] == 'AMOUNT') {
              const currency_value = importLocal[i]?.['currency_data']?.['current_value'] ? parseFloat(importLocal[i]?.['currency_data']?.['current_value']) : 1
              var quantity = importLocal[i]['quantity'] ? importLocal[i]['quantity'] : 1
              total_import_charge += (importLocal[i]['amount'] * quantity) / currency_value
              total_import_expense += (importLocal[i]['expense'] * quantity) / currency_value
            }
          }
          mpi = total_import_charge - total_import_expense
          setMarginPerImport(mpi)
          setTotalImportCharge(total_import_charge)
          setTotalImportExpense(total_import_expense)

          const updatedExportLocalExpenses = totalTranshipmentCharge?.total_transhipment_charge > 0 ? [...exportLocalCharges, transhipment_charge] : exportLocalCharges;

          // Add Existing Adhoc Export Charges and Miscellaneous Export Charges
          if (exportChargeRows?.[0]?.amount > 0) {
            if (miscellaneousChargeRows?.[0]?.amount > 0) {
              var miscellaneous_export_charges = miscellaneousChargeRows.filter(charge => charge.paid_by == "SHIPPER")
              var updated_export_local_charges = [...updatedExportLocalExpenses, ...exportChargeRows, ...miscellaneous_export_charges]
              setExportLocal(updated_export_local_charges)
            }
            else {
              var updated_export_local_charges = [...updatedExportLocalExpenses, ...exportChargeRows]
              setExportLocal(updated_export_local_charges)
            }
          }
          else {
            if (miscellaneousChargeRows?.[0]?.amount > 0) {
              var miscellaneous_export_charges = miscellaneousChargeRows.filter(charge => !(charge.paid_by == "SHIPPER"))
              var updated_export_local_charges = [...updatedExportLocalExpenses, ...miscellaneous_export_charges]
              setExportLocal(updated_export_local_charges)
            }
            else {
              setExportLocal(updatedExportLocalExpenses)
            }
          }

          var mpe = 0
          var total_export_charge = 0
          var total_export_expense = 0

          for (let i = 0; i < exportLocal.length; i++) {
            if (exportLocal[i]['amount_type'] == 'AMOUNT') {
              var currency_value = exportLocal[i]?.['currency_data']?.['current_value'] ? exportLocal[i]?.['currency_data']?.['current_value'] : 1
              var quantity = exportLocal[i]['quantity'] ? exportLocal[i]['quantity'] : 1
              total_export_charge += (exportLocal[i]['amount'] * quantity) / currency_value
              total_export_expense += (exportLocal[i]['expense'] * quantity) / currency_value
            }
          }
          mpe = total_export_charge - total_export_expense
          setMarginPerExport(mpe)
          setTotalExportCharge(total_export_charge)
          setTotalExportExpense(total_export_expense)

          setTarrifChargeDataPending(false)
        }
      } catch (err) {
        toast.error("Error in fetching tariff data! Try again.");
      }
    }
    else {
      try {
        setTarrifChargeDataPending(false)
        const container_type = cargoRows?.[0]?.container_size?.value
        const cargo_type = cargoRows?.[0]?.cargo_type

        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/tariffcharge/gettariffcharges?tariff__poa=' + selectedPoa?.value +
          '&tariff__pol=' + selectedPol?.value + '&tariff__pol_terminal=' + selectedPolTerminal?.value + '&tariff__pod_terminal=' + selectedPodTerminal?.value +
          '&tariff__pod=' + selectedPod?.value + '&tariff__fd=' + selectedFd?.value +
          '&charge_type=' + cargo_type + '&product=' + container_type + '&bl_type=' + selectedBlType?.value);

        if (response) {
          const importLocalCharges = response.data.filter(charge => charge.charge_category == "IMPORT_LOCAL").map(charge => ({
            product_data: charge?.product_data,
            product_name: charge?.product_data?.product_name,
            charge_type: charge?.charge_type,
            charge_name: charge?.charge_name,
            amount: charge?.amount,
            expense: charge?.expense,
            amount_type: charge?.amount_type || "",
            charge_basis: charge?.charge_basis || "",
            currency_data: charge?.currency_data,
            currency: charge?.currency_data?.symbol || "",
            quantity: 1,
            total: 0.0,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }));

          const exportLocalCharges = response.data.filter(charge => charge.charge_category == "EXPORT_LOCAL").map(charge => ({
            product_data: charge?.product_data,
            product_name: charge?.product_data?.product_name,
            charge_type: charge?.charge_type,
            charge_name: charge?.charge_name,
            amount: charge?.amount,
            expense: charge?.expense,
            amount_type: charge?.amount_type || "",
            charge_basis: charge?.charge_basis || "",
            currency_data: charge?.currency_data,
            currency: charge?.currency_data?.symbol || "",
            quantity: 1,
            total: 0.0,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }));

          const transhipment_charge = {
            product_data: { "product_name": "TSP" },
            product_name: "TSP",
            charge_type: "Amount",
            charge_name: "Transhipment Charge",
            amount: 0,
            expense: totalTranshipmentCharge?.total_transhipment_charge / parseInt(cargoRows[0]?.quantity),
            amount_type: "AMOUNT",
            charge_basis: "PER_BL",
            currency_data: { "current_value": 1, "symbol": "$" },
            currency: totalTranshipmentCharge?.currency,
            quantity: parseInt(cargoRows[0]?.quantity),
            total: totalTranshipmentCharge?.total_transhipment_charge,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }

          const freight_charge = {
            product_data: { "product_name": "Freight" },
            product_name: "Freight",
            charge_type: "Amount",
            charge_name: "Freight Charge",
            amount: freightCharge,
            expense: 0,
            amount_type: "AMOUNT",
            charge_basis: "PER_SHIPMENT",
            currency_data: { "current_value": 1, "symbol": "$" },
            currency: totalTranshipmentCharge?.currency,
            quantity: 1,
            total: freightCharge,
            requested: 0.0,
            approved: 0.0,
            approved_by: ""
          }

          exportLocalCharges.push(freight_charge)

          for (let i = 0; i < cargoRows.length; i++) {
            const slot = {
              product_data: { "product_name": cargoRows[i]?.container_size?.label },
              product_name: cargoRows[i]?.container_size?.label,
              charge_type: "Amount",
              charge_name: "Slot Charge (" + cargoRows[i]?.cargo_type + ")",
              amount: 0,
              expense: totalSlotRate / parseInt(cargoRows[i]?.quantity),
              amount_type: "AMOUNT",
              charge_basis: "PER_CONTAINER",
              currency_data: { "current_value": 1, "symbol": "$" },
              currency: "$",
              quantity: cargoRows[i]?.quantity,
              total: parseInt(totalSlotRate) / parseInt(cargoRows[i]?.quantity),
              requested: 0.0,
              approved: 0.0,
              approved_by: ""
            }
            exportLocalCharges.push(slot)
          }

          getIhcImportRoute(selectedPod, selectedFd)

          if (selectedFd?.type == "DRYPORT") {
            for (let i = 0; i < cargoRows.length; i++) {
              const slot = {
                product_data: { "product_name": cargoRows[i]?.container_size?.label },
                product_name: cargoRows[i]?.container_size?.label,
                charge_type: "Amount",
                charge_name: "IHC Charge (" + cargoRows[i]?.weight * cargoRows[i]?.quantity + " MT + " + cargoRows[i]?.tare_weight * cargoRows[i]?.quantity + " Tare Wt)",
                amount: (cargoRows[i]?.import_transport_charge + cargoRows[i]?.import_iso_tank_charge + cargoRows[i]?.import_bss_surcharge + cargoRows[i]?.import_dg_surcharge) / cargoRows[i]?.quantity,
                expense: (cargoRows[i]?.import_transport_charge_expense + cargoRows[i]?.import_iso_tank_charge_expense + cargoRows[i]?.import_bss_surcharge_expense + cargoRows[i]?.import_dg_surcharge_expense) / cargoRows[i]?.quantity,
                amount_type: "AMOUNT",
                charge_basis: "PER_CONTAINER",
                currency_data: { "current_value": parseFloat(icdImportCurrency?.currency_value), "symbol": icdImportCurrency?.symbol },
                currency: cargoRows[i]?.currency,
                quantity: cargoRows[i]?.quantity,
                total: cargoRows[i]?.import_transport_charge_expense,
                requested: 0.0,
                approved: 0.0,
                approved_by: ""
              }
              importLocalCharges.push(slot)
            }
          }
          

          setImportLocal(importLocalCharges)

          var mpi = 0
          var total_import_charge = 0
          var total_import_expense = 0
          for (let i = 0; i < importLocalCharges.length; i++) {
            if (importLocalCharges[i]['amount_type'] == 'AMOUNT') {
              var currency_value = importLocalCharges[i]?.['currency_data']?.['current_value'] ? parseFloat(importLocalCharges[i]?.['currency_data']?.['current_value']) : 1
              var quantity = importLocalCharges[i]['quantity'] ? importLocalCharges[i]['quantity'] : 1
              total_import_charge += (importLocalCharges[i]['amount'] * quantity) / currency_value
              total_import_expense += (importLocalCharges[i]['expense'] * quantity) / currency_value
            }
          }

          mpi = total_import_charge - total_import_expense
          setMarginPerImport(mpi)
          setTotalImportCharge(total_import_charge)
          setTotalImportExpense(total_import_expense)

          const updatedExportLocalExpenses = totalTranshipmentCharge?.total_transhipment_charge > 0 ? [...exportLocalCharges, transhipment_charge] : exportLocalCharges;
          setExportLocal(updatedExportLocalExpenses)

          var mpe = 0
          var total_export_charge = 0
          var total_export_expense = 0
          for (let i = 0; i < updatedExportLocalExpenses.length; i++) {
            if (updatedExportLocalExpenses[i]['amount_type'] == 'AMOUNT') {
              var quantity = updatedExportLocalExpenses[i]['quantity'] ? updatedExportLocalExpenses[i]['quantity'] : 1
              total_export_charge += (updatedExportLocalExpenses[i]['amount'] * quantity) / updatedExportLocalExpenses[i]?.['currency_data']?.['current_value']
              total_export_expense += (updatedExportLocalExpenses[i]['expense'] * quantity) / updatedExportLocalExpenses[i]?.['currency_data']?.['current_value']
            }
          }
          mpe = total_export_charge - total_export_expense
          setMarginPerExport(mpe)
          setTotalExportCharge(total_export_charge)
          setTotalExportExpense(total_export_expense)

          setTarrifChargeDataPending(false)
        }
      } catch (err) {
        console.log("err", err)
        toast.error("Error in fetching operator data! Try again.");
      }
    }
  }

  const getBookingLineItem = async (shipment_id) => {
    try {
      setBookingLineItemLoader(true)
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/bookinglineitem/getbookinglineitemsforupdate?shipment_id=' + shipment_id);

      if (response?.data) {
        const booking_line_items_array = response.data.map(item => ({
          id: item?.id,
          container_size: item?.container_type_data,
          quantity: item?.container_quantity,
          weight: item?.weight,
          tare_weight: item?.tare_weight,
          slot: item?.slot,
          export_iso_tank_charge: item?.export_iso_tank_charge,
          export_dg_surcharge: item?.export_dg_surcharge,
          export_bss_surcharge: item?.export_bss_surcharge,
          export_transport_charge: item?.export_transport_charge,
          export_iso_tank_charge_expense: item?.export_iso_tank_charge_expense,
          export_dg_surcharge_expense: item?.export_dg_surcharge_expense,
          export_bss_surcharge_expense: item?.export_bss_surcharge_expense,
          export_transport_charge_expense: item?.export_transport_charge_expense,
          import_iso_tank_charge: item?.import_iso_tank_charge,
          import_dg_surcharge: item?.import_dg_surcharge,
          import_bss_surcharge: item?.import_bss_surcharge,
          import_transport_charge: item?.import_transport_charge,
          import_iso_tank_charge_expense: item?.import_iso_tank_charge_expense,
          import_dg_surcharge_expense: item?.import_dg_surcharge_expense,
          import_bss_surcharge_expense: item?.import_bss_surcharge_expense,
          import_transport_charge_expense: item?.import_transport_charge_expense,
          cargo_type: item?.cargo_type,
          commodity: item?.commodity_data,
          currency: item?.currency_data
        }));

        setUpdateBookingLineItem(booking_line_items_array)
        setBookingLineItemLoader(false)
      }
    } catch (err) {
      toast.error("Error in fetching booking line items! Try again.");
    }
  }

  const getProduct = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/product');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.product_name, }));
        setProductList(data)
      }
    } catch (err) {
      toast.error("Error in fetching product data! Try again.");
    }
  }

  const getCharge = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/charge');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setChargeList(data)
      }
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/currency');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.symbol + " (" + item.name + ")", current_value: item.current_value, symbol: item.symbol }));
        setCurrencyList(data)
        const current_usd_rate = response.data.find(currency => currency.value === "us_dollar");
        setUSDRate(current_usd_rate?.current_value)
      }
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  }


  const getVesselScheduleTranshipmentPort = async () => {
    if (selectedPol?.value != "" | selectedPol?.value != undefined) {
      if (selectedPod?.value != "" | selectedPod?.value != undefined) {
        try {
          const transhipment_port_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/gettranshipmentport?poa_port=' + selectedPoa?.value + '&pick_port=' + selectedPol?.value + '&next_port=' + selectedPod?.value)
          console.log("transhipment_port_response", transhipment_port_response)
          if (transhipment_port_response) {
            const vessel_route_array = []
            Object.values(transhipment_port_response?.data?.routes).map(item => vessel_route_array.push(item.ports));
            setVesselTranshipmentRoute(vessel_route_array)
            setPortStorageFreeDays(transhipment_port_response?.data?.terminal_storage_free_days)
            setTranshipmentStorageFreeDays(transhipment_port_response?.data?.transhipment_storage_free_days)
            setTranshipmentPortTerminal(transhipment_port_response?.data?.transhipment_dict)
            setSelectedPodTerminal(transhipment_port_response?.data?.pod_terminal)
          }
        } catch (err) {
          toast.error("Error in fetching transhipment data! Try again.", err);
        }
      }
    }
  }

  const getUpdateVesselScheduleTranshipmentPort = async (poa, from, to) => {
    if (from != "" | from != undefined) {
      if (to != "" | to != undefined) {
        try {
          const transhipment_port_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/gettranshipmentport?poa_port=' + poa + '&pick_port=' + from + '&next_port=' + to)
          console.log("UPDATE ---------- transhipment_port_response", transhipment_port_response)
          if (transhipment_port_response) {
            const vessel_route_array = []
            Object.values(transhipment_port_response?.data?.routes).map(item => vessel_route_array.push(item.ports));
            setVesselTranshipmentRoute(vessel_route_array)

            setUpdateSelectedPodTerminal(transhipment_port_response?.data?.pod_terminal?.value)
            setTranshipmentPortTerminal(transhipment_port_response?.data?.transhipment_dict)
            setUpdateTranshipmentTerminalFreeDays(transhipment_port_response?.data?.transhipment_storage_free_days)
          }
        } catch (err) {
          toast.error("Error in fetching transhipment data! Try again.", err);
        }
      }
    }
  }

  const getTrashipmentPort = async (from, to, vessel_schedule) => {
    if (from?.value != "" | from?.value != undefined) {
      if (to?.value != "" | to?.value != undefined) {
        if (vessel_schedule?.value != undefined) {
          const vessel_schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/' + vessel_schedule.value)
          const vessel = vessel_schedule_response.data?.vessel
          try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment?from_port=' + from.value + '&to_port=' + to.value + '&vessel=' + vessel);
            if (response) {
              const data = response.data.map(item => ({ value: item.id, label: item.via_port_data.name, }));
              setTranshipmentList(data)
            }
          } catch (err) {
            toast.error("Error in fetching transhipment data! Try again.");
          }
        }
      }
    }
  }

  const getUpdateTrashipmentPort = async (from, to, vessel_schedule) => {
    if (from != "" | from != undefined) {
      if (to != "" | to != undefined) {
        if (vessel_schedule != undefined) {
          const vessel_schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/' + vessel_schedule)
          const vessel = vessel_schedule_response.data?.vessel
          try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment?from_port=' + from + '&to_port=' + to + '&vessel=' + vessel);
            if (response) {
              const data = response.data.map(item => ({ value: item.id, label: item.via_port_data.name, }));
              setTranshipmentList(data)
            }
          } catch (err) {
            toast.error("Error in fetching transhipment data! Try again.");
          }
        }
      }
    }
  }

  const getTerminalStorageFreeDays = async (e) => {
    const schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/getterminalstoragefreedays/?schedule=' + e?.value + "&poa=" + selectedPoa?.value + "&pod=" + selectedPod?.value);
    console.log("schedule_response", schedule_response)
  }

  const getSlotAgreementRate = async (slot_agreement) => {
    const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotrate?slot_agreement=' + slot_agreement);
    setSlotRateList(response.data)
    console.log("response.data", response)

    for (let i = 0; i < updateBookingLineItem.length; i++) {
      const container_type = updateBookingLineItem[i]?.container_size?.id
      const cargo_type = updateBookingLineItem[i]?.cargo_type

      const matching_agreement = response.data.find(item => item.container_type === container_type && item.cargo_type === cargo_type);

      updateBookingLineItem[i].slot = matching_agreement?.rate
      updateBookingLineItem[i].currency = matching_agreement?.currency_data?.symbol
    }

    addRow()
    setUpdateBookingLineItem(updateBookingLineItem)
  }

  const getSlotRate = async (index, vessel_index, e) => {
    const container_type = cargoRows[index]['container_size']?.['label']
    const cargo_type = cargoRows[index]['cargo_type']
    const operator = e?.value
    vesselPlanningRows[0][index][vessel_index]["operator"] = e

    console.log("container_type", container_type)
    console.log("cargo_type", cargo_type)
    console.log("e", e)


    if (container_type != "") {
      if (cargo_type != "") {
        try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotrate?slot_agreement__operator=' + operator);
          const slot_rate_list = response.data

          const slot_rate = slot_rate_list.filter(slot => slot.container_type_data?.product_name == container_type && slot.cargo_type == cargo_type);
          
          vesselPlanningRows[0][index][vessel_index]["slot"] = parseFloat(slot_rate?.[0]?.rate)
          setVesselPlanningRows(vesselPlanningRows)
          refreshRows()
        } catch (err) {
          toast.error("Error in fetching slot rate data! Try again.");
        }
      }
    }
  }

  const getUpdateSlotRate = async (index, vessel_index, e) => {
    const container_type = updateBookingLineItem[index]['container_size']?.['product_name']
    const cargo_type = updateBookingLineItem[index]['cargo_type']
    const operator = e?.value
    vesselPlanningRows[0][index][vessel_index]["operator"] = e

    console.log("container_type", container_type)
    console.log("cargo_type", cargo_type)
    console.log("e", e)


    if (container_type != "") {
      if (cargo_type != "") {
        try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotrate?slot_agreement__operator=' + operator);
          const slot_rate_list = response.data

          const slot_rate = slot_rate_list.filter(slot => slot.container_type_data?.product_name == container_type && slot.cargo_type == cargo_type);
          
          vesselPlanningRows[0][index][vessel_index]["slot"] = parseFloat(slot_rate?.[0]?.rate)
          setVesselPlanningRows(vesselPlanningRows)
          refreshRows()
        } catch (err) {
          toast.error("Error in fetching slot rate data! Try again.");
        }
      }
    }
  }


  // ============================================= IHC Export =============================================

  const getIhcExportRoute = async (icd, pol) => {
    const icd_port = icd?.value
    const icd_port_type = icd?.type
    const pol_port = pol?.value

    if (icd_port != undefined && icd_port_type == "DRYPORT") {
      if (pol_port != undefined) {
        try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulageroute?icd=' + icd_port + '&via_port=' + pol_port);
          const id = response.data?.[0]?.id
          setIhcExportRoute(id)

          const icd_origin_currency = response.data?.[0]?.icd_data?.currency_data
          const icd_export_currency = { "country": icd_origin_currency?.country_data?.long_name, "currency_value": icd_origin_currency?.current_value, "symbol": icd_origin_currency?.symbol }
          setIcdExportCurrency(icd_export_currency)
        }
        catch (err) {
          toast.error("Error in fetching IHC Charges data! Try again.");
        }
      }
    }
  }

  const getIhcExportCharge = async (row, index) => {
    const container_type = row['container_size']?.['value']
    const container_carrier_type = row['container_size']?.['type']
    const cargo_type = row['cargo_type']
    const quantity = row['quantity']
    const weight = row['weight']

    if (container_type != "") {
      if (cargo_type != "") {
        if (weight != 0) {
          try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulagecharge?route=' + ihcExportRoute + '&product=' + container_type);
            const ihc_charge_data = response.data

            const ihc_charge_ranges = ihc_charge_data.filter(charge => charge.min_weight <= (parseFloat(weight) + parseFloat(charge.tare_weight))
              && charge.max_weight >= (parseFloat(weight) + parseFloat(charge.tare_weight)));
            const ihc_charge = ihc_charge_ranges[0]?.charge
            const tare_weight = ihc_charge_ranges[0]?.tare_weight
            const export_iso_tank_charge = container_carrier_type == "TANK" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.2 : 0
            const export_dg_surcharge = cargo_type == "HAZARDOUS" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.25 : 0
            const export_bss_surcharge = parseFloat(ihc_charge) * parseFloat(quantity) * 0.10

            const ihc_expense = ihc_charge_ranges[0]?.expense
            const export_iso_tank_charge_expense = container_carrier_type == "TANK" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.2 : 0
            const export_dg_surcharge_expense = cargo_type == "HAZARDOUS" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.25 : 0
            const export_bss_surcharge_expense = parseFloat(ihc_expense) * parseFloat(quantity) * 0.10

            cargoRows[index].tare_weight = tare_weight
            cargoRows[index].export_iso_tank_charge = export_iso_tank_charge
            cargoRows[index].export_iso_tank_charge_expense = export_iso_tank_charge_expense

            cargoRows[index].export_dg_surcharge = export_dg_surcharge
            cargoRows[index].export_dg_surcharge_expense = export_dg_surcharge_expense

            cargoRows[index].export_bss_surcharge = export_bss_surcharge
            cargoRows[index].export_bss_surcharge_expense = export_bss_surcharge_expense

            cargoRows[index].export_transport_charge = parseFloat(ihc_charge) * parseFloat(quantity)
            cargoRows[index].export_transport_charge_expense = parseFloat(ihc_expense) * parseFloat(quantity)

            setCargoRows(cargoRows)
            refreshRows()
          } catch (err) {
            toast.error("Error in fetching IHC Export Charges data! Try again.");
          }
        }
      }
    }
  }

  const getIhcExportChargeUpdate = async (row) => {
    console.log("ihcExportRoute", row[0]['container_size']?.['id'])
    for (let index = 0; index < row.length; index++) {
      const container_type = row[index]['container_size']?.['id']
      const container_carrier_type = row[index]['container_size']?.['type']
      const cargo_type = row[index]['cargo_type']
      const quantity = row[index]['quantity']
      const weight = row[index]['weight']

      if (container_type != "") {
        if (cargo_type != "") {
          if (weight != 0) {
            try {
              const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulagecharge?route=' + ihcExportRoute + '&product=' + container_type);
              const ihc_charge_data = response.data

              const ihc_charge_ranges = ihc_charge_data.filter(charge => charge.min_weight <= (parseFloat(weight) + parseFloat(charge.tare_weight))
                && charge.max_weight >= (parseFloat(weight) + parseFloat(charge.tare_weight)));
              const ihc_charge = ihc_charge_ranges[0]?.charge
              const tare_weight = ihc_charge_ranges[0]?.tare_weight
              const export_iso_tank_charge = container_carrier_type == "TANK" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.2 : 0
              const export_dg_surcharge = cargo_type == "HAZARDOUS" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.25 : 0
              const export_bss_surcharge = parseFloat(ihc_charge) * parseFloat(quantity) * 0.10

              const ihc_expense = ihc_charge_ranges[0]?.expense
              const export_iso_tank_charge_expense = container_carrier_type == "TANK" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.2 : 0
              const export_dg_surcharge_expense = cargo_type == "HAZARDOUS" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.25 : 0
              const export_bss_surcharge_expense = parseFloat(ihc_expense) * parseFloat(quantity) * 0.10

              updateBookingLineItem[index].tare_weight = tare_weight
              updateBookingLineItem[index].export_iso_tank_charge = export_iso_tank_charge
              updateBookingLineItem[index].export_iso_tank_charge_expense = export_iso_tank_charge_expense

              updateBookingLineItem[index].export_dg_surcharge = export_dg_surcharge
              updateBookingLineItem[index].export_dg_surcharge_expense = export_dg_surcharge_expense

              updateBookingLineItem[index].export_bss_surcharge = export_bss_surcharge
              updateBookingLineItem[index].export_bss_surcharge_expense = export_bss_surcharge_expense

              updateBookingLineItem[index].export_transport_charge = parseFloat(ihc_charge) * parseFloat(quantity)
              updateBookingLineItem[index].export_transport_charge_expense = parseFloat(ihc_expense) * parseFloat(quantity)

              setUpdateBookingLineItem(updateBookingLineItem)
              // addRow()
            } catch (err) {
              toast.error("Error in fetching IHC Export Charges data! Try again.");
            }
          }
        }
      }
    }
  }

  // ============================================= IHC Import =============================================

  const getIhcImportRoute = async (pod, icd) => {
    const pod_port = shipmentExist ? pod?.id : pod?.value
    const icd_port = shipmentExist ? icd?.id : icd?.value
    const icd_port_type = shipmentExist ? icd?.type : icd?.type

    if (icd_port != undefined && icd_port_type == "DRYPORT") {
      if (pod_port != undefined) {
        try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulageroute?icd=' + icd_port + '&via_port=' + pod_port);
          const id = response.data?.[0]?.id
          setIhcImportRoute(id)

          const icd_origin_currency = response.data?.[0]?.icd_data?.currency_data
          console.log("icd_origin_currency", icd_origin_currency)
          const icd_import_currency = { "country": icd_origin_currency?.country_data?.long_name, "currency_value": icd_origin_currency?.current_value, "symbol": icd_origin_currency?.symbol }
          console.log("icd_import_currency", icd_import_currency)
          setIcdImportCurrency(icd_import_currency)
        }
        catch (err) {
          toast.error("Error in fetching IHC Charges data! Try again.");
        }
      }
    }
  }

  const getIhcImportCharge = async (row, index) => {
    const container_type = row['container_size']?.['value']
    const container_carrier_type = row['container_size']?.['type']
    const cargo_type = row['cargo_type']
    const quantity = row['quantity']
    const weight = row['weight']

    if (container_type != "") {
      if (cargo_type != "") {
        if (weight != 0) {
          try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulagecharge?route=' + ihcImportRoute + '&product=' + container_type);
            const ihc_charge_data = response.data

            const ihc_charge_ranges = ihc_charge_data.filter(charge => charge.min_weight <= (parseFloat(weight) + parseFloat(charge.tare_weight))
              && charge.max_weight >= (parseFloat(weight) + parseFloat(charge.tare_weight)));
            const ihc_charge = ihc_charge_ranges[0]?.charge
            const tare_weight = ihc_charge_ranges[0]?.tare_weight
            const import_iso_tank_charge = container_carrier_type == "TANK" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.2 : 0
            const import_dg_surcharge = cargo_type == "HAZARDOUS" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.25 : 0
            const import_bss_surcharge = parseFloat(ihc_charge) * parseFloat(quantity) * 0.10

            const ihc_expense = ihc_charge_ranges[0]?.expense
            const import_iso_tank_charge_expense = container_carrier_type == "TANK" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.2 : 0
            const import_dg_surcharge_expense = cargo_type == "HAZARDOUS" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.25 : 0
            const import_bss_surcharge_expense = parseFloat(ihc_expense) * parseFloat(quantity) * 0.10

            cargoRows[index].tare_weight = tare_weight
            cargoRows[index].import_iso_tank_charge = import_iso_tank_charge
            cargoRows[index].import_iso_tank_charge_expense = import_iso_tank_charge_expense

            cargoRows[index].import_dg_surcharge = import_dg_surcharge
            cargoRows[index].import_dg_surcharge_expense = import_dg_surcharge_expense

            cargoRows[index].import_bss_surcharge = import_bss_surcharge
            cargoRows[index].import_bss_surcharge_expense = import_bss_surcharge_expense

            cargoRows[index].import_transport_charge = parseFloat(ihc_charge) * parseFloat(quantity)
            cargoRows[index].import_transport_charge_expense = parseFloat(ihc_expense) * parseFloat(quantity)

            setCargoRows(cargoRows)
            refreshRows()
          } catch (err) {
            toast.error("Error in fetching IHC Import Charges data! Try again.");
          }
        }
      }
    }
  }

  const getIhcImportChargeUpdate = async (row) => {
    for (let index = 0; index < row.length; index++) {
      const container_type = row[index]['container_size']?.['id']
      const container_carrier_type = row[index]['container_size']?.['type']
      const cargo_type = row[index]['cargo_type']
      const quantity = row[index]['quantity']
      const weight = row[index]['weight']

      if (container_type != "") {
        if (cargo_type != "") {
          if (weight != 0) {
            try {
              const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulagecharge?route=' + ihcImportRoute + '&product=' + container_type);
              const ihc_charge_data = response.data

              const ihc_charge_ranges = ihc_charge_data.filter(charge => charge.min_weight <= (parseFloat(weight) + parseFloat(charge.tare_weight))
                && charge.max_weight >= (parseFloat(weight) + parseFloat(charge.tare_weight)));
              const ihc_charge = ihc_charge_ranges[0]?.charge
              const tare_weight = ihc_charge_ranges[0]?.tare_weight
              const import_iso_tank_charge = container_carrier_type == "TANK" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.2 : 0
              const import_dg_surcharge = cargo_type == "HAZARDOUS" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.25 : 0
              const import_bss_surcharge = parseFloat(ihc_charge) * parseFloat(quantity) * 0.10

              const ihc_expense = ihc_charge_ranges[0]?.expense
              const import_iso_tank_charge_expense = container_carrier_type == "TANK" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.2 : 0
              const import_dg_surcharge_expense = cargo_type == "HAZARDOUS" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.25 : 0
              const import_bss_surcharge_expense = parseFloat(ihc_expense) * parseFloat(quantity) * 0.10

              updateBookingLineItem[index].tare_weight = tare_weight
              updateBookingLineItem[index].import_iso_tank_charge = import_iso_tank_charge
              updateBookingLineItem[index].import_iso_tank_charge_expense = import_iso_tank_charge_expense

              updateBookingLineItem[index].import_dg_surcharge = import_dg_surcharge
              updateBookingLineItem[index].import_dg_surcharge_expense = import_dg_surcharge_expense

              updateBookingLineItem[index].import_bss_surcharge = import_bss_surcharge
              updateBookingLineItem[index].import_bss_surcharge_expense = import_bss_surcharge_expense

              updateBookingLineItem[index].import_transport_charge = parseFloat(ihc_charge) * parseFloat(quantity)
              updateBookingLineItem[index].import_transport_charge_expense = parseFloat(ihc_expense) * parseFloat(quantity)

              setUpdateBookingLineItem(updateBookingLineItem)
            } catch (err) {
              toast.error("Error in fetching IHC Import Charges data! Try again.");
            }
          }
        }
      }
    }
  }

  const calculateMpi = (chargesData) => {
    var mpi = 0
    var total_import_charge = 0
    var total_import_expense = 0
    for (let i = 0; i < chargesData.length; i++) {
      if (chargesData[i]['amount_type'] == 'AMOUNT') {
        var currency_value = chargesData[i]?.['currency_data']?.['current_value'] ? parseFloat(chargesData[i]?.['currency_data']?.['current_value']) : 1
        total_import_charge += parseFloat(chargesData[i]['amount']) / currency_value
        total_import_expense += parseFloat(chargesData[i]['expense']) / currency_value
      }
    }
    mpi = total_import_charge - total_import_expense
    setMarginPerImport(mpi)
    setTotalImportCharge(total_import_charge)
    setTotalImportExpense(total_import_expense)
  }

  const calculateMpe = (chargesData) => {
    var mpe = 0
    var total_export_charge = 0
    var total_export_expense = 0
    for (let i = 0; i < chargesData.length; i++) {
      if (chargesData[i]['amount_type'] == 'AMOUNT') {
        if (chargesData[i]['charge_name'].includes('Transhipment Charge') || chargesData[i]['charge_name'].includes('Slot Charge')) {
          total_export_expense += parseFloat(chargesData[i]['expense'])
          total_export_charge += parseFloat(chargesData[i]['amount'])
        }
        else {
          total_export_expense += parseFloat(chargesData[i]['expense']) / parseFloat(chargesData[i]?.['currency_data']?.['current_value'])
          total_export_charge += parseFloat(chargesData[i]['amount']) / parseFloat(chargesData[i]?.['currency_data']?.['current_value'])
        }
      }
    }
    console.log("total_export_charge", total_export_charge)
    console.log("total_export_expense", total_export_expense)
    mpe = total_export_charge - total_export_expense
    setMarginPerExport(mpe)
    setTotalExportCharge(total_export_charge)
    setTotalExportExpense(total_export_expense)
  }


  // ----------------------------------------- Adhoc Import Charges -----------------------------------------

  const saveAdhocImportCharges = async () => {
    setShowAddImportModal(false)
    const combinedCharges = [...importLocal, ...importChargeRows];
    calculateMpi(combinedCharges)
    setImportLocal(combinedCharges)
    clearImportChargeRow()

    if (newShipmentImportExtraCharge) {
      const charge_data = {
        name: importChargeRows[0]?.charge_name,
        charge: parseFloat(importChargeRows[0]?.amount),
        charge_type: importChargeRows[0]?.amount_type,
        import_export_type: importChargeRows[0]?.charge_type,
        currency: importChargeRows[0]?.currency_data?.value,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentextracharge/', charge_data, { headers: { "Content-Type": "application/json" } });
      if (response.status === 201) {
        toast.success("New additional import charge added")
      }
      else {
        toast.error("Error adding new charge")
      }
    }

    getShipmentExtraCharge()
    setNewShipmentImportExtraCharge(false)
  }

  const updateImportCharge = (row) => {
    setShowUpdateImportModal(true)
    setUpdateImportChargeRows({
      id: row.id,
      product_data: "Adhoc",
      product_name: "Adhoc",
      charge_data: row.charge_data,
      charge_name: row.charge_name,
      amount: row.amount,
      expense: row.expense,
      amount_type: row.amount_type,
      charge_type: "IMPORT",
      charge_basis: row.charge_basis,
      currency_data: row.currency_data,
      currency: row.currency,
      quantity: row.quantity,
      total: row.total,
      requested: row.requested,
      approved: row.approved,
      approved_by: row.approved_by
    })
  }

  const updateAdhocImportCharges = async () => {
    const update_id = updateImportChargeRows?.id;
    const new_data = updateImportChargeRows;

    const new_import_local_charges = importLocal.map(item =>
      item.id === update_id ? new_data : item
    );

    setImportLocal(new_import_local_charges);
    setShowUpdateImportModal(false);
    calculateMpi(new_import_local_charges)
  }

  const removeImportChargeExpense = (row) => {
    const product_name = row.product_name
    const charge_name = row.charge_name
    const filtered_data = importLocal.filter(charge => !(charge.product_name === product_name && charge.charge_name === charge_name))
    calculateMpi(filtered_data)
    setImportLocal(filtered_data)
  }

  // ----------------------------------------- Adhoc Export Charges -----------------------------------------

  const saveAdhocExportCharges = async () => {
    setShowAddExportModal(false)
    const combinedCharges = [...exportLocal, ...exportChargeRows];
    calculateMpe(combinedCharges)
    setExportLocal(combinedCharges)
    clearExportChargeRow()

    if (newShipmentExportExtraCharge) {
      const charge_data = {
        name: exportChargeRows[0]?.charge_name,
        charge: parseFloat(exportChargeRows[0]?.amount),
        charge_type: exportChargeRows[0]?.amount_type,
        import_export_type: exportChargeRows[0]?.charge_type,
        currency: exportChargeRows[0]?.currency_data?.value,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentextracharge/', charge_data, { headers: { "Content-Type": "application/json" } });
      if (response.status === 201) {
        toast.success("New additional export charge added")
      }
      else {
        toast.error("Error adding new charge")
      }
    }

    getShipmentExtraCharge()
    setNewShipmentExportExtraCharge(false)
  }

  const updateExportCharge = (row) => {
    setShowUpdateExportModal(true)
    setUpdateExportChargeRows({
      id: row.id,
      product_data: "Adhoc",
      product_name: "Adhoc",
      charge_data: row.charge_data,
      charge_name: row.charge_name,
      amount: row.amount,
      expense: row.expense,
      amount_type: row.amount_type,
      charge_type: "EXPORT",
      charge_basis: row.charge_basis,
      currency_data: row.currency_data,
      currency: row.currency,
      quantity: row.quantity,
      total: row.total,
      requested: row.requested,
      approved: row.approved,
      approved_by: row.approved_by
    })
  }

  const updateAdhocExportCharges = async () => {
    const update_id = updateExportChargeRows?.id;
    const new_data = updateExportChargeRows;

    const new_export_local_charges = exportLocal.map(item =>
      item.id === update_id ? new_data : item
    );

    setExportLocal(new_export_local_charges);
    setShowUpdateExportModal(false);
    calculateMpe(new_export_local_charges)
  }

  const removeExportChargeExpense = (row) => {
    const product_name = row.product_name
    const charge_name = row.charge_name
    const filtered_data = exportLocal.filter(charge => !(charge.product_name === product_name && charge.charge_name === charge_name))
    calculateMpe(filtered_data)
    setExportLocal(filtered_data)
  }

  const localimportchargescolumns = [
    {
      name: 'Product',
      width: '90px',
      selector: row => <span className={`${row.product_data == "Adhoc" ? "bg-info px-2 rounded" : ""}`}>{row.product_data == "Adhoc" ? row.product_data : row.product_data?.product_name}</span>,
      sortable: true,
    },
    {
      name: 'Charge',
      width: '210px',
      selector: row => <p className={`${row.charge_type == "HAZARDOUS" ? "bg-warning py-1 px-2 mb-0 rounded" : "mb-0"}`}>
        {row.charge_type == "HAZARDOUS" ? <i className="fa fa-exclamation-triangle mr-2"></i> : ""}
        {row.charge_name}
      </p>,
      sortable: true,
    },
    {
      name: 'Amount',
      width: '95px',
      selector: row => row.amount_type == 'PERCENTAGE' ? row.amount + " %" : row.amount + " x " + row.quantity,
      sortable: true,
    },
    {
      name: 'Total',
      width: '95px',
      selector: row =>
        <>
          <span>{row.product_data == "Adhoc" | row.product_name == "Miscellaneous" ? row.currency_data?.label[0] : row.currency_data?.symbol}</span>
          <span> {row.amount_type == 'PERCENTAGE' ? row.amount + " %" : row.quantity * row.amount}</span>
        </>,
      sortable: true,
    },
    {
      name: 'Negotiation',
      width: '140px',
      selector: row =>
        <>
          <span>Requested: {row.product_data == "Adhoc" ? row.currency_data?.label[0] : row.currency_data?.symbol} {row.requested == 0 ? row.amount : row.requested}
          </span><br></br>
          <span>Approved: {row.product_data == "Adhoc" ? row.currency_data?.label[0] : row.currency_data?.symbol} {row.approved == 0 ? row.amount : row.approved}
          </span>
        </>,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => updateImportCharge(row)}
                disabled={row.product_data == "Adhoc" ? false : true}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Remove" onClick={() => removeImportChargeExpense(row)}
                disabled={row.product_data == "Adhoc" ? false : true}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];


  const localexportchargescolumns = [
    {
      name: 'Product',
      width: '90px',
      selector: row => <span className={`${row.product_data == "Adhoc" ? "bg-info px-2 rounded" : ""}`}>{row.product_data == "Adhoc" ? row.product_data : row.product_data?.product_name}</span>,
      sortable: true,
    },
    {
      name: 'Charge',
      width: '210px',
      selector: row => <p className={`${row.charge_type == "HAZARDOUS" ? "bg-warning py-1 px-2 mb-0 rounded" : "mb-0"}`}>
        {row.charge_type == "HAZARDOUS" ? <i className="fa fa-exclamation-triangle mr-2"></i> : ""}
        {row.charge_name}
      </p>,
      sortable: true,
    },
    {
      name: 'Amount',
      width: '95px',
      selector: row => row.amount_type == 'PERCENTAGE' ? row.amount + " %" : row.amount + " x " + row.quantity,
      sortable: true,
    },
    {
      name: 'Total',
      width: '95px',
      selector: row =>
        <>
          <span>{row.product_data == "Adhoc" | row.product_name == "Miscellaneous" ? row.currency_data?.label[0] : row.currency_data?.symbol}</span>
          <span> {row.amount_type == 'PERCENTAGE' ? row.amount + " %" : row.quantity * row.amount}</span>
        </>,
      sortable: true,
    },
    {
      name: 'Negotiation',
      width: '140px',
      selector: row =>
        <>
          <span>Requested: {row.product_data == "Adhoc" ? row.currency_data?.label[0] : row.currency_data?.symbol} {row.requested == 0 ? row.amount : row.requested}
          </span><br></br>
          <span>Approved: {row.product_data == "Adhoc" ? row.currency_data?.label[0] : row.currency_data?.symbol} {row.approved == 0 ? row.amount : row.approved}
          </span>
        </>,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => updateExportCharge(row)}
                disabled={row.product_data == "Adhoc" ? false : true}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Remove" onClick={() => removeExportChargeExpense(row)}
                disabled={row.product_data == "Adhoc" ? false : true}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];


  const localexpensescolumns = [
    {
      name: 'Product',
      selector: row => <span className={`${row.product_data == "Adhoc" ? "bg-info px-2 rounded" : ""}`}>{row.product_data == "Adhoc" ? row.product_data : row.product_data?.product_name}</span>,
      sortable: true,
    },
    {
      name: 'Charge',
      width: '250px',
      selector: row => <p className={`${row.charge_type == "HAZARDOUS" ? "bg-warning py-1 px-2 mb-0 rounded" : "mb-0"}`}>
        {row.charge_type == "HAZARDOUS" ? <i className="fa fa-exclamation-triangle mr-2"></i> : ""}
        {row.charge_name}
      </p>,
      sortable: true,
    },
    {
      name: 'Amount',
      width: '95px',
      selector: row => row.amount_type == 'PERCENTAGE' ? row.expense + " %" : row.expense + " x " + row.quantity,
      sortable: true,
    },
    {
      name: 'Total',
      width: '95px',
      selector: row =>
        <>
          <span>{row.product_data == "Adhoc" ? row.currency?.label[0] : row.currency_data?.symbol}</span>
          <span> {row.amount_type == 'PERCENTAGE' ? row.expense + " %" : row.quantity * row.expense}</span>
        </>,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => setShowAddImportModal(true)}
                disabled={row.product_data == "Adhoc" ? false : true}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Remove" onClick={() => removeImportChargeExpense(row)}
                disabled={row.product_data == "Adhoc" ? false : true}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];

  const transhipmentchargescolumns = [
    {
      name: 'Charge',
      width: '300px',
      selector: row => row.charge_name,
      sortable: true,
    },
    {
      name: 'Charge',
      selector: row => row.currency_data?.symbol + " " + row.charge,
      sortable: true,
    },
    {
      name: 'Charge Basis',
      selector: row => row.charge_basis?.replaceAll("_"," "),
      sortable: true,
    },
    {
      name: 'Container Size',
      selector: row => row.container_type_data?.product_name,
    },
    {
      name: 'Total Container',
      selector: row => shipmentExist? updateBookingLineItem?.[0]?.quantity: 1,
      center: true,
      sortable: true,
    },
    {
      name: 'Total Charge',
      selector: row => row.currency_data?.symbol + " " + parseFloat(row.charge) * 1,
      right: true,
      sortable: true,
    },
  ];

  // ---------------------- Route Form ---------------------------
  const handleRouteFormClick = () => {
    const rect = triggerRouteFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });

    setRouteInputDisabled(true);
    setRouteFormOpen(true);
  };

  useEffect(() => {
    function handleRouteFormOutsideClick(e) {
      if (
        tooltipRouteFormRef.current &&
        !tooltipRouteFormRef.current.contains(e.target) &&
        !triggerRouteFormRef.current.contains(e.target)
      ) {
        setRouteInputDisabled(false);
        setRouteFormOpen(false);
        setShowRouteError(true);
      }
    }
    document.addEventListener("mousedown", handleRouteFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleRouteFormOutsideClick);
  }, []);

  // ---------------------- Cargo Form ---------------------------
  const handleCargoFormClick = () => {
    const rect = triggerCargoFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });

    setCargoInputDisabled(true);
    setCargoFormOpen(true);
    console.log("cargoRows", cargoRows)
    setCargoRows(cargoRows);
  };

  useEffect(() => {
    function handleCargoFormOutsideClick(e) {
      if (
        tooltipCargoFormRef.current &&
        !tooltipCargoFormRef.current.contains(e.target) &&
        !triggerCargoFormRef.current.contains(e.target)
      ) {
        setCargoInputDisabled(false);
        setCargoFormOpen(false);
      }
    }
    document.addEventListener("mousedown", handleCargoFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleCargoFormOutsideClick);
  }, []);

  // ---------------------- Stakeholder Form ---------------------------
  const handleStakeholderFormClick = () => {
    const rect = triggerStakeholderFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });

    setStakeholderInputDisabled(true);
    setStakeholderFormOpen(true);
  };

  useEffect(() => {
    function handleStakeholderFormOutsideClick(e) {
      if (
        tooltipStakeholderFormRef.current &&
        !tooltipStakeholderFormRef.current.contains(e.target) &&
        !triggerStakeholderFormRef.current.contains(e.target)
      ) {

        setStakeholderInputDisabled(false);
        setStakeholderFormOpen(false);
        setShowStakeholderError(true);
      }
    }
    document.addEventListener("mousedown", handleStakeholderFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleStakeholderFormOutsideClick);
  }, []);

  // ---------------------- Charges Form ---------------------------
  const handleChargesFormClick = () => {
    const rect = triggerChargesFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });

    setChargesInputDisabled(true);
    setChargesFormOpen(true);
  };

  useEffect(() => {
    function handleChargesFormOutsideClick(e) {
      if (
        tooltipChargesFormRef.current &&
        !tooltipChargesFormRef.current.contains(e.target) &&
        !triggerChargesFormRef.current.contains(e.target)
      ) {

        setChargesInputDisabled(false);
        setChargesFormOpen(false);
        setShowBlError(true);
      }
    }
    document.addEventListener("mousedown", handleChargesFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleChargesFormOutsideClick);
  }, []);

  // ---------------------- Logistic Form ---------------------------
  const handleLogisticFormClick = () => {
    const rect = triggerLogisticFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });

    setLogisticInputDisabled(true);
    setLogisticFormOpen(true);
  };

  useEffect(() => {
    function handleLogisticFormOutsideClick(e) {
      if (
        tooltipLogisticFormRef.current &&
        !tooltipLogisticFormRef.current.contains(e.target) &&
        !triggerLogisticFormRef.current.contains(e.target)
      ) {
        setLogisticInputDisabled(false);
        setLogisticFormOpen(false);
        setShowLogisticError(true);
      }
    }
    document.addEventListener("mousedown", handleLogisticFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleLogisticFormOutsideClick);
  }, []);

  // ---------------------- Handling Form ---------------------------
  const handleHandlingFormClick = () => {
    const rect = triggerHandlingFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });

    setHandlingInputDisabled(true);
    setHandlingFormOpen(true);
    poaDetentionFreeDays == "" ? setPoaDetentionFreeDaysError(true) : setPoaDetentionFreeDaysError(false)
    podDetentionFreeDays == "" ? setPodDetentionFreeDaysError(true) : setPodDetentionFreeDaysError(false)
    poaTerminalStorageFreeDays == "" ? setPoaTerminalStorageFreeDaysError(true) : setPoaTerminalStorageFreeDaysError(false)
    podTerminalStorageFreeDays == "" ? setPodTerminalStorageFreeDaysError(true) : setPodTerminalStorageFreeDaysError(false)
  };

  useEffect(() => {
    function handleHandlingFormOutsideClick(e) {
      if (
        tooltipHandlingFormRef.current &&
        !tooltipHandlingFormRef.current.contains(e.target) &&
        !triggerHandlingFormRef.current.contains(e.target)
      ) {
        setHandlingInputDisabled(false);
        setHandlingFormOpen(false);
      }
    }
    document.addEventListener("mousedown", handleHandlingFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleHandlingFormOutsideClick);
  }, []);

  useEffect(() => {
    getLoggenInUser()
    getPort()
    getPrincipal()
    getAgent()
    getOperator()
    getUser()
    getCustomer()
    getContainerSize()
    getCommodity()
    getProduct()
    getCharge()
    getCurrency()
    getShipmentExtraCharge()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const customRouteValidationStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: !state.hasValue && showRouteError ? 'red' : base.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: !state.hasValue && showRouteError ? 'red' : base.borderColor
      },
    }),
  };

  const customStakeholderValidationStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: !state.hasValue && showStakeholderError ? 'red' : base.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: !state.hasValue && showStakeholderError ? 'red' : base.borderColor
      },
    }),
  };

  const customBlValidationStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: !state.hasValue && showBlError ? 'red' : base.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: !state.hasValue && showBlError ? 'red' : base.borderColor
      },
    }),
  };

  const customLogisticValidationStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: !state.hasValue && showLogisticError ? 'red' : base.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: !state.hasValue && showLogisticError ? 'red' : base.borderColor
      },
    }),
  };

  //  ----------------------------------------------- Uploads  -----------------------------------------------------

  const shipmentuploadcolumns = [
    {
      name: 'Preview',
      selector: row =>
        <>
          {row.file_type == 'application/pdf' ?
            <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.screenshot}`} width={100}></img>
            :
            <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.file}`} width={100}></img>
          }
        </>
      ,
      width: '150px',
      sortable: true,
    },
    {
      name: 'File Name',
      selector: row => row.file_name,
      width: '300px',
      sortable: true,
    },
    {
      name: 'Document Category',
      selector: row => row.document_category.replaceAll("_", " "),
      sortable: true,
    },
    {
      name: 'File Type',
      selector: row => row.file_type,
      sortable: true,
    },
    {
      name: 'File Size',
      selector: row => row.file_size + " MB",
      sortable: true,
    },
    {
      name: 'Uploaded By',
      selector: row => row.created_by?.name,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
            <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => setDeleteUploadDetails(row)}>
              <i className="fa fa-trash"></i>
            </Button>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:view") ?
            <a href={`${row.file}`} target="_blank">
              <Button className="btn btn-sm btn-inox-geen border-0 mx-2" title="View">
                <i className="fa fa-eye"></i>
              </Button>
            </a>
            :
            ""
        }
      </div>,
    }
  ];

  const createUploadFiles = async (files) => {
    const uploadFiles = await Promise.all(
      Array.from(files).map(async (file) => {
        const screenshot = file.type === "application/pdf"
          ? await ConvertPdfToImage(file)
          : "";

        return {
          file,
          previewUrl: URL.createObjectURL(file),
          custom_category: "",
          screenshot
        };
      })
    );

    return uploadFiles;
  };

  const handleUploadsFileChange = async (files) => {
    const uploadfiles = await createUploadFiles(files);
    setUploadFiles(uploadfiles);
    console.log("uploadfiles", uploadfiles)
  }

  const setCustomCategoryToDocument = (file, category) => {
    file.custom_category = category
    console.log("uploadfiles", uploadFiles)
  }

  const removeDocument = (index_to_remove) => {
    URL.revokeObjectURL(uploadFiles[index_to_remove].previewUrl);
    setUploadFiles(files => files.filter((_, index) => index !== index_to_remove));
  }

  const addDraftbookingUploads = async (e) => {
    e.preventDefault();
    setShowUploadFilesLoader(true)
    const id = updateId
    const empty_category = uploadFiles.some(file => file.custom_category === "");
    if (empty_category) {
      toast.error("Assign category to all documents")
      setShowUploadFilesLoader(false)
    }
    else {
      const data = {
        id: id,
        shipment: shipment_id,
        upload: uploadFiles,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentdocument/shipmentuploads/', data,
        {
          headers: { 'content-type': 'multipart/form-data' }
        }
      );
      if (response.status === 200) {
        toast.success("Files Uploaded Successfully")
      }

      setUploadFiles([])
      getShipmentUploads(shipment_id)
      shipmentUploadFileInputRef.current.value = null;
      setShowUploadFilesLoader(false)
    }
  }

  const setDeleteUploadDetails = (row) => {
    setDeleteShippingUploadModal(true)
    setUpdateShippingId(row.id)
    setDeleteShippingUploadFileName(row.file_name)
  }

  const deleteShippingUploads = async (e) => {
    e.preventDefault();
    setShowDeleteShippingUploadFilesLoader(true)

    const data = {
      "document_id": updateShippingId
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentdocument/deletedocumentuploads/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status === 204) {
      toast.success("File Deleted Successfully")
      getShipmentUploads(shipment_id)
    }

    setShowDeleteShippingUploadFilesLoader(false)
    setDeleteShippingUploadModal(false)
  }

  //  ----------------------------------------------- Uploads  -----------------------------------------------------

  useEffect(() => {
    if (selectedPoa && selectedPol && selectedPolTerminal && selectedPod && selectedFd && selectedVesselSchedule) {
      setEnableSearchButton(true)
    }
    else {
      if (shipmentExist) {
        setEnableSearchButton(true)
      }
      else{
        setEnableSearchButton(false)
      }
    }
  }, [selectedPoa, selectedPol, selectedPolTerminal, selectedPod, selectedFd, selectedVesselSchedule]);

  useEffect(() => {
    if (shipmentExist) {
      if (updateSelectedPoa && updateSelectedPol && updateSelectedPolTerminal && updateSelectedPod && updateSelectedFd && updateSelectedVesselSchedule) {
        setEnableSearchButton(true)
      }
      else {
        setEnableSearchButton(false)
      }
    }
  }, [shipmentExist]);


  useEffect(() => {
    if (selectedPoa && selectedPol && selectedPolTerminal && selectedPod && selectedFd && selectedVesselSchedule && selectedPrincipal &&
      selectedBookingParty && selectedCustomer && selectedBlType && selectedBlSubType && selectedPaymentType && selectedSalesPerson
      && !slotsOverload && !tonnageOverload) {
      setEnableCreateButton(true)
      setShowKYCDocumentForm(true)
    }
    else {
      setEnableCreateButton(false)
      setShowKYCDocumentForm(false)
    }
  }, [selectedPoa, selectedPol, selectedPolTerminal, selectedPod, selectedFd, selectedVesselSchedule, selectedPrincipal,
    selectedBookingParty, selectedCustomer, selectedBlType, selectedBlSubType, selectedPaymentType, selectedSalesPerson, slotsOverload, tonnageOverload]);


  const addNewBooking = async (e) => {
    e.preventDefault();
    setShowDraftBookingLoader(true)

    const adhoc_import_charges = importLocal.filter(charge => charge.product_name == "Adhoc")
    const adhoc_export_charges = exportLocal.filter(charge => charge.product_name == "Adhoc")

    const data = {
      principal: selectedPrincipal?.value,
      booking_agent: selectedBookingAgent?.value,
      delivery_agent: selectedDeliveryAgent?.value,
      poa: selectedPoa?.value,
      pol: selectedPol?.value,
      pol_terminal: selectedPolTerminal?.value,
      pod: selectedPod?.value,
      fd: selectedFd?.value,
      hide_fd: hideFdPort,
      origin_for_fd: hiddenFdOrigin?.value,
      shipment_type: selectedShipmentType?.value,
      reference_number: "",
      booking_party: selectedBookingParty?.value,
      customer: selectedCustomer?.value,
      transhipment_vessel_route: selectedVesselTranshipmentRoute?.label,
      transhipment: selectedTranshipment?.length > 0 ? selectedTranshipment?.map(transhipment => transhipment.value) : [],
      transhipment_sequence: selectedTranshipmentSequence,
      iec_code: "",
      shipper: shipper,
      first_vessel_schedule: selectedVesselSchedule?.value,
      in_transit_to: "",
      on_account: onAccount?.value,
      bl_type: selectedBlType?.value,
      bl_sub_type: selectedBlSubType?.value,
      swich_at: switchAt?.value,
      payment: selectedPaymentType?.value,
      collect_at: collectAt?.value,
      poa_detention_free_days: poaDetentionFreeDays,
      pod_detention_free_days: podDetentionFreeDays,
      poa_terminal_storage_free_days: portStorageFreeDays?.poa_terminal_storage_free_days,
      pod_terminal_storage_free_days: portStorageFreeDays?.pod_terminal_storage_free_days,
      transhipment_terminal_storage_free_days: transhipmentStorageFreeDays,
      remarks: remarks,
      weight: cargoRows.reduce((sum, row) => sum + Number(row.weight || 0), 0),
      slot_agreement: selectedSlotAgreement?.value,
      slot_payment_agent: selectedSlotPaymentAgent?.value,
      sales_person: selectedSalesPerson?.value,
      rate_approved_by: selectedRateApprovedBy?.value,
      space_confirmed_by: selectedSpaceConfirmedBy?.value,
      freight_charge: freightCharge,
      ihc_export_payment_type: exportIHCPaymentType,
      ihc_import_payment_type: importIHCPaymentType,
      total_import_local_amount: importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
      total_export_local_amount: exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
      total_import_local_expense: importLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
      total_export_local_expense: exportLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
      approximate_mpe: marginPerExport != null ? marginPerExport: 0,
      approximate_mpi: marginPerImport != null ? marginPerImport:  0,
      status: "DRAFT",
      line_booking_item: cargoRows,
      import_local_charge: importLocal,
      export_local_charge: exportLocal,
      adhoc_import_charge: adhoc_import_charges,
      adhoc_export_charge: adhoc_export_charges,
      miscellaneous_charge: miscellaneousChargeRows,
      vessel_planning: vesselPlanningRows,
      submit_option: submitOption,
      multiple_booking_count: multipleBookingCount,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
      last_booking_number: process.env.REACT_APP_LAST_BOOKING_NUMBER
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/createdraftbooking/', data, { headers: { 'content-type': 'application/json' } });
    if (response.status == 200) {
      toast.success("New Draft Created Successfully")
      navigate("/draftbooking/draftbookingrequest/" + response.data?.shipment);
    }
    
    setShowDraftBookingLoader(false)
  }

  const handleTranshipmentVessel = async (pol, pod, transhipment) => {
    console.log("transhipment00000000000000000000", transhipment)
    if (pol != "" | pol != undefined) {
      if (pod != "" | pod != undefined) {
        try {
          const transhipment_ids = transhipment.map(item => item.value).join(",");
          const transhipment_vessel_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/gettranshipmentvesseltimeline?pick_port=' + pol + '&next_port=' + pod + '&transhipment=' + transhipment_ids)
          console.log("transhipment_vessel_response -----------------",transhipment_vessel_response)
          setTranshipmentVessel(transhipment_vessel_response?.data)
        } catch (err) {
          toast.error("Error in fetching transhipment vessel data! Try again.", err);
        }
      }
    }
  }

  const handleUpdateTranshipmentVessel = async (pol, pod, transhipment) => {
    console.log("transhipment00000000000000000000", transhipment)
    if (pol != "" | pol != undefined) {
      if (pod != "" | pod != undefined) {
        try {
          const transhipment_ids = transhipment.map(item => item).join(",");
          const transhipment_vessel_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/gettranshipmentvesseltimeline?pick_port=' + pol + '&next_port=' + pod + '&transhipment=' + transhipment_ids)
          console.log("transhipment_vessel_response -----------------",transhipment_vessel_response)
          setTranshipmentVessel(transhipment_vessel_response?.data)
        } catch (err) {
          toast.error("Error in fetching transhipment vessel data! Try again.", err);
        }
      }
    }
  }

  const handleSelectedTranshipmentSequence = (transhipmentdata) => {
    const transhipment_sequence = transhipmentdata.reduce((acc, item, index) => {
      acc[index] = {
        index: index + 1,
        id: item.value,
        name: item.label
      };
      return acc;
    }, {});

    setSelectedTranshipmentSequence(transhipment_sequence)

    // const transhipment_port_ids = transhipmentdata.length > 0? transhipmentdata.map(transhipment => transhipment.value):[]
    // if(transhipment_port_ids.length > 0){
    //   getTotalTranshipmentCharges(transhipment_port_ids, JSON.stringify(updateBookingLineItem), 'UPDATE')
    // }
  }

  const setSelectedTranshipmentForUpdate = (transhipmentdata) => {
    const existingValues = transhipmentPortsForUpdate?.map(o => o.value)
    const newSelections = transhipmentdata.filter(o => !existingValues.includes(o.value));
    const updated = [...transhipmentPortsForUpdate.filter(o => transhipmentdata.find(n => n.value === o.value)), ...newSelections];
    setTranshipmentPortsForUpdate(updated);
    setTranshipmentUpdatePorts(updated);

    const transhipment_sequence = updated.reduce((acc, item, index) => {
      acc[index] = {
        index: index + 1,
        id: item.value,
        name: item.label
      };
      return acc;
    }, {});

    setTranshipmentPortSequence(transhipment_sequence)

    const transhipment_port_ids = updated.length > 0 ? updated.map(transhipment => transhipment.value) : []
    if (transhipment_port_ids.length > 0) {
      getTotalTranshipmentCharges(updateSelectedSlotAgreement?.label, transhipmentPortTerminal, JSON.stringify(updateBookingLineItem), 'UPDATE')
    }

  }

  const transhipment_port_sequence = {}

  const formatOptionLabel = (data) => {
    const dataArray = Object.values(data);
    const index = shipmentExist ? transhipmentPortsForUpdate.findIndex(option => option.value === data.value) : dataArray.findIndex(option => option.value === data.value);
    transhipment_port_sequence[index] = { "index": index + 1, "id": data.value, "name": data.label }

    return (
      <div>
        {index !== -1 && <span className="text-inox-green fw-bold" style={{ marginRight: 10 }}>{index + 1} </span>} {data.label}
      </div>
    );
  };

  const updateBooking = async (e) => {
    e.preventDefault();
    setShowUpdateDraftBookingLoader(true)

    if(updateOption=="approve"){
      // Update Existing Draft 
      const draft_data = {
        id: shipmentData?.id,
        hide_fd: updateHideFdPort,
        origin_for_fd: updateHiddenFdOrigin?.value,
        principal: updateSelectedPrincipal?.value,
        booking_agent: updateSelectedBookingAgent?.value,
        delivery_agent: updateSelectedDeliveryAgent?.value,
        shipment_type: updateSelectedShipmentType?.value,
        booking_party: updateSelectedBookingParty?.value,
        transhipment: transhipmentPortsForUpdate.length > 0 ? transhipmentPortsForUpdate.map(transhipment => transhipment.value) : [],
        transhipment_sequence: transhipmentPortSequence,
        shipper: updateShipper,
        first_vessel_schedule: updateSelectedVesselSchedule?.value,
        in_transit_to: "",
        on_account: updateOnAccount?.value,
        bl_type: updateSelectedBlType?.value,
        bl_sub_type: updateSelectedBlSubType?.value,
        swich_at: updateSwitchAt?.value,
        payment: updateSelectedPaymentType?.value,
        collect_at: updateCollectAt?.value,
        poa_detention_free_days: updatePoaDetentionFreeDays,
        pod_detention_free_days: updatePodDetentionFreeDays,
        pod_terminal_storage_free_days: updatePoaTerminalStorageFreeDays,
        pod_terminal_storage_free_days: updatePodTerminalStorageFreeDays,
        transhipment_terminal_free_days: updateTranshipmentTerminalFreeDays,
        remarks: updateRemarks,
        weight: updateBookingLineItem.reduce((sum, row) => sum + Number(row.weight || 0), 0),
        slot_agreement: updateSelectedSlotAgreement?.value,
        slot_payment_agent: updateSelectedSlotPaymentAgent?.value,
        sales_person: updateSelectedSalesPerson?.value,
        rate_approved_by: updateSelectedRateApprovedBy?.value,
        space_confirmed_by: updateSelectedSpaceConfirmedBy?.value,
        freight_charge: updateFreightCharge,
        ihc_export_payment_type: updateExportIHCPaymentType,
        ihc_import_payment_type: updateImportIHCPaymentType,
        total_import_local_amount: importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
        total_export_local_amount: exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
        total_import_local_expense: importLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
        total_export_local_expense: exportLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
        approximate_mpe:  0,
        approximate_mpi: marginPerImport != null ? marginPerImport: 0,
        line_booking_item: updateBookingLineItem,
        import_local_charge: importLocal,
        export_local_charge: exportLocal,
        adhoc_import_charge: importChargeRows,
        adhoc_export_charge: exportChargeRows,
        miscellaneous_charge: miscellaneousChargeRows,
        vessel_planning: vesselPlanningRows,
        status: updateOption,
        modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/updatedraftbooking/', draft_data, { headers: { 'content-type': 'application/json' } });
      if (response.status == 200) {
        toast.success("Draft Approved Successfully")
      }
      

      // Create a new Booking after approval
      const adhoc_import_charges = importLocal.filter(charge => charge.product_name == "Adhoc")
      const adhoc_export_charges = exportLocal.filter(charge => charge.product_name == "Adhoc")

      const data = {
        principal: updateSelectedPrincipal?.value,
        booking_agent: updateSelectedBookingAgent?.value,
        delivery_agent: updateSelectedDeliveryAgent?.value,
        poa: updateSelectedPoa?.id,
        pol: updateSelectedPol?.id,
        pol_terminal: updateSelectedPolTerminal?.id,
        pod: updateSelectedPod?.id,
        fd: updateSelectedFd?.id,
        hide_fd: updateHideFdPort,
        origin_for_fd: updateHiddenFdOrigin?.value,
        reference_number: "",
        shipment_type: updateSelectedShipmentType?.value,
        booking_party: updateSelectedBookingParty?.value,
        customer: updateSelectedCustomer?.value,
        transhipment: transhipmentPortsForUpdate.length > 0 ? transhipmentPortsForUpdate.map(transhipment => transhipment.value) : [],
        transhipment_sequence: transhipmentPortSequence,
        iec_code: "",
        shipper: updateShipper,
        first_vessel_schedule: updateSelectedVesselSchedule?.value,
        in_transit_to: "",
        on_account: updateOnAccount?.value,
        bl_type: updateSelectedBlType?.value,
        bl_sub_type: updateSelectedBlSubType?.value,
        swich_at: updateSwitchAt?.value,
        payment: updateSelectedPaymentType?.value,
        collect_at: updateCollectAt?.value,
        poa_detention_free_days: updatePoaDetentionFreeDays,
        pod_detention_free_days: updatePodDetentionFreeDays,
        pod_terminal_storage_free_days: updatePoaTerminalStorageFreeDays,
        pod_terminal_storage_free_days: updatePodTerminalStorageFreeDays,
        transhipment_terminal_free_days: updateTranshipmentTerminalFreeDays,
        remarks: updateRemarks,
        weight: updateBookingLineItem.reduce((sum, row) => sum + Number(row.weight || 0), 0),
        slot_agreement: updateSelectedSlotAgreement?.value,
        slot_payment_agent: updateSelectedSlotPaymentAgent?.value,
        sales_person: updateSelectedSalesPerson?.value,
        rate_approved_by: updateSelectedRateApprovedBy?.value,
        space_confirmed_by: updateSelectedSpaceConfirmedBy?.value,
        freight_charge: updateFreightCharge,
        ihc_export_payment_type: updateExportIHCPaymentType,
        ihc_import_payment_type: updateImportIHCPaymentType,
        total_import_local_amount: importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
        total_export_local_amount: exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
        total_import_local_expense: importLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
        total_export_local_expense: exportLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
        approximate_mpe:  0,
        approximate_mpi: marginPerImport != null ? marginPerImport: 0,
        line_booking_item: updateBookingLineItem,
        import_local_charge: importLocal,
        export_local_charge: exportLocal,
        adhoc_import_charge: adhoc_import_charges,
        adhoc_export_charge: adhoc_export_charges,
        miscellaneous_charge: miscellaneousChargeRows,
        vessel_planning: vesselPlanningRows,
        submit_option: "draft",
        status: "APPROVED",
        multiple_booking_count: 1,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
        last_booking_number: process.env.REACT_APP_LAST_BOOKING_NUMBER,
        booking_trade_type: "EXPORT",
        booking_cargo_type: updateBookingLineItem[0]?.cargo_type,
        booking_country: updateSelectedPoa?.country,
        booking_poa_port_type: updateSelectedPoa?.type == "SEAPORT" ? "SEA": "DRY"
      }

      const booking_response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/createnewbooking/', data, { headers: { 'content-type': 'application/json' } });
      if (booking_response.status == 200) {
        toast.success("New Booking Created Successfully.")
      }

      getShipment(shipmentData?.id)
      setShowUpdateDraftBookingLoader(false)
    }
    else{
      const data = {
        id: shipmentData?.id,
        hide_fd: updateHideFdPort,
        origin_for_fd: updateHiddenFdOrigin?.value,
        principal: updateSelectedPrincipal?.value,
        booking_agent: updateSelectedBookingAgent?.value,
        delivery_agent: updateSelectedDeliveryAgent?.value,
        shipment_type: updateSelectedShipmentType?.value,
        booking_party: updateSelectedBookingParty?.value,
        transhipment: transhipmentPortsForUpdate.length > 0 ? transhipmentPortsForUpdate.map(transhipment => transhipment.value) : [],
        transhipment_sequence: transhipmentPortSequence,
        shipper: updateShipper,
        first_vessel_schedule: updateSelectedVesselSchedule?.value,
        in_transit_to: "",
        on_account: updateOnAccount?.value,
        bl_type: updateSelectedBlType?.value,
        bl_sub_type: updateSelectedBlSubType?.value,
        swich_at: updateSwitchAt?.value,
        payment: updateSelectedPaymentType?.value,
        collect_at: updateCollectAt?.value,
        poa_detention_free_days: updatePoaDetentionFreeDays,
        pod_detention_free_days: updatePodDetentionFreeDays,
        pod_terminal_storage_free_days: updatePoaTerminalStorageFreeDays,
        pod_terminal_storage_free_days: updatePodTerminalStorageFreeDays,
        transhipment_terminal_free_days: updateTranshipmentTerminalFreeDays,
        remarks: updateRemarks,
        weight: updateBookingLineItem.reduce((sum, row) => sum + Number(row.weight || 0), 0),
        slot_agreement: updateSelectedSlotAgreement?.value,
        slot_payment_agent: updateSelectedSlotPaymentAgent?.value,
        sales_person: updateSelectedSalesPerson?.value,
        rate_approved_by: updateSelectedRateApprovedBy?.value,
        space_confirmed_by: updateSelectedSpaceConfirmedBy?.value,
        freight_charge: updateFreightCharge,
        ihc_export_payment_type: updateExportIHCPaymentType,
        ihc_import_payment_type: updateImportIHCPaymentType,
        total_import_local_amount: importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
        total_export_local_amount: exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0),
        total_import_local_expense: importLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
        total_export_local_expense: exportLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0),
        approximate_mpe:  0,
        approximate_mpi: marginPerImport != null ? marginPerImport: 0,
        line_booking_item: updateBookingLineItem,
        import_local_charge: importLocal,
        export_local_charge: exportLocal,
        adhoc_import_charge: importChargeRows,
        adhoc_export_charge: exportChargeRows,
        miscellaneous_charge: miscellaneousChargeRows,
        vessel_planning: vesselPlanningRows,
        status: updateOption,
        modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/updatedraftbooking/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status == 200) {
        toast.success("Booking Updated Successfully")
      }

      getShipment(shipmentData?.id)
      setShowUpdateDraftBookingLoader(false)
    }
  }


  // ----------------------------- Hazardous Document -------------------------------
  const [hazardousDocumentData, setHazardousDocumentData] = useState(null);
  const [hazardousUploadFiles, setHazardousUploadFiles] = useState(null);
  const [uploadedHazardousFile, setUploadedHazardousFile] = useState(null);
  const [showHazardousDataModal, setShowHazardousDataModal] = useState(false);
  const [showHazardousUploadFilesLoader, setShowHazardousUploadFilesLoader] = useState(false);
  const [shipmentHazardousUploadDataPending, setShipmentHazardousUploadDataPending] = useState(false);
  const [updateShipmentHazardousUploads, setUpdateShipmentHazardousUploads] = useState([]);
  const [deleteShippingHazardousUploadModal, setDeleteShippingHazardousUploadModal] = useState(false);
  const [deleteShippingHazardousUploadFileName, setDeleteShippingHazardousUploadFileName] = useState(false);
  const [showDeleteShippingHazardousUploadFilesLoader, setShowDeleteShippingHazardousUploadFilesLoader] = useState(false);
  const [hazardousDocRemark, setHazardousDocRemark] = useState("");
  const [showHazardousEmailModal, setShowHazardousEmailModal] = useState(false);
  const [showSendHazardousDocumentEmailLoader, setShowSendHazardousDocumentEmailLoader] = useState(false);
  const [updateShipmentHazardousClassInformation, setUpdateShipmentHazardousClassInformation] = useState([]);
  const [shipmentHazardousClassDataPending, setShipmentHazardousClassDataPending] = useState(false);
  const [deleteHazardousClassInformation, setDeleteHazardousClassInformation] = useState(false);
  const [showDeleteHazardousClassInformationLoader, setShowDeleteHazardousClassInformationLoader] = useState(false);
  const [showDeleteHazardousClassInformationModal, setShowDeleteHazardousClassInformationModal] = useState(false);
  const [showUpdateHazardousClassInformationLoader, setShowUpdateHazardousClassInformationLoader] = useState(false);
  const [showUpdateHazardousClassInformationModal, setShowUpdateHazardousClassInformationModal] = useState(false);
  const [updateHazardousClassId, setUpdateHazardousClassId] = useState(null);
  const [updateHazardousClass, setUpdateHazardousClass] = useState("");
  const [updateHazardousUnNumber, setUpdateHazardousUnNumber] = useState("");
  const [updateHazardousPackagingGroup, setUpdateHazardousPackagingGroup] = useState("");
  const [updateHazardousEmsGroup, setUpdateHazardousEmsGroup] = useState("");
  const [updateHazardousMarinePollutant, setUpdateHazardousMarinePollutant] = useState("");
  const [updateHazardousFlashPoint, setUpdateHazardousFlashPoint] = useState("");
  const [updateHazardousSegregationGroup, setUpdateHazardousSegregationGroup] = useState("");
  const [updateHazardousUnPackingCode, setUpdateHazardousUnPackingCode] = useState("");
  const [updateHazardousSubRiskLabel, setUpdateHazardousSubRiskLabel] = useState("");


  const shipmenthazardousuploadcolumns = [
    {
      name: 'Preview',
      selector: row =>
        <>
          {row.file_type == 'application/pdf' ?
            <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.screenshot}`} width={100}></img>
            :
            row.file_type == 'application/vnd.ms-excel' | row.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ?
              <img src={ExcelIcon} style={{ width: '100px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} />
              :
              <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.file}`} width={100}></img>
          }
        </>
      ,
      width: '150px',
      sortable: true,
    },
    {
      name: 'File Details',
      selector: row => <>
        <span><b>File Name: </b>{row.file_name}</span><br></br>
        <span><b>File Type: </b>{row.file_type}</span><br></br>
        <span><b>File Size: </b>{row.file_size + " MB"}</span><br></br>
      </>,
      width: '300px',
      sortable: true,
    },
    {
      name: 'Document Category',
      selector: row => row.document_category.replaceAll("_", " "),
      sortable: true,
    },
    {
      name: 'Uploaded By',
      selector: row => row.created_by?.name,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => loggedInUser?.role_array?.includes("superadmin") ?
        <select className="form-control form-select-sm" onChange={(e) => setHazardousDocumentStatus(row.id, e.target.value)}>
          <option value="" selected={row.status == "" ? true : false} disabled>Select Status</option>
          <option value="UPLOADED" selected={row.status == "UPLOADED" ? true : false} className={row.status == "UPLOADED" ? "bg-inox-green text-white" : ""}>Uploaded</option>
          <option value="UNDER_REVIEW" selected={row.status == "UNDER_REVIEW" ? true : false} className={row.status == "UNDER_REVIEW" ? "bg-inox-green text-white" : ""}>Under Review</option>
          <option value="AWAITING_INFO" selected={row.status == "AWAITING_INFO" ? true : false} className={row.status == "AWAITING_INFO" ? "bg-inox-green text-white" : ""}>Awaiting Additional Information</option>
          <option value="APPROVED" selected={row.status == "APPROVED" ? true : false} className={row.status == "APPROVED" ? "bg-inox-green text-white" : ""}>Approved</option>
          <option value="REJECTED" selected={row.status == "REJECTED" ? true : false} className={row.status == "REJECTED" ? "bg-inox-green text-white" : ""}>Rejected</option>
        </select>
        :
        row.status ?? "-",
      sortable: true,
    },
    {
      name: 'Remarks',
      width: '400px',
      selector: row => loggedInUser?.role_array?.includes("superadmin") ?
        <textarea style={{ fontSize: 11 }} rows={4} cols={60} className="form form-control" onBlur={(e) => setHazardousDocRemark(e.target.value)}>
          {row.remarks}
        </textarea>
        :
        row.remarks ?? "-",
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:view") ?
            <a href={`${row.file}`} target="_blank">
              <Button className="btn btn-sm btn-inox-green border-0 mx-1" title="View">
                <i className="fa fa-eye"></i>
              </Button>
            </a>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
            <Button className="btn btn-sm bg-warning border-0 mx-1" title="Update Remarks" onClick={() => setHazardousDocumentRemark(row.id, hazardousDocRemark)}>
              <i className="fa fa-edit"></i>
            </Button>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
            <Button className="btn btn-sm bg-danger border-0 mx-1" title="Delete" onClick={() => setDeleteHazardousUploadDetails(row)}>
              <i className="fa fa-trash"></i>
            </Button>
            :
            ""
        }
      </div>,
    }
  ];

  const shipmenthazardousrequestuploadcolumns = [
    {
      name: 'Preview',
      selector: row =>
        <>
          {row.file_type == 'application/pdf' ?
            <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.screenshot}`} width={100}></img>
            :
            row.file_type == 'application/vnd.ms-excel' | row.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ?
              <img src={ExcelIcon} style={{ width: '100px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} />
              :
              <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.file}`} width={100}></img>
          }
        </>
      ,
      width: '150px',
      sortable: true,
    },
    {
      name: 'File Details',
      selector: row => <>
        <span><b>File Name: </b>{row.file_name}</span><br></br>
        <span><b>File Type: </b>{row.file_type}</span><br></br>
        <span><b>File Size: </b>{row.file_size + " MB"}</span><br></br>
      </>,
      width: '300px',
      sortable: true,
    },
    {
      name: 'Document Category',
      selector: row => row.document_category.replaceAll("_", " "),
      sortable: true,
    },
    {
      name: 'Uploaded By',
      selector: row => row.created_by?.name,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:view") ?
            <a href={`${row.file}`} target="_blank">
              <Button className="btn btn-sm btn-inox-green border-0 mx-1" title="View">
                <i className="fa fa-eye"></i>
              </Button>
            </a>
            :
            ""
        }
      </div>,
    }
  ];

  const getShipmentHazardousUploads = async (id) => {
    try {
      setShipmentHazardousUploadDataPending(true)
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousdocument?shipment=' + id);
      if (response) {
        setUpdateShipmentHazardousUploads(response.data)
      }
      setShipmentHazardousUploadDataPending(false)
    } catch (err) {
      toast.error("Error in fetching shipment hazardous documents! Try again.");
    }
  }

  const createHazardousUploadFiles = async (files) => {
    const hazardousUploadFiles = await Promise.all(
      Array.from(files).map(async (file) => {
        const screenshot = file.type === "application/pdf"
          ? await ConvertPdfToImage(file)
          : "";

        return {
          file,
          previewUrl: URL.createObjectURL(file),
          hazardous_file_category: "",
          screenshot
        };
      })
    );

    return hazardousUploadFiles;
  };

  const handleHazardousUploadsFileChange = async (e) => {
    setUploadedHazardousFile(e)
    const uploaded_file = e.target.files
    const hazardous_upload_files = await createHazardousUploadFiles(uploaded_file);
    setHazardousUploadFiles(hazardous_upload_files);
    console.log("uploadfiles", hazardous_upload_files)
  }

  const setHazardousDocumentStatus = async (id, status) => {
    const data = {
      id: id,
      shipment: shipment_id,
      status: status,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousdocument/' + id + '/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );
    if (response.status === 200) {
      toast.success("Files Status Updated Successfully")
    }

    getShipmentHazardousUploads(shipment_id)
  }

  const setHazardousDocumentRemark = async (id, remarks) => {
    const data = {
      id: id,
      shipment: shipment_id,
      remarks: remarks,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousdocument/' + id + '/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );
    if (response.status === 200) {
      toast.success("Remark added Successfully")
    }

    getShipmentHazardousUploads(shipment_id)
  }

  const setHazardousCategoryToDocument = async (file, category) => {
    file.hazardous_file_category = category
    // const uploaded_hazardous_file = uploadedHazardousFile.target.files;
    // if (!uploaded_hazardous_file) return;

    // for(let i=0; i<uploaded_hazardous_file.length;i++){
    //   uploaded_hazardous_file[i].hazardous_file_category = category
    //   if(uploaded_hazardous_file[i].type == "application/pdf"){
    //     const text = await extractTextFromPDF(uploaded_hazardous_file[i]);
    //     const data = extractFields(text);

    //     if(category == "UN_PACKAGING"){
    //       const package_data = {"UN Packing Type Codes": data['UN Packing Type Codes']}
    //       if(hazardousDocumentData?.["Product Name"]){
    //         hazardousDocumentData["UN Packing Type Codes"] = package_data['UN Packing Type Codes']
    //         setHazardousDocumentData(hazardousDocumentData);
    //       }
    //       else{
    //         setHazardousDocumentData(data);
    //       }
    //     }
    //     else if(hazardousDocumentData?.["UN Packing Type Codes"]){
    //       data["UN Packing Type Codes"] = hazardousDocumentData?.['UN Packing Type Codes']
    //       setHazardousDocumentData(data);
    //     }
    //     else{
    //       setHazardousDocumentData(data);
    //     }
    //   }
    // }
  }

  const removeHazardousDocument = (index_to_remove) => {
    URL.revokeObjectURL(hazardousUploadFiles[index_to_remove].previewUrl);
    setHazardousUploadFiles(files => files.filter((_, index) => index !== index_to_remove));
  }

  // const addDraftbookingHazardousUploads = async (e) => {
  //   e.preventDefault();
  //   setShowHazardousUploadFilesLoader(true)
  //   const id = updateId

  //   const empty_category = hazardousUploadFiles.some(file => file.hazardous_file_category === "");
  //   if (empty_category){
  //     toast.error("Assign category to all documents")
  //     setShowHazardousUploadFilesLoader(false)
  //   }
  //   else{
  //     const data = {
  //       id: id,
  //       shipment: shipment_id,
  //       upload: hazardousUploadFiles,
  //       created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
  //     }

  //     const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousdocument/shipmenthazardousuploads/', data,
  //       {
  //         headers: { 'content-type': 'multipart/form-data' }
  //       }
  //     );
  //     if (response.status === 200) {
  //       toast.success("Hazardous Files Uploaded Successfully")
  //     }

  //     setHazardousUploadFiles([])
  //     getShipmentHazardousUploads(shipment_id)
  //     shipmentHazardousUploadFileInputRef.current.value = null;
  //     setShowHazardousUploadFilesLoader(false)
  //   }
  // }

  const addDraftbookingHazardousUploads = async (e) => {
    e.preventDefault();
    setShowHazardousUploadFilesLoader(true);

    const id = updateId;

    const empty_category = hazardousUploadFiles.some(
      (file) => file.hazardous_file_category === ""
    );
    if (empty_category) {
      toast.error("Assign category to all documents");
      setShowHazardousUploadFilesLoader(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("shipment", shipment_id);
      formData.append("created_by", loggedInUser?.id);

      // Append each uploaded file and its extra data
      hazardousUploadFiles.forEach((file, index) => {
        formData.append(`upload[${index}][file]`, file.file); // actual file object
        formData.append(`upload[${index}][hazardous_file_category]`, file.hazardous_file_category || "");
        if (file.screenshot) {
          formData.append(`upload[${index}][screenshot]`, file.screenshot);
        }
      });

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/master/shipmenthazardousdocument/shipmenthazardousuploads/`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status === 200) {
        toast.success("Hazardous Files Uploaded Successfully");
      }

      setHazardousUploadFiles([]);
      getShipmentHazardousUploads(shipment_id);
      shipmentHazardousUploadFileInputRef.current.value = null;
    } catch (error) {
      console.error(error);
      toast.error("File upload failed");
    } finally {
      setShowHazardousUploadFilesLoader(false);
    }
  };

  const setDeleteHazardousUploadDetails = (row) => {
    setDeleteShippingHazardousUploadModal(true)
    setUpdateShippingId(row.id)
    setDeleteShippingHazardousUploadFileName(row.file_name)
  }

  const deleteShippingHazardousUploads = async (e) => {
    e.preventDefault();
    setShowDeleteShippingHazardousUploadFilesLoader(true)

    const document_id = updateShippingId

    const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousdocument/' + document_id + '/',
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status === 204) {
      toast.success("File Deleted Successfully")
      getShipmentHazardousUploads(shipment_id)
    }

    setShowDeleteShippingHazardousUploadFilesLoader(false)
    setDeleteShippingHazardousUploadModal(false)
  }

  const sendHazardousDocumentEmail = async (e) => {
    e.preventDefault();
    setShowSendHazardousDocumentEmailLoader(true)

    const data = {
      "to": updateSlotOperatorEmail,
      "subject": updateEmailSubject,
      "message": updateEmailMessage,
      "attachments": updateShipmentHazardousUploads.map(doc => doc.file)
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousdocument/sendhazardousdocumentemail/', data,
    );

    if (response.status === 200) {
      toast.success("Email Sent Successfully")
    }

    setShowSendHazardousDocumentEmailLoader(false)
    setShowHazardousEmailModal(false)
  }


  const shipmenthazardousclasscolumns = [
    {
      name: 'Class',
      selector: row => row.haz_class,
      sortable: true,
    },
    {
      name: 'UN No',
      selector: row => row.un_number,
      sortable: true,
    },
    {
      name: 'Packaging Group',
      selector: row => row.packaging_group,
      sortable: true,
    },
    {
      name: 'EMS/PSA Group',
      selector: row => row.ems_psa_group,
      sortable: true,
    },
    {
      name: 'Marine Pollutant',
      selector: row => row.marine_pollutant,
      sortable: true,
    },
    {
      name: 'Flash Point',
      selector: row => row.flash_point,
      sortable: true,
    },
    {
      name: 'Segregation Group',
      selector: row => row.segregation_group,
      sortable: true,
    },
    {
      name: 'Packing Code',
      selector: row => row.un_packing_code,
      sortable: true,
    },
    {
      name: 'Sub Risk Label',
      selector: row => row.sub_risk_label,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
            <Button className="btn btn-sm bg-warning border-0 mx-1" title="Update" onClick={() => setUpdateHazardousClassInformation(row)}>
              <i className="fa fa-edit"></i>
            </Button>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
            <Button className="btn btn-sm bg-danger border-0 mx-1" title="Delete" onClick={() => [setShowDeleteHazardousClassInformationModal(true), setDeleteHazardousClassInformation(row)]}>
              <i className="fa fa-trash"></i>
            </Button>
            :
            ""
        }
      </div>,
    }
  ];

  const getShipmentHazardousClassInformation = async (id) => {
    try {
      setShipmentHazardousClassDataPending(true)
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousclassinformation?shipment=' + id);
      if (response) {
        setUpdateShipmentHazardousClassInformation(response.data)
      }
      setShipmentHazardousClassDataPending(false)
    } catch (err) {
      console.log("err", err)
      toast.error("Error in fetching shipment hazardous class information! Try again.");
    }
  }

  const addDraftbookingHazardousClassInformation = async (e) => {
    e.preventDefault()
    // const formData = new FormData(shipmentHazardousClassFormRef.current);
    // console.log("shipmentHazardousClassFormRef.current", shipmentHazardousClassFormRef.current)
    // console.log("formData", formData)

    const formElement = shipmentHazardousClassFormRef.current;
    const formData = new FormData(formElement);
    const data = Object.fromEntries(formData.entries());

    console.log("data", data)

    if (data.haz_class == "") {
      toast.error("Class is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else if (data.haz_un_number == "") {
      toast.error("UN Number is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else if (data.haz_packaging_group == "") {
      toast.error("Packaging Group is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else if (data.haz_ems_group == "") {
      toast.error("EMS Group is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else if (data.haz_flash_point == "") {
      toast.error("Flash Point is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else if (data.haz_segregation_group == "") {
      toast.error("Segregation Group is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else if (data.haz_un_packing_code == "") {
      toast.error("UN Packaging Code is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else if (data.haz_sub_risk_label == "") {
      toast.error("Sub Risk Label is required")
      setShowHazardousUploadFilesLoader(false)
    }
    else {
      const class_data = {
        shipment: shipment_id,
        haz_class: data?.haz_class,
        un_number: data?.haz_un_number,
        packaging_group: data?.haz_packaging_group,
        ems_psa_group: data?.haz_ems_group,
        marine_pollutant: data?.haz_marine_pollutant,
        flash_point: data?.haz_flash_point,
        segregation_group: data?.haz_segregation_group,
        un_packing_code: data?.haz_un_packing_code,
        sub_risk_label: data?.haz_sub_risk_label,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousclassinformation/', class_data,
        {
          headers: { 'content-type': 'application/json' }
        }
      );
      if (response.status === 201) {
        toast.success("Hazardous Class Data Added Successfully")
      }

      getShipmentHazardousClassInformation(shipment_id)
      shipmentHazardousClassFormRef.current.haz_class.value = "";
      shipmentHazardousClassFormRef.current.haz_un_number.value = "";
      shipmentHazardousClassFormRef.current.haz_packaging_group.value = "";
      shipmentHazardousClassFormRef.current.haz_ems_group.value = "";
      shipmentHazardousClassFormRef.current.haz_marine_pollutant.value = "NO";
      shipmentHazardousClassFormRef.current.haz_flash_point.value = "";
      shipmentHazardousClassFormRef.current.haz_segregation_group.value = "";
      shipmentHazardousClassFormRef.current.haz_un_packing_code.value = "";
      shipmentHazardousClassFormRef.current.haz_sub_risk_label.value = "";
      setShowHazardousUploadFilesLoader(false)
    }
  }

  const deleteShippingHazardousClassInformation = async (e) => {
    e.preventDefault();
    setShowDeleteHazardousClassInformationLoader(true)

    const id = deleteHazardousClassInformation?.id

    const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousclassinformation/' + id + '/',
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status === 204) {
      toast.success("Class Information Deleted Successfully")
      getShipmentHazardousClassInformation(shipment_id)
    }

    setShowDeleteHazardousClassInformationLoader(false)
    setShowDeleteHazardousClassInformationModal(false)
  }

  const setUpdateHazardousClassInformation = (row) => {
    setUpdateHazardousClassId(row.id)
    setUpdateHazardousClass(row.haz_class)
    setUpdateHazardousUnNumber(row.un_number)
    setUpdateHazardousPackagingGroup(row.packaging_group)
    setUpdateHazardousEmsGroup(row.ems_psa_group)
    setUpdateHazardousMarinePollutant(row.marine_pollutant)
    setUpdateHazardousFlashPoint(row.flash_point)
    setUpdateHazardousSegregationGroup(row.segregation_group)
    setUpdateHazardousUnPackingCode(row.packaging_group)
    setUpdateHazardousSubRiskLabel(row.sub_risk_label)
    setShowUpdateHazardousClassInformationModal(true)
  }

  const updateShippingHazardousClassInformation = async (e) => {
    e.preventDefault();
    const id = updateHazardousClassId

    if (updateHazardousClass == "") {
      toast.error("Class is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else if (updateHazardousUnNumber == "") {
      toast.error("UN Number is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else if (updateHazardousPackagingGroup == "") {
      toast.error("Packaging Group is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else if (updateHazardousEmsGroup == "") {
      toast.error("EMS Group is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else if (updateHazardousFlashPoint == "") {
      toast.error("Flash Point is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else if (updateHazardousSegregationGroup == "") {
      toast.error("Segregation Group is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else if (updateHazardousUnPackingCode == "") {
      toast.error("UN Packaging Code is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else if (updateHazardousSubRiskLabel == "") {
      toast.error("Sub Risk Label is required")
      setShowUpdateHazardousClassInformationLoader(false)
    }
    else {
      const class_data = {
        id: id,
        haz_class: updateHazardousClass,
        un_number: updateHazardousUnNumber,
        packaging_group: updateHazardousPackagingGroup,
        ems_psa_group: updateHazardousEmsGroup,
        marine_pollutant: updateHazardousMarinePollutant,
        flash_point: updateHazardousFlashPoint,
        segregation_group: updateHazardousSegregationGroup,
        un_packing_code: updateHazardousUnPackingCode,
        sub_risk_label: updateHazardousSubRiskLabel,
        created_by: JSON.stringify(loggedInUser?.id)
      }

      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousclassinformation/updatehazardousclassinformation/', class_data,
        {
          headers: { 'content-type': 'application/json' }
        }
      );
      if (response.status === 200) {
        toast.success("Hazardous Class Data Updated Successfully")
      }

      getShipmentHazardousClassInformation(shipment_id)
      setShowUpdateHazardousClassInformationLoader(false)
      setShowUpdateHazardousClassInformationModal(false)
    }
  }


  // ---------------------------------------------- Haz Request Information -----------------------------------------------------------------

  const [showHazardousRequestLoader, setShowHazardousRequestLoader] = useState(false)
  const [showDeleteHazardousRequestInformationLoader, setShowDeleteHazardousRequestInformationLoader] = useState(false)
  const [showDeleteHazardousRequestInformationModal, setShowDeleteHazardousRequestInformationModal] = useState(false)
  const [showUpdateHazardousRequestInformationModal, setShowUpdateHazardousRequestInformationModal] = useState(false)
  const [showUpdateHazardousRequestInformationLoader, setShowUpdateHazardousRequestInformationLoader] = useState(false)
  const [shipmentHazardousRequestDataPending, setShipmentHazardousRequestDataPending] = useState(false)
  const [updateShipmentHazardousRequestInformation, setUpdateShipmentHazardousRequestInformation] = useState(false)
  const [deleteHazardousRequestInformation, setDeleteHazardousRequestInformation] = useState(false)


  const [updateHazardousRequestId, setUpdateHazardousRequestId] = useState("")
  const [updateHazardousRequestCargo, setUpdateHazardousRequestCargo] = useState("Hazardous")
  const [updateHazardousRequestCommodity, setUpdateHazardousRequestCommodity] = useState(updateBookingLineItem[0]?.commodity?.name)
  const [updateHazardousRequestDgRefNumber, setUpdateHazardousRequestDgRefNumber] = useState("")
  const [updateHazardousRequestShipper, setUpdateHazardousRequestShipper] = useState("")
  const [updateHazardousRequestInnerPkgDesc, setUpdateHazardousRequestInnerPkgDesc] = useState("")
  const [updateHazardousRequestOuterPkgDesc, setUpdateHazardousRequestOuterPkgDesc] = useState("")
  const [updateHazardousRequestIipCodeNumber, setUpdateHazardousRequestIipCodeNumber] = useState("")
  const [updateHazardousRequestImdgRegNumber, setUpdateHazardousRequestImdgRegNumber] = useState("")
  const [updateHazardousRequestShippingName, setUpdateHazardousRequestShippingName] = useState("")
  const [updateHazardousRequestTechnicalName, setUpdateHazardousRequestTechnicalName] = useState("")
  const [updateHazardousRequestEmergencyNumber, setUpdateHazardousRequestEmergencyNumber] = useState("")
  const [updateHazardousRequestRemarks, setUpdateHazardousRequestRemarks] = useState("")


  const shipmenthazardousRequestInformationcolumns = [
    {
      name: 'Cargo',
      selector: row => row.cargo,
      sortable: true,
    },
    {
      name: 'Commodity',
      selector: row => row.commodity,
      sortable: true,
    },
    {
      name: 'Reference Number',
      selector: row => row.dg_reference_number,
      sortable: true,
    },
    {
      name: 'Shipper',
      selector: row => row.shipper,
      sortable: true,
    },
    {
      name: 'Inner Pkg Desc',
      selector: row => row.inner_package_description,
      sortable: true,
    },
    {
      name: 'Outer Pkg Desc',
      selector: row => row.outer_package_description,
      sortable: true,
    },
    {
      name: 'IIP Code No.',
      selector: row => row.iip_code_number,
      sortable: true,
    },
    {
      name: 'IMDG Code',
      selector: row => row.imdg_code,
      sortable: true,
    },
    {
      name: 'Shipping Name',
      selector: row => row.shipping_name,
      sortable: true,
    },
    {
      name: 'Technical Name',
      selector: row => row.technical_name,
      sortable: true,
    },
    {
      name: 'Emergency Contact No.',
      selector: row => row.emergency_contact_number,
      sortable: true,
    },
    {
      name: 'Remarks',
      selector: row => row.remarks,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:update") ?
            <Button className="btn btn-sm bg-warning border-0 mx-1" title="Update" onClick={() => setUpdateHazardousRequestInformation(row)}>
              <i className="fa fa-edit"></i>
            </Button>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:delete") ?
            <Button className="btn btn-sm bg-danger border-0 mx-1" title="Delete" onClick={() => [setShowDeleteHazardousRequestInformationModal(true), setDeleteHazardousRequestInformation(row)]}>
              <i className="fa fa-trash"></i>
            </Button>
            :
            ""
        }
      </div>,
    }
  ];

  const getShipmentHazardousRequestInformation = async (id) => {
    try {
      setShipmentHazardousRequestDataPending(true)
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousrequest?shipment=' + id);
      if (response) {
        setUpdateShipmentHazardousRequestInformation(response.data)
      }
      setShipmentHazardousRequestDataPending(false)
    } catch (err) {
      console.log("err", err)
      toast.error("Error in fetching shipment hazardous request information! Try again.");
    }
  }

  const addDraftbookingHazardousRequestInformation = async (e) => {
    e.preventDefault()

    const formElement = shipmentHazardousRequestFormRef.current;
    const formData = new FormData(formElement);
    const data = Object.fromEntries(formData.entries());


    if (data.haz_request_cargo == "") {
      toast.error("Cargo is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_commodity == "") {
      toast.error("Commodity is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_dg_ref_number == "") {
      toast.error("DG Ref Number is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_shipper == "") {
      toast.error("Shipper is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_inner_pkg_desc == "") {
      toast.error("Inner Pkg Description is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_outer_pkg_desc == "") {
      toast.error("Outer Pkg Description is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_iip_code_number == "") {
      toast.error("IIP Code Number is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_imdg_reg_number == "") {
      toast.error("IMDG Reg Number is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_shipping_name == "") {
      toast.error("Shipping Name is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_technical_name == "") {
      toast.error("Technical Name is required")
      setShowHazardousRequestLoader(false)
    }
    else if (data.haz_request_emergency_number == "") {
      toast.error("Emergency Number is required")
      setShowHazardousRequestLoader(false)
    }
    else {
      const request_data = {
        shipment: shipment_id,
        cargo: "Hazardous",
        commodity: updateBookingLineItem[0]?.commodity?.name,
        dg_reference_number: data?.haz_request_dg_ref_number,
        shipper: data?.haz_request_shipper,
        inner_package_description: data?.haz_request_inner_pkg_desc,
        outer_package_description: data?.haz_request_outer_pkg_desc,
        iip_code_number: data?.haz_request_iip_code_number,
        imdg_code: data?.haz_request_imdg_reg_number,
        shipping_name: data?.haz_request_shipping_name,
        technical_name: data?.haz_request_technical_name,
        emergency_contact_number: data?.haz_request_emergency_number,
        remarks: data?.haz_request_remarks,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousrequest/', request_data,
        {
          headers: { 'content-type': 'application/json' }
        }
      );
      if (response.status === 201) {
        toast.success("Hazardous Request Data Added Successfully")
      }

      getShipmentHazardousRequestInformation(shipment_id)
      shipmentHazardousRequestFormRef.current.haz_request_cargo.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_commodity.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_dg_ref_number.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_shipper.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_inner_pkg_desc.value = "NO";
      shipmentHazardousRequestFormRef.current.haz_request_outer_pkg_desc.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_iip_code_number.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_imdg_reg_number.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_shipping_name.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_technical_name.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_emergency_number.value = "";
      shipmentHazardousRequestFormRef.current.haz_request_remarks.value = "";
      setShowHazardousRequestLoader(false)
    }
  }

  const deleteShippingHazardousRequestInformation = async (e) => {
    e.preventDefault();
    setShowDeleteHazardousRequestInformationLoader(true)

    const id = deleteHazardousRequestInformation?.id

    const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousrequest/' + id + '/',
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status === 204) {
      toast.success("Request Information Deleted Successfully")
      getShipmentHazardousRequestInformation(shipment_id)
    }

    setShowDeleteHazardousRequestInformationLoader(false)
    setShowDeleteHazardousRequestInformationModal(false)
  }

  const setUpdateHazardousRequestInformation = (row) => {
    setUpdateHazardousRequestId(row.id)
    setUpdateHazardousRequestCargo(row.cargo)
    setUpdateHazardousRequestCommodity(row.commodity)
    setUpdateHazardousRequestDgRefNumber(row.dg_reference_number)
    setUpdateHazardousRequestShipper(row.shipper)
    setUpdateHazardousRequestInnerPkgDesc(row.inner_package_description)
    setUpdateHazardousRequestOuterPkgDesc(row.outer_package_description)
    setUpdateHazardousRequestIipCodeNumber(row.iip_code_number)
    setUpdateHazardousRequestImdgRegNumber(row.imdg_code)
    setUpdateHazardousRequestShippingName(row.shipping_name)
    setUpdateHazardousRequestTechnicalName(row.technical_name)
    setUpdateHazardousRequestEmergencyNumber(row.emergency_contact_number)
    setUpdateHazardousRequestRemarks(row.remarks)
    setShowUpdateHazardousRequestInformationModal(true)
  }

  const updateShippingHazardousRequestInformation = async (e) => {
    e.preventDefault();
    setShowUpdateHazardousRequestInformationLoader(true)
    const id = updateHazardousRequestId

    if (updateHazardousRequestCargo == "") {
      toast.error("Cargo is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestCommodity == "") {
      toast.error("Commodity is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestDgRefNumber == "") {
      toast.error("DG Ref Number is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestShipper == "") {
      toast.error("Shipper is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestInnerPkgDesc == "") {
      toast.error("Inner Pkg Description is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestOuterPkgDesc == "") {
      toast.error("Outer Pkg Description is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestIipCodeNumber == "") {
      toast.error("IIP Code Number is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestImdgRegNumber == "") {
      toast.error("IMDG Reg Number is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestShippingName == "") {
      toast.error("Shipping Name is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestTechnicalName == "") {
      toast.error("Technical Name is required")
      setShowHazardousRequestLoader(false)
    }
    else if (updateHazardousRequestEmergencyNumber == "") {
      toast.error("Emergency Number is required")
      setShowHazardousRequestLoader(false)
    }
    else {
      const request_data = {
        id: id,
        cargo: updateHazardousRequestCargo,
        commodity: updateHazardousRequestCommodity,
        dg_reference_number: updateHazardousRequestDgRefNumber,
        shipper: updateHazardousRequestShipper,
        inner_package_description: updateHazardousRequestInnerPkgDesc,
        outer_package_description: updateHazardousRequestOuterPkgDesc,
        iip_code_number: updateHazardousRequestIipCodeNumber,
        imdg_code: updateHazardousRequestImdgRegNumber,
        shipping_name: updateHazardousRequestShippingName,
        technical_name: updateHazardousRequestTechnicalName,
        emergency_contact_number: updateHazardousRequestEmergencyNumber,
        remarks: updateHazardousRequestRemarks,
        modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousrequest/' + id + '/', request_data,
        {
          headers: { 'content-type': 'application/json' }
        }
      );
      if (response.status === 200) {
        toast.success("Hazardous Request Data Updated Successfully")
      }

      getShipmentHazardousRequestInformation(shipment_id)
      setShowUpdateHazardousRequestInformationLoader(false)
      setShowUpdateHazardousRequestInformationModal(false)
    }
  }



  // -------------------------------------------------------------------------------
  const handleDeadFreightToggle = async () => {
    if (isDeadFreight) {
      setIsDeadFreight(false)
    }
    else {
      setIsDeadFreight(true)
    }
  };


  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
          <ToastContainer></ToastContainer>
          <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
          <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="DraftBooking" activeSubMenu="DraftBookingRequest" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar} />

          <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
            {updatePageLoader ?
              <div className="my-5 text-center" style={{ paddingTop: '25%' }}>
                <Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" />
              </div>
              :
            <div className="col-12 page-header">
              <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-6 py-1">
                  <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                    {menuDrawerShow ?
                      <span><i className="fa fa-chevron-left mx-1"></i></span> :
                      <span><i className="fa fa-chevron-right mx-1"></i></span>
                    }
                  </Button>
                  <span className="page-header-text">
                    {isDeadFreight ? "Dead Freight Booking" : "Draft Booking"}
                    <label class="switch">
                      <input type="checkbox" onChange={handleDeadFreightToggle} />
                      <span class="slider round"></span>
                    </label>
                  </span>
                </div>

                {shipmentExist ?
                  <div className="col-sm-6 col-md-6 col-lg-6 py-1">
                    <div style={{
                      borderRadius: 5, float: 'right', marginRight: 20,
                      backgroundColor: updateStatus === "DRAFT" ? "#B2EBF2" :
                        updateStatus === "WAITING_APPROVAL" ? "#FFF3CD" :
                          updateStatus === "APPROVED" ? "#C3E6CB" :
                            updateStatus === "NOT_APPROVED" ? "#FFE5B4" :
                              updateStatus === "REJECTED" ? "#F5C6CB" :
                                updateStatus === "CANCELLED" ? "#D6D8DB" : "#000"
                    }}>
                      <p className="px-3 my-2 fw-bold">{updateStatus?.replaceAll("_", " ")}</p>
                    </div>
                  </div>
                  : ""}
              </div>

              {!isDeadFreight ?
                <div className="row" style={{ marginRight: 35 }}>
                  <div class="col-12 border rounded shadow mt-3" style={{ marginLeft: 18 }}>
                    <div className="d-flex my-3">
                      <div class="p-2 flex-grow-1" style={{ width: '20%' }}>
                        <h5 className="fw-bold">Route</h5>
                        <input
                          ref={triggerRouteFormRef}
                          type="text"
                          className="form-control form-control-sm border-0"
                          placeholder="Shipping From and To"
                          onClick={handleRouteFormClick}
                          disabled={routeInputDisabled}
                        />

                        {shipmentExist ?
                          <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                            <span><b>POA: </b> {updateSelectedPoa?.name ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POL: </b> {updateSelectedPol.name ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POL Terminal: </b> {updateSelectedPolTerminal?.name ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POD: </b> {updateSelectedPod.name ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>FD: </b> {updateSelectedFd.name ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Vessel: </b> <br></br>
                                1. {updateSelectedVesselSchedule?.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                                {transhipmentVessel.map((vessel, index) => (
                                  index!=0? 
                                  <><span>{index+1}. {vessel?.schedule?.vessel}</span><br></br></>
                                  :
                                  ""
                                ))}
                            <span><b>Shipment Type: </b> {updateSelectedShipmentType?.label ?? "None"}</span><br></br>

                            {updateSelectedTranshipment?.length > 0 ?
                              <span className="d-flex">
                                <b>Transhipment Ports: </b>
                                <ul style={{ listStyle: 'none', paddingLeft: 5, marginBottom: 0 }}>
                                  {updateSelectedTranshipment && updateSelectedTranshipment?.map(transhipment => (
                                    <li>
                                      {transhipment?.label}
                                    </li>
                                  ))}
                                </ul>
                              </span>
                              : 
                              ""
                            }

                            {totalTranshipmentCharge?.total_transhipment_charge > 0 ?
                              <span>
                                <b>Transhipment Charge: </b> {totalTranshipmentCharge?.currency} {totalTranshipmentCharge?.total_transhipment_charge}
                              </span>
                              : 
                              ""
                            }
                          </div>
                          :
                          selectedPoa && selectedPol && selectedPod && selectedFd ?
                            <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                              <span><b>POA: </b> {selectedPoa.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                              <span><b>POL: </b> {selectedPoa.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                              <span><b>POL Terminal: </b> {selectedPolTerminal.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                              <span><b>POD: </b> {selectedPod.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                              <span><b>FD: </b> {selectedFd.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                              <span><b>Vessel: </b> 
                                  <span>
                                  {selectedVesselSchedule?.label ?? <span className="text-danger fw-bold">None</span>}
                                  </span>
                              </span><br></br>
                              <span><b>Shipment Type: </b> {selectedShipmentType?.value ?? "None"}</span><br></br>

                              {selectedTranshipment?.length > 0 ?
                                <span className="d-flex">
                                  <b>Transhipment Ports: </b>
                                  <ul style={{ listStyle: 'none', paddingLeft: 5, marginBottom: 0 }}>
                                    {selectedTranshipment && selectedTranshipment?.map(transhipment => (
                                      <li>
                                        {transhipment?.label}
                                      </li>
                                    ))}
                                  </ul>
                                </span>
                                : 
                                ""
                              }

                              {totalTranshipmentCharge?.total_transhipment_charge > 0 ?
                                <>
                                  <span>
                                    <b>Transhipment Charge: </b>  {totalTranshipmentCharge?.currency} {totalTranshipmentCharge?.total_transhipment_charge}
                                  </span>
                                </>
                                : 
                                ""
                              }
                            </div>
                            : ""
                        }

                        {routeFormOpen && (
                          <div
                            ref={tooltipRouteFormRef}
                            className="tooltip-form-container"
                            style={{
                              top: tooltipPosition.top,
                              left: tooltipPosition.left,
                              transform: "translateX(-35%)",
                            }}
                          >
                            <div className="tooltip-arrow" />
                            <div className="tooltip-content px-3" style={{ background: '#FFF' }}>
                              <form className="tooltip-form">
                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">POA</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={portList}
                                      id="poa"
                                      name="poa"
                                      onChange={(e) => [setSelectedPoa(e), getIhcExportRoute(e, selectedPol)]}
                                      value={
                                        shipmentExist ?
                                          { 'value': updateSelectedPoa?.id, 'label': updateSelectedPoa?.name }
                                          :
                                          selectedPoa
                                      }
                                      isMulti={false}
                                      isClearable
                                      className="px-0"
                                      placeholder={<span>POA <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customRouteValidationStyles}
                                      isDisabled={shipmentExist}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">POL</div>

                                  <div className="col-12 px-0">
                                    <Select
                                      options={portList}
                                      id="pol"
                                      name="pol"
                                      onChange={(e) => [
                                        setSelectedPol(e),
                                        getTerminal(e),
                                        getVesselSchedule(e, null),
                                        // getTrashipmentPort(e, selectedPod, selectedVesselSchedule),
                                        getIhcExportRoute(selectedPoa, e),
                                        setVesselPlanningRows([
                                          {
                                            0:[{
                                                id: generateId,
                                                vessel: selectedVesselSchedule,
                                                vessel_desciption: selectedVesselSchedule,
                                                from: e,
                                                to: selectedPod,
                                                transhipment_port: "",
                                                operator: "",
                                                slot: 0
                                              }]
                                          },
                                        ])
                                      ]}
                                      value={shipmentExist ? { 'value': updateSelectedPol?.id, 'label': updateSelectedPol?.name } : selectedPol}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1 mr-1"
                                      placeholder={<span>POL <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customRouteValidationStyles}
                                      isDisabled={shipmentExist}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">POD</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={portList}
                                      id="pod"
                                      name="pod"
                                      onChange={(e) => [
                                        setSelectedPod(e),
                                        getVesselSchedule(selectedPol, e),
                                        // getTrashipmentPort(selectedPol, e, selectedVesselSchedule),
                                        getIhcImportRoute(e, selectedFd),
                                        setVesselPlanningRows([
                                            {
                                              0:[{
                                                  id: generateId,
                                                  vessel: selectedVesselSchedule,
                                                  vessel_desciption: selectedVesselSchedule,
                                                  from: selectedPol,
                                                  to: e,
                                                  transhipment_port: "",
                                                  operator: "",
                                                  slot: 0
                                                }]
                                            },
                                          ])
                                      ]}
                                      value={shipmentExist ? { 'value': updateSelectedPod?.id, 'label': updateSelectedPod?.name } : selectedPod}
                                      isMulti={false}
                                      isClearable
                                      className="px-0"
                                      placeholder={<span>POD <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customRouteValidationStyles}
                                      isDisabled={shipmentExist}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">FD</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={portList}
                                      id="fd"
                                      name="fd"
                                      onChange={(e) => {
                                        if(!shipmentExist){
                                          setSelectedFd(e)
                                          getIhcImportRoute(selectedPod, e)
                                          setHideDestinationPort(e?.hide_port)
                                        }
                                        else{
                                          getIhcImportRoute(selectedPod, e)
                                          setUpdateHideDestinationPort(e?.hide_port)
                                        }
                                      }}
                                      value={shipmentExist ? { 'value': updateSelectedFd?.id, 'label': updateSelectedFd?.name, 'type': updateSelectedFd?.type, 'hide_port': updateSelectedFd?.hide_if_destination } : selectedFd}
                                      isMulti={false}
                                      isClearable
                                      className="px-0"
                                      placeholder={<span>FD <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customRouteValidationStyles}
                                      isDisabled={shipmentExist}
                                    />
                                  </div>

                                  {hideDestinationPort && !shipmentExist?
                                  <div class="d-flex justify-content-between mt-2">
                                    <div className="row">
                                        <div className="col-12 px-0 font-12px mt-2">Hide FD?</div>
                                        <div className="col-12 px-0">
                                          <select className="form-select form-select-sm" onChange={(e) => setHideFdPort(e.target.value)}>
                                            <option value="YES">YES</option>
                                            <option value="NO">NO</option>
                                          </select>
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-12 px-0 font-12px mt-2">Origin For FD</div>
                                        <div className="col-12 px-0">
                                          <Select
                                            options={portList}
                                            id="fd_origin"
                                            name="fd_origin"
                                            onChange={(e) => setHiddenFdOrigin(e)}
                                            value={hiddenFdOrigin}
                                            isMulti={false}
                                            isClearable
                                            className="px-0"
                                            placeholder={<span>Origin For FD</span>}
                                            styles={smallFormSelectCustomStyles}
                                          />
                                        </div>
                                      </div>
                                  </div>
                                  :
                                  updateHideDestinationPort && shipmentExist?
                                  <div class="d-flex justify-content-between mt-2">
                                    <div className="row">
                                      <div className="col-12 px-0 font-12px mt-2">Hide FD?</div>
                                      <div className="col-12 px-0">
                                        <select className="form-select form-select-sm" onChange={(e) => setUpdateHideFdPort(e.target.value)}>
                                          <option value="YES" selected={updateHideFdPort=="YES"?true:false}>YES</option>
                                          <option value="NO" selected={updateHideFdPort=="NO"?true:false}>NO</option>
                                        </select>
                                      </div>
                                    </div>
                                  
                                    <div className="row">
                                      <div className="col-12 font-12px mt-2">Origin For FD</div>
                                      <div className="col-12">
                                        <Select
                                          options={portList}
                                          id="fd_origin"
                                          name="fd_origin"
                                          onChange={(e) => setUpdateHiddenFdOrigin(e)}
                                          value={updateHiddenFdOrigin}
                                          isMulti={false}
                                          isClearable
                                          className="px-0"
                                          placeholder={<span>Origin For FD</span>}
                                          styles={smallFormSelectCustomStyles}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  ""
                                  }
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Vessel Schedule</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={vesselScheduleList}
                                      id="vessel_schedule"
                                      name="vessel_schedule"
                                      onChange={(e) => {
                                        if (!shipmentExist) {
                                          getVesselScheduleTranshipmentPort()
                                          setSelectedVesselSchedule(e)
                                          getTerminalStorageFreeDays(e)
                                          // getTrashipmentPort(selectedPol, selectedPod, e)
                                          getSlotRateAgreementOperator(e?.value)
                                          getVesselSlotAndTonnage(e?.value)
                                          setVesselPlanningRows([
                                            {
                                              0:[{
                                                  id: generateId,
                                                  vessel: e?.value,
                                                  vessel_desciption: e?.label,
                                                  from: selectedPol,
                                                  from_terminal: e?.loading_port_terminal,
                                                  to: selectedPod,
                                                  to_terminal: e?.destination_port_terminal,
                                                  transhipment_port: "",
                                                  operator: "",
                                                  slot: 0
                                                }]
                                            },
                                          ])
                                        }
                                        else {
                                          setUpdateSelectedVesselSchedule(e)
                                          getUpdateTrashipmentPort(updateSelectedPol?.id, updateSelectedPod?.id, e?.value)
                                          setVesselPlanningRows([
                                            {
                                              0:[{
                                                  id: generateId,
                                                  vessel: selectedVesselSchedule,
                                                  vessel_desciption: selectedVesselSchedule,
                                                  from: selectedPol,
                                                  from_terminal: e?.loading_port_terminal,
                                                  to: selectedPod,
                                                  to_terminal: e?.destination_port_terminal,
                                                  transhipment_port: "",
                                                  operator: "",
                                                  slot: 0
                                                }]
                                            },
                                          ])
                                        }
                                      }
                                      }
                                      value={shipmentExist ? updateSelectedVesselSchedule : vesselScheduleList.length > 0 ? selectedVesselSchedule : null}
                                      isMulti={false}
                                      isClearable
                                      className="px-0"
                                      placeholder={<span>Vessel Schedule <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customRouteValidationStyles}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Shipment Type</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={shipmentTypeList}
                                      id="shipment_type"
                                      name="shipment_type"
                                      onChange={(e) => {
                                        if (shipmentExist) {
                                          setUpdateSelectedShipmentType(e)
                                          if (e?.value == "VIA") {
                                            setShowTranshipment(true)
                                          }
                                          else {
                                            setShowTranshipment(false)
                                          }
                                        }
                                        else {
                                          setSelectedShipmentType(e)
                                          if (e?.value == "VIA") {
                                            setShowTranshipment(true)
                                          }
                                          else {
                                            setShowTranshipment(false)
                                          }
                                        }
                                      }}
                                      value={shipmentExist ? { 'value': updateSelectedShipmentType?.value, 'label': updateSelectedShipmentType.label } : { 'value': selectedShipmentType?.value, 'label': selectedShipmentType?.label }}
                                      isMulti={false}
                                      isClearable
                                      className="px-0"
                                      placeholder="Shipment type"
                                    />
                                  </div>
                                </div>

                                {/* {shipmentExist && updateSelectedShipmentType?.value == "VIA" || showTranshipment ?
                                  <div className="row">
                                    <div className="col-12 px-0 font-12px mt-2">Vessel Route</div>
                                    <div className="col-12 px-0">
                                      <Select
                                        options={vesselTranshipmentRoute}
                                        id="vessel_transhipment_route"
                                        name="vessel_transhipment_route"
                                        onChange={(e) => [
                                          setSelectedVesselTranshipmentRoute(e),
                                          setTranshipmentList(e?.transhipments),
                                          setSelectedTranshipment(e?.transhipments),
                                          handleSelectedTranshipmentSequence(e?.transhipments),
                                          handleTranshipmentVessel(selectedPol?.value, selectedPod?.value, e?.transhipments)
                                        ]}
                                        isMulti={false}
                                        isClearable
                                        className="px-0"
                                        placeholder="Vessel Route"
                                        value={selectedVesselTranshipmentRoute}
                                      />
                                    </div>
                                  </div>
                                  : ""} */}

                                {/* {shipmentExist && updateSelectedShipmentType?.value == "VIA" || showTranshipment ?
                                  <div className="row">
                                    <div className="col-12 px-0 font-12px mt-2">Transhipments</div>
                                    <div className="col-12 px-0">
                                      <Select
                                        options={transhipmentList}
                                        id="transhipment"
                                        name="transhipment"
                                        onChange={(e) => {
                                          if (shipmentExist) {
                                            setSelectedTranshipmentForUpdate(e)
                                          }
                                          else {
                                            setSelectedTranshipment(e)

                                          }
                                        }}
                                        value={shipmentExist ? transhipmentUpdatePorts : selectedTranshipment}
                                        isMulti={true}
                                        isClearable
                                        className="px-0"
                                        placeholder="Transhipment"
                                        formatOptionLabel={formatOptionLabel}
                                      />
                                    </div>
                                  </div>
                                  : ""} */}

                                <div className="row">
                                  <div class="d-flex text-center my-1 px-0">
                                    <button type="button"
                                      className="btn btn-secondary border-0 w-100"
                                      style={{ marginRight: 5 }} onClick={() => [
                                        setRouteFormOpen(false),
                                        setShowRouteError(false),
                                        setSelectedPoa(""),
                                        setSelectedPol(""),
                                        setSelectedPolTerminal(""),
                                        setSelectedPodTerminal(""),
                                        setSelectedPod(""),
                                        setSelectedFd(""),
                                        setSelectedVesselSchedule(""),
                                        setSelectedShipmentType(""),
                                        setVesselScheduleList([]),
                                        setTranshipmentList([]),
                                        setSelectedTranshipment([]),
                                        setRouteInputDisabled(false)
                                      ]}>Cancel</button>
                                    <button className="btn btn-inox-green border-0 w-100 text-white" style={{ marginLeft: 5 }} onClick={() => [setRouteFormOpen(false), setRouteInputDisabled(false)]}>Save</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>

                      <div class="p-2 flex-grow-1" style={{ width: '20%' }}>
                        <h5 className="fw-bold">Cargo and Container</h5>
                        <input
                          ref={triggerCargoFormRef}
                          type="text"
                          className="form-control form-control-sm border-0"
                          placeholder="What is being shipped?"
                          onClick={handleCargoFormClick}
                          disabled={cargoInputDisabled}
                        />

                        <div className="mt-3" style={{ fontSize: 12 }}>
                          {!shipmentExist && cargoRows.map((cargo, index) => (
                            <div style={{ fontSize: 13 }} class={`${cargoRows[index]['export_transport_charge'] == "" ? "display-none" : ""}`}>
                              <hr className={`my-1 ${index==0?"display-none":""}`}></hr>
                              <small>
                                <Image src={cargo?.container_size?.type == "TANK" ? IsoTankImage : ContainerImage} height={30} className="mr-2 mb-1"></Image>
                                {cargo?.quantity} x {cargo?.container_size?.label} {cargo?.commodity} ({cargo?.cargo_type == "NON_HAZARDOUS" ? "NON-HAZ" : "HAZ"})
                              </small><br></br>
                              <small>
                                <span><b>Weight: </b>{cargo.quantity * cargo.weight} MT</span>
                                <span className="ml-3"><b>IHC: </b>
                                  {icdImportCurrency?.country == "India" || icdExportCurrency?.symbol == "India" ?
                                    selectedPoa.type == "DRYPORT" ?
                                      FormatCurrency(cargo.export_transport_charge + cargo.export_iso_tank_charge + cargo.export_dg_surcharge + cargo.export_bss_surcharge, "INR", "en-IN")
                                      :
                                      selectedFd.type == "DRYPORT" ?
                                        FormatCurrency(cargo.import_transport_charge + cargo.import_iso_tank_charge + cargo.import_dg_surcharge + cargo.import_bss_surcharge, "INR", "en-IN")
                                        :
                                        0
                                    :
                                    selectedPoa.type == "DRYPORT" ?
                                      FormatCurrency(cargo.export_transport_charge + cargo.export_iso_tank_charge + cargo.export_dg_surcharge + cargo.export_bss_surcharge, "USD")
                                      :
                                      selectedFd.type == "DRYPORT" ?
                                        FormatCurrency(cargo.import_transport_charge + cargo.import_iso_tank_charge + cargo.import_dg_surcharge + cargo.import_bss_surcharge, "USD")
                                        :
                                        0

                                  }
                                  <small> (Inc. Taxes)</small>
                                </span>
                              </small>
                            </div>
                          ))}

                          {!shipmentExist && cargoRows && cargoRows?.[0]?.export_transport_charge > 0 ?
                            <>
                              <hr className="my-1"></hr>
                              <span><b>Total Containers: </b>{cargoRows?.reduce((sum, row) => sum + parseInt(row.quantity), 0)}</span><br></br>
                              <span>
                                <b>Total Weight: </b>
                                {cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.weight || 0), 0)} + {(cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.tare_weight || 0), 0)).toFixed(2)} (Tare Weight) = {cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.weight || 0), 0) + cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.tare_weight || 0), 0)} MT
                              </span><br></br>
                              <span><b>Total Slot Charge: </b> $ {totalSlotRate}</span><br></br>
                              <span><b>Total Freight Charge: </b> $ {freightCharge}</span><br></br>

                              {selectedPoa.type == "DRYPORT" ?
                                <div className="row">
                                  <div className="col-8">
                                    {icdExportCurrency?.country != "India" ?
                                      <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                        <b>Total IHC Export Charge: </b>
                                        {FormatCurrency(((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                        ) * parseFloat(icdExportCurrency?.currency_value)).toFixed(2), "USD")}
                                      </span>
                                      :
                                      <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                        <b>Total IHC Export Charge: </b>
                                        {FormatCurrency((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                        ).toFixed(2), "INR", "en-IN")}
                                      </span>
                                    }
                                  </div>
                                  <div className="col-3 px-1">
                                    <select className="form-select form-select-sm" style={{ fontSize: 'smaller' }} onChange={(e) => setExportIHCPaymentType(e.target.value)}>
                                      <option value="NA">NA</option>
                                      <option value="PREPAID">PREPAID</option>
                                      <option value="COLLECT">COLLECT</option>
                                    </select>
                                  </div>
                                  <div className="col-1 px-0">
                                    <span className="text-danger">*</span>
                                  </div>
                                </div>
                                : ""}

                              {selectedFd.type == "DRYPORT" ?
                                <div className="row">
                                  <div className="col-8">
                                    {icdImportCurrency?.country != "India" ?
                                      <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                        <b>Total IHC Import Charge: </b>
                                        {FormatCurrency(((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                        ) * parseFloat(icdImportCurrency?.currency_value)).toFixed(2), "USD")}
                                      </span>
                                      :
                                      <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                        <b>Total IHC Import Charge: </b>
                                        {FormatCurrency((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                          cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                        ).toFixed(2), "INR", "en-IN")}
                                      </span>
                                    }
                                  </div>
                                  <div className="col-3">
                                    <select className="form-select form-select-sm" style={{ fontSize: 'smaller' }} onChange={(e) => setImportIHCPaymentType(e.target.value)}>
                                      <option value="NA">NA</option>
                                      <option value="PREPAID">PREPAID</option>
                                      <option value="COLLECT">COLLECT</option>
                                    </select>
                                  </div>
                                  <div className="col-1 px-0">
                                    <span className="text-danger">*</span>
                                  </div>
                                </div>
                                : ""}
                            </>
                            : ""}


                          {shipmentExist && updateBookingLineItem.map((cargo, index) => (
                            <div style={{ fontSize: 13 }} class={`${cargo['export_transport_charge'] == "" ? "display-none" : ""}`}>
                              <hr className={`my-1 ${index==0?"display-none":""}`}></hr>
                              <small>
                                <Image src={cargo.container_size?.type == "TANK" ? IsoTankImage : ContainerImage} height={30} className="mr-2 mb-1"></Image>
                                {cargo.quantity}  x {cargo.container_size?.product_name ? cargo.container_size?.product_name : cargo.container_size?.label} {cargo.commodity?.name ? cargo.commodity?.name : cargo.commodity} ({cargo.cargo_type == "NON_HAZARDOUS" ? "NON-HAZ" : "HAZ"})
                              </small><br></br>

                              <small>
                                <span><b>Weight: </b>{cargo.quantity * cargo.weight} MT</span>
                                <span className="ml-3"><b>IHC: </b>
                                  {icdImportCurrency?.country == "India" || icdExportCurrency?.symbol == "India" ?
                                    updateSelectedPoa.type == "DRYPORT" ?
                                      FormatCurrency(
                                        Number(cargo.export_transport_charge) +
                                        Number(cargo.export_iso_tank_charge) +
                                        Number(cargo.export_dg_surcharge) +
                                        Number(cargo.export_bss_surcharge), "INR", "en-IN")
                                      :
                                      updateSelectedFd.type == "DRYPORT" ?
                                        FormatCurrency(
                                          Number(cargo.import_transport_charge) +
                                          Number(cargo.import_iso_tank_charge) +
                                          Number(cargo.import_dg_surcharge) +
                                          Number(cargo.import_bss_surcharge), "INR", "en-IN")
                                        :
                                        0
                                    :
                                    updateSelectedPoa.type == "DRYPORT" ?
                                      FormatCurrency(
                                        Number(cargo.export_transport_charge) +
                                        Number(cargo.export_iso_tank_charge) +
                                        Number(cargo.export_dg_surcharge) +
                                        Number(cargo.export_bss_surcharge), "USD")
                                      :
                                      updateSelectedFd.type == "DRYPORT" ?
                                        FormatCurrency(
                                          Number(cargo.import_transport_charge) +
                                          Number(cargo.import_iso_tank_charge) +
                                          Number(cargo.import_dg_surcharge) +
                                          Number(cargo.import_bss_surcharge), "USD")
                                        :
                                        0

                                  }
                                  <small> (Inc. Taxes)</small>
                                </span>
                              </small>
                            </div>
                          ))}

                          {shipmentExist && updateBookingLineItem && updateBookingLineItem?.[0]?.export_transport_charge > 0 ?
                            <>
                              <hr className="my-1"></hr>
                              <span><b>Total Containers: </b>{updateBookingLineItem?.reduce((sum, row) => sum + parseInt(row.quantity), 0)}</span><br></br>
                              <span>
                                <b>Total Weight (MT): </b>
                                {updateBookingLineItem?.reduce((sum, row) => sum + Number(row.quantity * row.weight || 0), 0)} + {(updateBookingLineItem?.reduce((sum, row) => sum + Number(row.quantity * row.tare_weight || 0), 0)).toFixed(2)} (Tare Weight) = {updateBookingLineItem?.reduce((sum, row) => sum + Number(row.quantity * row.weight || 0), 0) + updateBookingLineItem?.reduce((sum, row) => sum + Number(row.quantity * row.tare_weight || 0), 0)} MT
                              </span><br></br>
                              <span><b>Total Slot Charge: </b> $ {totalSlotRate}</span><br></br>
                              <span><b>Total Freight Charge: </b> $ {updateFreightCharge}</span><br></br>

                              {updateSelectedPoa.type == "DRYPORT" ?
                                <div className="row">
                                  <div className="col-8">
                                    {
                                      icdExportCurrency?.country != "India" ?
                                        <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                          <b>Total IHC Export Charge: </b>
                                          {
                                            FormatCurrency(((updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                              updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                              updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                              updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                            ) * parseFloat(icdExportCurrency?.currency_value)), "USD")}
                                        </span>
                                        :
                                        <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                          <b>Total IHC Export Charge: </b>
                                          {FormatCurrency((updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                            updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                            updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                            updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                          ).toFixed(2), "INR", "en-IN")}
                                        </span>
                                    }
                                  </div>
                                  <div className="col-3">
                                    <select className="form-select form-select-sm" style={{ fontSize: 'smaller' }} onChange={(e) => setUpdateExportIHCPaymentType(e.target.value)}>
                                      <option value="NA" selected={updateExportIHCPaymentType == "NA" ? true : false}>NA</option>
                                      <option value="PREPAID" selected={updateExportIHCPaymentType == "PREPAID" ? true : false}>PREPAID</option>
                                      <option value="COLLECT" selected={updateExportIHCPaymentType == "COLLECT" ? true : false}>COLLECT</option>
                                    </select>
                                  </div>
                                  <div className="col-1 px-0">
                                    <span className="text-danger">*</span>
                                  </div>
                                </div>
                                : ""}

                              {updateSelectedFd.type == "DRYPORT" ?
                                <div className="row">
                                  <div className="col-8">
                                    {icdImportCurrency?.country != "India" ?
                                      <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                        <b>Total IHC Import Charge: </b>
                                        {
                                          FormatCurrency(((updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                            updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                            updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                            updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                          ) * parseFloat(icdImportCurrency?.currency_value)).toFixed(2), "USD")
                                        }
                                      </span>
                                      :
                                      <span style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                        <b>Total IHC Import Charge: </b>
                                        {FormatCurrency((updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                                          updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                                          updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                                          updateBookingLineItem.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                                        ).toFixed(2), "INR", "en-IN")
                                        }
                                      </span>
                                    }
                                  </div>
                                  <div className="col-3">
                                    <select className="form-select form-select-sm" style={{ fontSize: 'smaller' }} onChange={(e) => setUpdateImportIHCPaymentType(e.target.value)}>
                                      <option value="NA" selected={updateImportIHCPaymentType == "NA" ? true : false}>NA</option>
                                      <option value="PREPAID" selected={updateImportIHCPaymentType == "PREPAID" ? true : false}>PREPAID</option>
                                      <option value="COLLECT" selected={updateImportIHCPaymentType == "COLLECT" ? true : false}>COLLECT</option>
                                    </select>
                                  </div>
                                  <div className="col-1 px-0">
                                    <span className="text-danger">*</span>
                                  </div>
                                </div>
                                : ""}
                            </>
                            :
                            ""
                          }
                        </div>

                        {cargoFormOpen && (
                          <div
                            ref={tooltipCargoFormRef}
                            className="tooltip-form-line-item-container"
                            style={{
                              top: tooltipPosition.top,
                              left: tooltipPosition.left,
                              transform: "translateX(-40%)",
                            }}
                          >
                            <div className="tooltip-arrow" />
                            <div className="tooltip-content px-3" style={{ background: '#FFF' }}>
                              <div className="row">
                                {/* <div className="col-4 px-0 mb-2">
                                  <div className="col-12 px-0 font-12px mt-2">Slot Operator</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={slotAgreementList}
                                      id="slot_agreement"
                                      name="slot_agreement"
                                      onChange={(e) => {
                                        if (shipmentExist) {
                                          setUpdateSelectedSlotAgreement(e)
                                          getSlotAgreementRate(e?.value)
                                          getIhcExportChargeUpdate(updateBookingLineItem)
                                          getIhcImportChargeUpdate(updateBookingLineItem)
                                        }
                                        else {
                                          setSelectedSlotAgreement(e)
                                        }
                                      }}
                                      value={shipmentExist ? updateSelectedSlotAgreement : selectedSlotAgreement}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder="Slot Operator"
                                    />
                                  </div>
                                </div> */}

                                <div className="col-4 mb-2 px-0">
                                  <div className="col-12 font-12px mt-2">Freight Charges (In USD)</div>
                                  <div className="col-6">
                                      <input
                                      type="number" 
                                      id="freight_charge"
                                      name="freight_charge"
                                      className="form-control" 
                                      value={shipmentExist?updateFreightCharge:freightCharge}
                                      onChange={(e) => {
                                          if(shipmentExist){
                                            setUpdateFreightCharge(e.target.value)
                                          }
                                          else{
                                            setFreightCharge(e.target.value)
                                          }
                                        }
                                      }
                                      />
                                    </div>
                                </div>
                              </div>

                              {bookingLineItemLoader ?
                                <div className="d-flex flex-column align-items-center justify-content-center mt-4 mb-5">
                                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                </div>
                                : ""
                              }

                              {shipmentExist ?
                                updateBookingLineItem.map((row, index) => (
                                  <form className={`tooltip-form ${index != 0 ? 'mt-2' : ''}`}>
                                    <div className="row">
                                      <div class="d-flex px-0">
                                        <Select
                                          options={containerSizeList}
                                          id={"container_size" + index}
                                          name={"container_size" + index}
                                          onChange={(e) => handleChange(index, row.id, "container_size", e, "UPDATE")}
                                          isMulti={false}
                                          isClearable
                                          className="px-0 flex-grow-1"
                                          placeholder={
                                            row['container_size'] ?
                                              row['container_size']['product_name'] ?
                                                row['container_size']['product_name'] :
                                                row['container_size']['label']
                                              :
                                              "Container Size"
                                          }
                                        />

                                        <input
                                          id={"quantity" + index}
                                          name={"quantity" + index}
                                          type="number"
                                          placeholder={row['quantity'] ? row['quantity'] : "Quantity"}
                                          className="flex-grow-1 ml-1"
                                          style={{ width: '100px', height: 38 }}
                                          onChange={(e) => handleChange(index, row.id, "quantity", e.target.value, "UPDATE")}
                                        >
                                        </input>

                                        <Select
                                          options={cargoTypeList}
                                          id={"cargo_type" + index}
                                          name={"cargo_type" + index}
                                          onChange={(e) => handleChange(index, row.id, "cargo_type", e?.value, "UPDATE")}
                                          isMulti={false}
                                          isClearable
                                          className="px-0 flex-grow-1 ml-1"
                                          placeholder={row['cargo_type'] ? row['cargo_type'] : "Cargo Type"}

                                        />

                                        <input
                                          id={"weight" + index}
                                          name={"weight" + index}
                                          type="number"
                                          placeholder={row['weight'] ? row['weight'] : "Weight (MT)"}
                                          className="flex-grow-1 ml-1"
                                          style={{ width: '120px', background: '#F2F2F2', border: "1px solid #E6E6E6", height: 38 }}
                                          onChange={(e) => handleChange(index, row.id, "weight", e.target.value, "UPDATE")}
                                        >
                                        </input>

                                        <Select
                                          options={commodityList}
                                          id={"commodity" + index}
                                          name={"commodity" + index}
                                          onChange={(e) => handleChange(index, row.id, "commodity", e.value, "UPDATE")}
                                          isMulti={false}
                                          isClearable
                                          className="px-0 flex-grow-1 ml-1"
                                          placeholder={
                                            row['commodity'] ?
                                              row['commodity']?.['name'] ?
                                                row['commodity']?.['name'] :
                                                row['commodity']
                                              : "Commodity"
                                          }
                                        />

                                        <input
                                          id={"tare_weight" + index}
                                          name={"tare_weight" + index}
                                          type="number"
                                          placeholder={row['tare_weight'] ? row['tare_weight'] : "Tare Weight (MT)"}
                                          className="flex-grow-1 ml-1"
                                          style={{ width: '120px', background: '#F2F2F2', border: "1px solid #E6E6E6", height: 38 }}
                                          onChange={(e) => handleChange(index, row.id, "tare_weight", e.target.value, "UPDATE")}
                                        >
                                        </input>

                                        <input
                                          id={"export_transport_charge" + index}
                                          name={"export_transport_charge" + index}
                                          type="number"
                                          placeholder={row['export_transport_charge'] ? row['export_transport_charge'] : "Transport Charge"}
                                          className="flex-grow-1 ml-1"
                                          style={{ background: '#F2F2F2', border: "1px solid #E6E6E6", height: 38 }}
                                          disabled
                                        >
                                        </input>

                                        <Button
                                          className="flex-grow-1 btn btn-sm btn-inox-red ml-1 border-0"
                                          style={{ height: 38, width: 30 }}
                                          title="Remove Cargo"
                                          onClick={() => removeRow(row.id)}
                                          disabled={index == 0 ? true : false}>
                                          <i className="fa fa-trash"></i>
                                        </Button>

                                        <Button
                                          className="flex-grow-1 btn btn-sm btn-inox-green ml-1 border-0"
                                          style={{ height: 38, width: 30 }}
                                          title="Add Cargo"
                                          onClick={() => addRow()}>
                                          <i className="fa fa-plus"></i>
                                        </Button>
                                      </div>

                                      {row['container_size']['product_name'] != "" && 
                                        row['cargo_type'] != "" && 
                                        row['commodity']?.['name'] != ""  && 
                                        row['weight'] != ""?
                                      <div className="col-12 px-0">
                                        <table width="100%" className="mt-3">
                                          <tr className="border-bottom">
                                            <th width="5%">Leg</th>
                                            <th width="40%">Vessel</th>
                                            <th width="15%">Operator</th>
                                            <th width="5%">Slot</th>
                                            <th width="5%">FD?</th>
                                            <th width="15%">TSP Port</th>
                                            <th width="10%" className="text-center">Add Vessel</th>
                                          </tr>

                                          {vesselPlanningRows?.[0]?.[index]?.map((row, vessel_index) => (
                                          <tr>
                                            <td>
                                              <span>{vessel_index+1}</span>
                                            </td>

                                            <td>
                                              <span>{row?.vessel_desciption}</span><br></br>
                                              <span className="font-11px">{row?.from?.label} <b>({row?.from_terminal})</b> - {row?.to?.label} <b>({row?.to_terminal})</b></span>
                                            </td>

                                            <td>
                                              <Select
                                                options={operatorList}
                                                id="first_vessel_operator"
                                                name="first_vessel_operator"
                                                onChange={(e) => {
                                                  getUpdateSlotRate(index, vessel_index, e)
                                                  refreshRows()
                                                  console.log("vesselPlanningRows", vesselPlanningRows)
                                                  }
                                                }
                                                isMulti={false}
                                                isClearable
                                                className="w-100"
                                                placeholder="Select"
                                                value={vesselPlanningRows[0][index][vessel_index]['operator']}
                                              />
                                            </td>

                                            <td>
                                              <input 
                                                type="number" 
                                                value={Number(vesselPlanningRows[0][index][vessel_index]['slot'])}
                                                className="form-control form-control-sm"
                                                onChange={(e) => {
                                                  vesselPlanningRows[0][index][vessel_index]['slot'] = e.target.value
                                                  refreshRows()
                                                  console.log("SLOT", vesselPlanningRows[0][index][vessel_index]['slot'])
                                                }}>
                                              </input>
                                            </td>

                                            <td>
                                              <select 
                                                className="form form-control"
                                                onChange={(e) => {
                                                  vesselPlanningRows[0][index][vessel_index]['reached_destination'] = e.target.value
                                                  refreshRows()
                                                }}>
                                                <option value="YES">YES</option>
                                                <option value="NO" selected>NO</option>
                                              </select>
                                            </td>

                                            <td>
                                              <Select
                                                options={portList}
                                                id="transhipment_port"
                                                name="transhipment_port"
                                                onChange={(e) => {
                                                  const previous = vesselPlanningRows[0][index][vessel_index]['transhipment_port'];
                                                  vesselPlanningRows[0][index][vessel_index]['transhipment_port'] = e;

                                                  setSelectedTranshipment((prev) => {
                                                    const prevArray = Array.isArray(prev) ? prev : [];

                                                    // If cleared → remove old value
                                                    if (!e) {
                                                      return prevArray.filter(
                                                        (item) => item.value !== previous?.value
                                                      );
                                                    }

                                                    // Remove old value (if changed)
                                                    let updated = prevArray.filter(
                                                      (item) => item.value !== previous?.value
                                                    );

                                                    // Add new value (avoid duplicate)
                                                    if (!updated.some((item) => item.value === e.value)) {
                                                      updated = [...updated, e];
                                                    }

                                                    return updated;
                                                  });

                                                  if(selectedTranshipment.length > 0){
                                                    setSelectedShipmentType({ "value": "VIA", "label": "VIA" })
                                                  }
                                                  else{
                                                    setSelectedShipmentType({ "value": "DIRECT", "label": "DIRECT" })
                                                  }

                                                  console.log("SelectedTranshipment", selectedTranshipment)
                                                  refreshRows()
                                                }}
                                                isMulti={false}
                                                isClearable
                                                className="px-0 w-100"
                                                placeholder="Select"
                                                value={vesselPlanningRows[0][index][vessel_index]['transhipment_port']}
                                                isDisabled={vesselPlanningRows[0][index][vessel_index]['reached_destination']=="YES"?true:false}
                                              />
                                            </td>

                                            <td className="text-center">
                                              <Button
                                                className="btn btn-inox-red ml-1 border-0"
                                                title="Remove Vessel"
                                                onClick={() => removeVesselPlanningRow(index, vessel_index)}
                                                disabled={vessel_index == 0 ? true : false}>
                                                <i className="fa fa-trash"></i>
                                              </Button>

                                              <Button
                                                className="btn btn-inox-green ml-1 border-0"
                                                title="Add Vessel"
                                                disabled={vesselPlanningRows[0][index][vessel_index]['reached_destination']=="YES"?true:false}
                                                onClick={() => {
                                                  addVesselPlanningRow(index, vessel_index)
                                                  setCurrentCargoIndex(index)
                                                  setCurrentVesselLegIndex(vessel_index)
                                                  setAddVesselRouteModal(true)
                                                }}>
                                                <i className="fa fa-plus"></i>
                                              </Button>
                                            </td>
                                          </tr>
                                          ))}
                                        </table>
                                      </div>
                                      :""}
                                    </div>
                                  </form>
                                ))
                                :
                                selectedPol && selectedFd && cargoRows.map((row, index) => (
                                  <form className={`tooltip-form ${index != 0 ? 'mt-2' : ''}`}>
                                    {index != 0?<hr></hr>:<></>}
                                    <div className="row">
                                      <div class="d-flex px-0">
                                        <Select
                                          options={containerSizeList}
                                          id={"container_size" + index}
                                          name={"container_size" + index}
                                          onChange={(e) => [
                                            handleChange(index, row.id, "container_size", e, "CREATE"),
                                            getIhcExportCharge(cargoRows[index], index),
                                            getIhcImportCharge(cargoRows[index], index)
                                          ]}
                                          isMulti={false}
                                          isClearable
                                          className="px-0 flex-grow-1"
                                          placeholder={cargoRows[index]['container_size'] ? cargoRows[index]['container_size']['label'] : "Container Size"}
                                        />

                                        <input
                                          id={"quantity" + index}
                                          name={"quantity" + index}
                                          type="number"
                                          placeholder={cargoRows[index]['quantity'] ? cargoRows[index]['quantity'] : "Quantity"}
                                          className="flex-grow-1 ml-1"
                                          style={{ width: '100px', height: 39 }}
                                          onChange={(e) => [
                                            handleChange(index, row.id, "quantity", e.target.value, "CREATE"),
                                            getIhcExportCharge(cargoRows[index], index),
                                            getIhcImportCharge(cargoRows[index], index)
                                          ]}>
                                        </input>

                                        <Select
                                          options={cargoTypeList}
                                          id={"cargo_type" + index}
                                          name={"cargo_type" + index}
                                          onChange={(e) => [
                                            handleChange(index, row.id, "cargo_type", e?.value, "CREATE"),
                                            getIhcExportCharge(cargoRows[index], index),
                                            getIhcImportCharge(cargoRows[index], index)
                                          ]}
                                          isMulti={false}
                                          isClearable
                                          className="px-0 flex-grow-1 ml-1"
                                          placeholder={cargoRows[index]['cargo_type'] ? cargoRows[index]['cargo_type'] : "Cargo Type"}
                                        />

                                        <input
                                          id={"weight" + index}
                                          name={"weight" + index}
                                          type="number"
                                          placeholder={cargoRows[index]['weight'] ? cargoRows[index]['weight'] : "Weight (MT)"}
                                          className="flex-grow-1 ml-1"
                                          style={{ width: '120px', height: 39 }}
                                          onChange={(e) => {
                                            if (e.target.value > 30) {
                                              toast.warning("Maximum 30 MT weight is allowed")
                                              setTonnageOverload(true)
                                            }
                                            else {
                                              handleChange(index, row.id, "weight", e.target.value, "CREATE")
                                              getIhcExportCharge(cargoRows[index], index)
                                              getIhcImportCharge(cargoRows[index], index)
                                            }
                                          }
                                          }>
                                        </input>

                                        <Select
                                          options={commodityList.filter((row) => row.type == cargoRows[index]['cargo_type'])}
                                          id={"commodity" + index}
                                          name={"commodity" + index}
                                          onChange={(e) => handleChange(index, row.id, "commodity", e.value, "CREATE")}
                                          isMulti={false}
                                          isClearable
                                          className="px-0 flex-grow-1 ml-1"
                                          placeholder={cargoRows[index]['commodity'] ? cargoRows[index]['commodity'] : "Commodity"}
                                        />

                                        

                                        <input
                                          id={"tare_weight" + index}
                                          name={"tare_weight" + index}
                                          type="number"
                                          placeholder={cargoRows[index]['tare_weight'] ? cargoRows[index]['tare_weight'] : "Tare Weight (MT)"}
                                          className="flex-grow-1 ml-1"
                                          style={{ background: '#CFCFCF', height: 39 }}
                                          onChange={(e) => handleChange(index, row.id, "tare_weight", e.target.value, "CREATE")}
                                          disabled>
                                        </input>

                                        {/* <input
                                          id={"slot" + index}
                                          name={"slot" + index}
                                          type="number"
                                          placeholder={cargoRows[index]['slot'] ? cargoRows[index]['slot'] : "Slot"}
                                          className="flex-grow-1 ml-1"
                                          style={{ width: '120px', background: '#CFCFCF', height: 39 }}
                                          disabled
                                        >
                                        </input> */}

                                        <input
                                          id={"export_transport_charge" + index}
                                          name={"export_transport_charge" + index}
                                          type="number"
                                          placeholder={cargoRows[index]['export_transport_charge'] ? cargoRows[index]['export_transport_charge'] : "Transport Charge"}
                                          className="flex-grow-1 ml-1"
                                          style={{ background: '#CFCFCF', height: 39 }}
                                          disabled
                                        >
                                        </input>

                                        <Button
                                          className="flex-grow-1 btn btn-sm btn-inox-red ml-1 border-0"
                                          title="Remove Cargo"
                                          onClick={() => removeRow(row.id)}
                                          disabled={index == 0 ? true : false}>
                                          <i className="fa fa-trash"></i>
                                        </Button>

                                        <Button
                                          className="flex-grow-1 btn btn-sm btn-inox-green ml-1 border-0"
                                          title="Add Cargo"
                                          onClick={() => addRow()}>
                                          <i className="fa fa-plus"></i>
                                        </Button>
                                      </div>

                                      {cargoRows[index]['container_size']?.['label'] != "" && cargoRows[index]['cargo_type']?.['label'] != "" 
                                       && cargoRows[index]['commodity']?.['label'] != ""  && cargoRows[index]['weight'] != ""?
                                      <div className="col-12 px-0">
                                        <table width="100%" className="mt-3">
                                          <tr className="border-bottom">
                                            <th width="5%">Leg</th>
                                            <th width="40%">Vessel</th>
                                            <th width="15%">Operator</th>
                                            <th width="5%">Slot</th>
                                            <th width="5%">FD?</th>
                                            <th width="15%">TSP Port</th>
                                            <th width="10%" className="text-center">Add Vessel</th>
                                          </tr>

                                          {vesselPlanningRows?.[0]?.[index]?.map((row, vessel_index) => (
                                          <tr>
                                            <td>
                                              <span>{vessel_index+1}</span>
                                            </td>

                                            <td>
                                              <span>{row?.vessel_desciption}</span><br></br>
                                              <span className="font-11px">{row?.from?.label} <b>({row?.from_terminal})</b> - {row?.to?.label} <b>({row?.to_terminal})</b></span>
                                            </td>

                                            <td>
                                              <Select
                                                options={operatorList}
                                                id="first_vessel_operator"
                                                name="first_vessel_operator"
                                                onChange={(e) => {
                                                  getSlotRate(index, vessel_index, e)
                                                  console.log("vesselPlanningRows", vesselPlanningRows)
                                                  }
                                                }
                                                isMulti={false}
                                                isClearable
                                                className="w-100"
                                                isDisabled={shipmentExist}
                                                placeholder="Select"
                                                value={vesselPlanningRows[0][index][vessel_index]['operator']}
                                              />
                                            </td>

                                            <td>
                                              <input 
                                                type="number" 
                                                value={Number(vesselPlanningRows[0][index][vessel_index]['slot'])}
                                                className="form-control form-control-sm"
                                                onChange={(e) => {
                                                  vesselPlanningRows[0][index][vessel_index]['slot'] = e.target.value
                                                  refreshRows()
                                                  console.log("SLOT", vesselPlanningRows[0][index][vessel_index]['slot'])
                                                }}>
                                              </input>
                                            </td>

                                            <td>
                                              <select 
                                                className="form form-control"
                                                onChange={(e) => {
                                                  vesselPlanningRows[0][index][vessel_index]['reached_destination'] = e.target.value
                                                  refreshRows()
                                                }}>
                                                <option value="YES">YES</option>
                                                <option value="NO" selected>NO</option>
                                              </select>
                                            </td>

                                            <td>
                                              <Select
                                                options={portList}
                                                id="transhipment_port"
                                                name="transhipment_port"
                                                onChange={(e) => {
                                                  const previous = vesselPlanningRows[0][index][vessel_index]['transhipment_port'];
                                                  vesselPlanningRows[0][index][vessel_index]['transhipment_port'] = e;

                                                  setSelectedTranshipment((prev) => {
                                                    const prevArray = Array.isArray(prev) ? prev : [];

                                                    // If cleared → remove old value
                                                    if (!e) {
                                                      return prevArray.filter(
                                                        (item) => item.value !== previous?.value
                                                      );
                                                    }

                                                    // Remove old value (if changed)
                                                    let updated = prevArray.filter(
                                                      (item) => item.value !== previous?.value
                                                    );

                                                    // Add new value (avoid duplicate)
                                                    if (!updated.some((item) => item.value === e.value)) {
                                                      updated = [...updated, e];
                                                    }

                                                    return updated;
                                                  });

                                                  if(selectedTranshipment.length > 0){
                                                    setSelectedShipmentType({ "value": "VIA", "label": "VIA" })
                                                  }
                                                  else{
                                                    setSelectedShipmentType({ "value": "DIRECT", "label": "DIRECT" })
                                                  }

                                                  console.log("SelectedTranshipment", selectedTranshipment)
                                                  refreshRows()
                                                }}
                                                isMulti={false}
                                                isClearable
                                                className="px-0 w-100"
                                                placeholder="Select"
                                                value={vesselPlanningRows[0][index][vessel_index]['transhipment_port']}
                                                isDisabled={vesselPlanningRows[0][index][vessel_index]['reached_destination']=="YES"?true:false}
                                              />
                                            </td>

                                            <td className="text-center">
                                              <Button
                                                className="btn btn-inox-red ml-1 border-0"
                                                title="Remove Vessel"
                                                onClick={() => removeVesselPlanningRow(index, vessel_index)}
                                                disabled={vessel_index == 0 ? true : false}>
                                                <i className="fa fa-trash"></i>
                                              </Button>

                                              <Button
                                                className="btn btn-inox-green ml-1 border-0"
                                                title="Add Vessel"
                                                disabled={vesselPlanningRows[0][index][vessel_index]['reached_destination']=="YES"?true:false}
                                                onClick={() => {
                                                  addVesselPlanningRow(index, vessel_index)
                                                  setCurrentCargoIndex(index)
                                                  setCurrentVesselLegIndex(vessel_index)
                                                  setAddVesselRouteModal(true)
                                                }}>
                                                <i className="fa fa-plus"></i>
                                              </Button>
                                            </td>
                                          </tr>
                                          ))}
                                        </table>
                                      </div>
                                      :""}
                                    </div>
                                  </form>
                                ))
                              }

                              <div className="row mt-3">
                                <div class="d-flex justify-content-center text-center my-1 px-0">
                                  <button type="button"
                                    className="btn btn-secondary border-0"
                                    style={{ marginRight: 5, width: 200 }}
                                    onClick={() => [
                                      setCargoFormOpen(false),
                                      setCargoRows([{
                                        id: generateId,
                                        container_size: "",
                                        quantity: 1,
                                        weight: 0,
                                        tare_weight: 0,
                                        slot: 0,
                                        export_iso_tank_charge: 0,
                                        export_dg_surcharge: 0,
                                        export_bss_surcharge: 0,
                                        export_transport_charge: 0,
                                        export_iso_tank_charge_expense: 0,
                                        export_dg_surcharge_expense: 0,
                                        export_bss_surcharge_expense: 0,
                                        export_transport_charge_expense: 0,
                                        import_iso_tank_charge: 0,
                                        import_dg_surcharge: 0,
                                        import_bss_surcharge: 0,
                                        import_transport_charge: 0,
                                        import_iso_tank_charge_expense: 0,
                                        import_dg_surcharge_expense: 0,
                                        import_bss_surcharge_expense: 0,
                                        import_transport_charge_expense: 0,
                                        cargo_type: "",
                                        commodity: "",
                                        currency: ""
                                      }]),
                                      setSelectedSlotAgreement(""),
                                      setCargoInputDisabled(false)
                                    ]}>Cancel</button>

                                  <button 
                                    className="btn btn-inox-green border-0 text-white" 
                                    style={{ marginLeft: 5, width: 200 }} 
                                    onClick={() => {
                                      setCargoFormOpen(false)
                                      setCargoInputDisabled(false)

                                      if(shipmentExist){
                                        updateCalculateSlot(updateBookingLineItem, vesselPlanningRows)
                                      }
                                      else{
                                        calculateSlot()
                                      }

                                      if(selectedTranshipment.length > 0){
                                        setSelectedShipmentType({ "value": "VIA", "label": "VIA" })
                                      }
                                      else{
                                        setSelectedShipmentType({ "value": "DIRECT", "label": "DIRECT" })
                                      }
                                    }}>
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div class="p-2 flex-grow-1">
                        <h5 className="fw-bold">Stakeholders</h5>
                        <input
                          ref={triggerStakeholderFormRef}
                          type="text"
                          className="form-control form-control-sm border-0"
                          placeholder="Who is involved?"
                          onClick={handleStakeholderFormClick}
                          disabled={stakeholderInputDisabled}
                        />

                        {!shipmentExist && selectedPrincipal && selectedBookingParty && selectedCustomer ?
                          <div className="pt-3" style={{ fontSize: 12 }}>
                            <span><b>Principal: </b> {selectedPrincipal.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Booking Agent: </b> {selectedBookingAgent.label ?? "None"}</span><br></br>
                            <span><b>Delivery Agent: </b> {selectedDeliveryAgent.label ?? "None"}</span><br></br>
                            <span><b>Booking Party: </b> {selectedBookingParty.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Customer: </b> {selectedCustomer.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Shipper: </b> {shipper ?? "None"}</span>
                          </div>
                          : ""
                        }

                        {shipmentExist ?
                          <div className="pt-3" style={{ fontSize: 12 }}>
                            <span><b>Principal: </b> {updateSelectedPrincipal.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Booking Agent: </b> {updateSelectedBookingAgent.label ?? "None"}</span><br></br>
                            <span><b>Delivery Agent: </b> {updateSelectedDeliveryAgent.label ?? "None"}</span><br></br>
                            <span><b>Booking Party: </b> {updateSelectedBookingParty.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Customer: </b> {updateSelectedCustomer.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Shipper: </b> {updateShipper ?? "None"}</span>
                          </div>
                          : ""
                        }

                        {stakeholderFormOpen && (
                          <div
                            ref={tooltipStakeholderFormRef}
                            className="tooltip-form-container"
                            style={{
                              top: tooltipPosition.top,
                              left: tooltipPosition.left,
                              transform: "translateX(-35%)",
                            }}
                          >
                            <div className="tooltip-arrow" />
                            <div className="tooltip-content px-3" style={{ background: '#FFF' }}>
                              <form className="tooltip-form">
                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Principal</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={principalList}
                                      id="principal"
                                      name="principal"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedPrincipal(e) : setSelectedPrincipal(e)}
                                      value={shipmentExist ? updateSelectedPrincipal : selectedPrincipal}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder={<span>Principal <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customStakeholderValidationStyles}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Booking Agent</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={agentList}
                                      id="booking_agent"
                                      name="booking_agent"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedBookingAgent(e) : setSelectedBookingAgent(e)}
                                      value={shipmentExist ? updateSelectedBookingAgent : selectedBookingAgent}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder="Booking Agent"
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Delivery Agent</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={agentList}
                                      id="delivery_agent"
                                      name="delivery_agent"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedDeliveryAgent(e) : setSelectedDeliveryAgent(e)}
                                      value={shipmentExist ? updateSelectedDeliveryAgent : selectedDeliveryAgent}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder="Delivery Agent"
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Booking Party</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={userList}
                                      id="booking_party"
                                      name="booking_party"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedBookingParty(e) : setSelectedBookingParty(e)}
                                      value={shipmentExist ? updateSelectedBookingParty : selectedBookingParty}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder={<span>Booking Party <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customStakeholderValidationStyles}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Customer</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={customerList}
                                      id="customer"
                                      name="customer"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedCustomer(e) : setSelectedCustomer(e)}
                                      value={shipmentExist ? updateSelectedCustomer : selectedCustomer}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder={<span>Customer <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customStakeholderValidationStyles}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Shipper</div>
                                  <div className="col-12 px-0">
                                    <input type="text"
                                      id="shipper"
                                      name="shipper"
                                      onChange={(e) => shipmentExist ? setUpdateShipper(e.target.value) : setShipper(e.target.value)}
                                      className="form-control flex-grow-1"
                                      placeholder="Shipper"
                                      styles={customStakeholderValidationStyles}
                                      value={shipmentExist ? updateShipper : shipper}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div class="d-flex text-center my-1 px-0">
                                    <button type="button"
                                      className="btn btn-secondary border-0 w-100"
                                      style={{ marginRight: 5 }} onClick={() => [
                                        setStakeholderFormOpen(false),
                                        setShowStakeholderError(false),
                                        setSelectedPrincipal(""),
                                        setSelectedBookingAgent(""),
                                        setSelectedDeliveryAgent(""),
                                        setSelectedBookingParty(""),
                                        setSelectedCustomer(""),
                                        setStakeholderInputDisabled(false)
                                      ]}
                                    >Cancel</button>

                                    <button className="btn btn-inox-green border-0 w-100 text-white" style={{ marginLeft: 5 }} onClick={() => [setStakeholderFormOpen(false), setShowStakeholderError(false), setStakeholderInputDisabled(false)]}>Save</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>

                      <div class="p-2 flex-grow-1">
                        <h5 className="fw-bold">Bill of Lading</h5>
                        <input
                          ref={triggerChargesFormRef}
                          type="text"
                          className="form-control form-control-sm border-0"
                          placeholder="What are the charges?"
                          onClick={handleChargesFormClick}
                          disabled={chargesInputDisabled}
                        />

                        {!shipmentExist && selectedBlType && selectedBlSubType && selectedPaymentType ?
                          <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                            <span><b>BL Type: </b> {selectedBlType.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>BL Sub-Type: </b> {selectedBlSubType.label.replaceAll("_", " ") ?? <span className="text-danger fw-bold">None</span>}</span><br></br>

                            {selectedBlSubType?.value == "SWITCH_BL" ?
                              <><span><b>Switch At: </b> {switchAt.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br></>
                              : ""}

                            <span><b>Payment Type: </b> {selectedPaymentType.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>

                            {selectedPaymentType?.value == "COLLECT" ?
                              <><span><b>Collect At: </b> {collectAt.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br></>
                              : ""}
                          </div>
                          : ""
                        }

                        {shipmentExist ?
                          <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                            <span><b>BL Type: </b> {updateSelectedBlType?.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>BL Sub-Type: </b> {updateSelectedBlSubType?.label.replaceAll("_", " ") ?? <span className="text-danger fw-bold">None</span>}</span><br></br>

                            {updateSelectedBlSubType?.value == "SWITCH_BL" ?
                              <><span><b>Switch At: </b> {updateSwitchAt?.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br></>
                              : ""}

                            <span><b>Payment Type: </b> {updateSelectedPaymentType?.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>

                            {updateSelectedPaymentType?.value == "COLLECT" ?
                              <><span><b>Collect At: </b> {updateCollectAt?.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br></>
                              : ""}
                          </div>
                          : ""
                        }

                        {chargesFormOpen && (
                          <div
                            ref={tooltipChargesFormRef}
                            className="tooltip-form-container"
                            style={{
                              top: tooltipPosition.top,
                              left: tooltipPosition.left,
                              transform: "translateX(-50%)",
                            }}
                          >
                            <div className="tooltip-arrow" />
                            <div className="tooltip-content px-3" style={{ background: '#FFF' }}>
                              <form className="tooltip-form">
                                <div className="row">
                                  <div className="col-7 px-0 font-12px mt-2">BL Type</div>
                                  <div className="col-5 px-1 font-12px mt-2">BL Sub-Type</div>

                                  <div className="col-7 px-0">
                                    <Select
                                      options={blTypeList}
                                      id="bl_type"
                                      name="bl_type"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedBlType(e) : setSelectedBlType(e)}
                                      value={shipmentExist ? updateSelectedBlType : selectedBlType}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1 mr-1"
                                      placeholder={<span>BL Type <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customBlValidationStyles}
                                    />
                                  </div>

                                  <div className="col-5 px-0">
                                    <Select
                                      options={blSubTypeList}
                                      id="bl_sub_type"
                                      name="bl_sub_type"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedBlSubType(e) : setSelectedBlSubType(e)}
                                      value={shipmentExist ? updateSelectedBlSubType : selectedBlSubType}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1 ml-1"
                                      placeholder={<span>BL Sub-Type <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customBlValidationStyles}
                                    />
                                  </div>
                                </div>

                                {shipmentExist && updateSelectedBlSubType?.value == "SWITCH_BL" || selectedBlSubType?.value == "SWITCH_BL" ?
                                  <div className="row">
                                    <div className="col-12 px-0 font-12px mt-2">Switch At</div>
                                    <div className="col-12 px-0">
                                      <Select
                                        options={portList}
                                        id="swith_at"
                                        name="swith_at"
                                        onChange={(e) => shipmentExist ? setUpdateSwitchAt(e) : setSwitchAt(e)}
                                        value={shipmentExist ? updateSwitchAt : switchAt}
                                        isMulti={false}
                                        isClearable
                                        className="px-0 flex-grow-1"
                                        placeholder={<span>Switch At <span style={{ color: 'red' }}>*</span></span>}
                                        styles={customBlValidationStyles}
                                      />
                                    </div>
                                  </div>
                                  : ""}

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Payment Type</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={paymentTypeList}
                                      id="payment_type"
                                      name="payment_type"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedPaymentType(e) : setSelectedPaymentType(e)}
                                      value={shipmentExist ? updateSelectedPaymentType : selectedPaymentType}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder={<span>Payment Type <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customBlValidationStyles}
                                    />
                                  </div>
                                </div>

                                {shipmentExist && updateSelectedPaymentType?.value == "COLLECT" || selectedPaymentType?.value == "COLLECT" ?
                                  <div className="row">
                                    <div className="col-12 px-0 font-12px mt-2">Collect At</div>
                                    <div className="col-12 px-0">
                                      <Select
                                        options={portList}
                                        id="collect_at"
                                        name="collect_at"
                                        onChange={(e) => shipmentExist ? setUpdateCollectAt(e) : setCollectAt(e)}
                                        value={shipmentExist ? updateCollectAt : collectAt}
                                        isMulti={false}
                                        isClearable
                                        className="px-0 flex-grow-1"
                                        placeholder={<span>Collect At <span style={{ color: 'red' }}>*</span></span>}
                                        styles={customBlValidationStyles}
                                      />
                                    </div>
                                  </div>
                                  : ""}

                                {shipmentExist && updateSelectedPaymentType?.value == "COLLECT" || selectedPaymentType?.value == "COLLECT" ?
                                  <div className="row">
                                    <div className="col-12 px-0 font-12px mt-2">On Account</div>
                                    <div className="col-12 px-0">
                                      <Select
                                        options={onAccountList}
                                        id="on_account"
                                        name="on_account"
                                        onChange={(e) => shipmentExist ? setUpdateOnAccount(e) : setOnAccount(e)}
                                        value={shipmentExist ? updateOnAccount : onAccount}
                                        isMulti={false}
                                        isClearable
                                        className="px-0 flex-grow-1"
                                        placeholder={<span>On Account <span style={{ color: 'red' }}>*</span></span>}
                                        styles={customBlValidationStyles}
                                      />
                                    </div>
                                  </div>
                                  : ""}

                                <div className="row">
                                  <div class="d-flex text-center my-1 px-0">
                                    <button type="button"
                                      className="btn btn-secondary border-0 w-100"
                                      style={{ marginRight: 5 }} onClick={() => [
                                        setChargesFormOpen(false),
                                        setShowBlError(false),
                                        setSelectedBlType(""),
                                        setSelectedBlSubType(""),
                                        setSelectedPaymentType(""),
                                        setChargesInputDisabled(false)
                                      ]}>Cancel</button>

                                    <button className="btn btn-inox-green border-0 w-100 text-white" style={{ marginLeft: 5 }} onClick={() => [setChargesFormOpen(false), setShowBlError(false), setChargesInputDisabled(false)]}>Save</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>

                      <div class="p-2 flex-grow-1">
                        <h5 className="fw-bold">Logistic Partners</h5>
                        <input
                          ref={triggerLogisticFormRef}
                          type="text"
                          className="form-control form-control-sm border-0"
                          placeholder="Who is involved?"
                          onClick={handleLogisticFormClick}
                          disabled={logisticInputDisabled}
                        />

                        {!shipmentExist && selectedSalesPerson ?
                          <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                            <span><b>Slot Payment Agent: </b> {selectedSlotPaymentAgent.label ?? "None"}</span><br></br>
                            <span><b>Sales Person: </b> {selectedSalesPerson.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Rate Approved By: </b> {selectedRateApprovedBy.label ?? "None"}</span><br></br>
                            <span><b>Space Confirmed By: </b> {selectedSpaceConfirmedBy.label ?? "None"}</span><br></br>
                          </div>
                          : ""
                        }

                        {shipmentExist ?
                          <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                            <span><b>Slot Payment Agent: </b> {updateSelectedSlotPaymentAgent.label ?? "None"}</span><br></br>
                            <span><b>Sales Person: </b> {updateSelectedSalesPerson.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>Rate Approved By: </b> {updateSelectedRateApprovedBy.label ?? "None"}</span><br></br>
                            <span><b>Space Confirmed By: </b> {updateSelectedSpaceConfirmedBy.label ?? "None"}</span><br></br>
                          </div>
                          : ""
                        }

                        {logisticFormOpen && (
                          <div
                            ref={tooltipLogisticFormRef}
                            className="tooltip-form-container"
                            style={{
                              top: tooltipPosition.top,
                              left: tooltipPosition.left,
                              transform: "translateX(-50%)",
                            }}
                          >
                            <div className="tooltip-arrow" />
                            <div className="tooltip-content px-3" style={{ background: '#FFF' }}>
                              <form className="tooltip-form">
                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Slot Payment Agent</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={agentList}
                                      id="slot_payment_agent"
                                      name="slot_payment_agent"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedSlotPaymentAgent(e) : setSelectedSlotPaymentAgent(e)}
                                      value={shipmentExist ? updateSelectedSlotPaymentAgent : selectedSlotPaymentAgent}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder="Slot Payment Agent"
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Sales Person</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={salesUserList}
                                      id="sales_person"
                                      name="sales_person"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedSalesPerson(e) : setSelectedSalesPerson(e)}
                                      value={shipmentExist ? updateSelectedSalesPerson : selectedSalesPerson}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder={<span>Sales Person <span style={{ color: 'red' }}>*</span></span>}
                                      styles={customLogisticValidationStyles}
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Rate Approved By</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={userList}
                                      id="rate_approved_by"
                                      name="rate_approved_by"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedRateApprovedBy(e) : setSelectedRateApprovedBy(e)}
                                      value={shipmentExist ? updateSelectedRateApprovedBy : selectedRateApprovedBy}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder="Rate Approved By"
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">Space Confirmed By</div>
                                  <div className="col-12 px-0">
                                    <Select
                                      options={userList}
                                      id="space_confirmed_by"
                                      name="space_confirmed_by"
                                      onChange={(e) => shipmentExist ? setUpdateSelectedSpaceConfirmedBy(e) : setSelectedSpaceConfirmedBy(e)}
                                      value={shipmentExist ? updateSelectedSpaceConfirmedBy : selectedSpaceConfirmedBy}
                                      isMulti={false}
                                      isClearable
                                      className="px-0 flex-grow-1"
                                      placeholder="Space Confirmed By"
                                    />
                                  </div>
                                </div>

                                <div className="row">
                                  <div class="d-flex text-center my-1 px-0">
                                    <button type="button"
                                      className="btn btn-secondary border-0 w-100"
                                      style={{ marginRight: 5 }} onClick={() => [
                                        setLogisticFormOpen(false),
                                        setShowLogisticError(false),
                                        setSelectedSlotPaymentAgent(""),
                                        setSelectedSalesPerson(""),
                                        setSelectedRateApprovedBy(""),
                                        setSelectedSpaceConfirmedBy(""),
                                        setLogisticInputDisabled(false)
                                      ]}>Cancel
                                    </button>
                                    <button className="btn btn-inox-green border-0 w-100 text-white" style={{ marginLeft: 5 }} onClick={() => [setLogisticFormOpen(false), setShowLogisticError(false), setLogisticInputDisabled(false)]}>Save</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>

                      <div class="p-2 flex-grow-1" style={{ width: '15%' }}>
                        <h5 className="fw-bold">Free Days</h5>
                        <input
                          ref={triggerHandlingFormRef}
                          type="text"
                          className="form-control form-control-sm border-0"
                          placeholder="Who is involved?"
                          onClick={handleHandlingFormClick}
                          disabled={handlingInputDisabled}
                        />

                        {!shipmentExist && showDefaultPoaPodFreeDays ?
                          <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                            <span><b>POA Detention Free Days: </b> {poaDetentionFreeDays ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POD Detention Free Days: </b> {podDetentionFreeDays ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POA Terminal Storage Free Days: </b> {portStorageFreeDays?.poa_terminal_storage_free_days ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POD Terminal Storage Free Days: </b> {portStorageFreeDays?.pod_terminal_storage_free_days ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            
                            <hr className={`${transhipmentStorageFreeDays.length > 0?"":"display-none"}`}></hr>
                            <span className={`${transhipmentStorageFreeDays.length > 0?"":"display-none"}`}><b>Trashipment Terminal Free Days: </b> </span>
                            {transhipmentStorageFreeDays && transhipmentStorageFreeDays.map(transhipment_storage => (
                              <p className="mb-0">
                                {transhipment_storage?.['terminal_data']?.['port_data']?.['name']} <b>({transhipment_storage?.['terminal_data']?.['name']})</b>: {transhipment_storage?.['param_value']}
                              </p>
                            ))}
                          </div>
                          : ""
                        }

                        {shipmentExist ?
                          <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                            <span><b>POA Detention Free Days: </b> {updatePoaDetentionFreeDays ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POD Detention Free Days: </b> {updatePodDetentionFreeDays ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <hr className="my-1"></hr>
                            <span><b>POA Terminal Storage Free Days: </b> {updatePoaTerminalStorageFreeDays ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                            <span><b>POD Terminal Storage Free Days: </b> {updatePodTerminalStorageFreeDays ?? <span className="text-danger fw-bold">None</span>}</span><br></br>

                            <hr className={`${transhipmentStorageFreeDays.length > 0?"":"display-none"}`}></hr>
                            <span className={`${transhipmentStorageFreeDays.length > 0?"":"display-none"}`}><b>Trashipment Terminal Free Days: </b> </span>
                            {transhipmentStorageFreeDays && transhipmentStorageFreeDays.map(transhipment_storage => (
                              <p className="mb-0">
                                {transhipment_storage?.['terminal_data']?.['port_data']?.['name']} <b>({transhipment_storage?.['terminal_data']?.['name']})</b>: {transhipment_storage?.['param_value']}
                              </p>
                            ))}
                          
                          </div>
                          : ""
                        }

                        {handlingFormOpen && (
                          <div
                            ref={tooltipHandlingFormRef}
                            className="tooltip-form-free_days-container"
                            style={{
                              top: tooltipPosition.top,
                              left: tooltipPosition.left,
                              transform: "translateX(-35%)",
                            }}
                          >
                            <div className="tooltip-arrow" />
                            <div className="tooltip-content px-3" style={{ background: '#FFF' }}>
                              <form className="tooltip-form">
                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">POA Detention Free Days</div>
                                  <div className="col-12 px-0">
                                    {!shipmentExist ?
                                      <input
                                        type="number"
                                        placeholder="POA Detention Free Days"
                                        name="poa_detention_free_days"
                                        onChange={(e) => {
                                          setPoaDetentionFreeDays(e.target.value)
                                          if (e.target.value == "") {
                                            setPoaDetentionFreeDaysError(true)
                                          }
                                        }}
                                        className={`${poaDetentionFreeDaysError ? 'border-danger' : ''}`}
                                        value={poaDetentionFreeDays}
                                      />
                                      :
                                      <input
                                        type="number"
                                        placeholder="POA Detention Free Days"
                                        name="poa_detention_free_days"
                                        onChange={(e) => {
                                          setUpdatePoaDetentionFreeDays(e.target.value)
                                          if (e.target.value == "") {
                                            setUpdatePoaDetentionFreeDaysError(true)
                                          }
                                        }}
                                        className={`${updatePoaDetentionFreeDaysError ? 'border-danger' : ''}`}
                                        value={updatePoaDetentionFreeDays}
                                      />
                                    }
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 px-0 font-12px mt-2">POD Detention Free Days</div>
                                  <div className="col-12 px-0">
                                    {!shipmentExist ?
                                      <input
                                        type="number"
                                        placeholder="POD Detention Free Days"
                                        name="pod_free_days"
                                        onChange={(e) => {
                                          setPodDetentionFreeDays(e.target.value)
                                          if (e.target.value == "") {
                                            setPodDetentionFreeDaysError(true)
                                          }
                                        }}
                                        className={`${podDetentionFreeDaysError ? 'border-danger' : ''}`}
                                        value={podDetentionFreeDays}
                                      />
                                      :
                                      <input
                                        type="number"
                                        placeholder="POD Detention Free Days"
                                        name="pod_free_days"
                                        onChange={(e) => {
                                          setUpdatePodDetentionFreeDays(e.target.value)
                                          if (e.target.value == "") {
                                            setUpdatePodDetentionFreeDaysError(true)
                                          }
                                        }}
                                        className={`${updatePodDetentionFreeDaysError ? 'border-danger' : ''}`}
                                        value={updatePodDetentionFreeDays}
                                      />
                                    }
                                  </div>
                                </div>

                                <div className="row">
                                  <div class="d-flex text-center my-1 px-0">
                                    <button type="button"
                                      className="btn btn-secondary border-0 w-100"
                                      style={{ marginRight: 5 }} onClick={() => [
                                        setHandlingFormOpen(false),
                                        setPoaDetentionFreeDays(7),
                                        setPodDetentionFreeDays(14),
                                        setHandlingInputDisabled(false),
                                        setShowDefaultPoaPodFreeDays(false)
                                      ]}>Cancel</button>

                                    <button className="btn btn-inox-green border-0 w-100 text-white"
                                      style={{ marginLeft: 5 }}
                                      onClick={() => [
                                        setHandlingFormOpen(false),
                                        setHandlingInputDisabled(false),
                                        setShowDefaultPoaPodFreeDays(true)
                                      ]}>Save</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>

                      <div class="p-2">
                        <Button className="btn btn-inox-green btn-sm border-0" style={{ marginTop: 30 }} onClick={() => getTariffCharges()}
                          disabled={enableSearchButton ? false : true}>
                          <i className="fa fa-search"></i>
                        </Button>
                      </div>
                    </div>
                  </div>

                  <Modal size="lg" show={addVesselRouteModal} onHide={() => setAddVesselRouteModal(false)} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>Add Vessel</Modal.Title>
                    </Modal.Header>
                    
                    <Modal.Body>
                      <div className="row">
                        <div className="col-3">
                          From Port:
                          <Select
                            options={portList}
                            id="vessel_leg_from_port"
                            name="vessel_leg_from_port"
                            onChange={(e) => {
                              handleCargoFormClick()
                              setVesselLegFromPort(e)
                              getVesselLegSchedule(e, null)
                              console.log("vesselPlanningRows FROOOOOOM *********", vesselPlanningRows)
                            }}
                            isMulti={false}
                            isClearable
                            className="px-0 w-100"
                            placeholder="Select"
                            value={vesselPlanningRows?.[0]?.[currentCargoIndex]?.[currentVesselLegIndex]?.['to']}
                          />
                        </div>

                        <div className="col-3">
                          To Port:
                          <Select
                            options={portList}
                            id="vessel_leg_to_port"
                            name="vessel_leg_to_port"
                            onChange={(e) => {
                              handleCargoFormClick()
                              setVesselLegToPort(e)
                              getVesselLegSchedule(vesselLegFromPort, e)
                              setEnableSearchButton(true)
                              console.log("vesselPlanningRows TOOOOOOOOO *********", vesselPlanningRows)
                            }}
                            isMulti={false}
                            isClearable
                            className="px-0 w-100"
                            placeholder="Select"
                          />
                        </div>

                        <div className="col-6">
                          Vessel:
                          <Select
                            options={vesselScheduleList}
                            id="vessel_leg_to_port"
                            name="vessel_leg_to_port"
                            onChange={(e) => {
                              handleCargoFormClick()
                              setVesselLegSchedule(e)
                            }}
                            isMulti={false}
                            isClearable
                            className="px-0 w-100"
                            placeholder="Select"
                          />
                        </div>
                      </div>
                    </Modal.Body>
                    
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => {
                                                                  handleCargoFormClick()
                                                                  setAddVesselRouteModal(false)
                                                                }}>Close</Button>
                      <Button className="btn-inox-green border-0" onClick={(e) => {
                                                                                    handleCargoFormClick()
                                                                                    addNewVesselToRoute(e)
                                                                                  }}>
                        {showAddNewVesselToRouteLoader ?
                          <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          :
                          "Add"
                        }

                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <div class="col-12 mt-3 px-0" style={{ marginLeft: 18 }}>
                    {!shipmentExist ?
                      <textarea class="form-control"
                        onChange={(e) => setRemarks(e.target.value)}
                        rows="3"
                        placeholder="Add remarks or specific request for the booking">
                      </textarea>
                      :
                      <textarea class="form-control"
                        onChange={(e) => setUpdateRemarks(e.target.value)}
                        value={updateRemarks}
                        rows="3"
                        placeholder="Add remarks or specific request for the booking">
                      </textarea>
                    }
                  </div>

                  <div class="col-12 mt-3 mb-5 px-0" style={{ marginLeft: 18 }}>
                    <div className="flex-grow-1">
                      <Accordion defaultActiveKey={['0']} alwaysOpen>
                        {shipmentExist ?
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>KYC Documents</Accordion.Header>
                            <Accordion.Body>
                              <div>
                                <form>
                                  <div className="row">
                                    <div class="form-group col-md-2 text-left mb-4">
                                      <input type="file"
                                        class="form-control form-control-sm"
                                        id="uploads"
                                        name="uploads"
                                        accept="image/*, .pdf"
                                        ref={shipmentUploadFileInputRef}
                                        onChange={(e) => handleUploadsFileChange(e.target.files)}
                                        multiple />
                                    </div>

                                    <div class="form-group col-md-10 text-left mb-4">
                                      <Button className="btn-inox-green border-0 btn-sm" onClick={(e) => addDraftbookingUploads(e)} disabled={uploadFiles?.length < 1 ? true : false}>
                                        {showUploadFilesLoader ?
                                          <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                          :
                                          <span className="px-1">Upload</span>
                                        }
                                      </Button>
                                    </div>
                                  </div>

                                  {uploadFiles?.target?.files}
                                  {uploadFiles?.length > 0 ?
                                    <div className="row">
                                      <div className="col-12" style={{ fontSize: 12, textAlign: 'left' }}>
                                        <table width={'100%'}>
                                          <tr>
                                            <th>Sr. No.</th>
                                            <th>Preview</th>
                                            <th>File Name</th>
                                            <th>File Size</th>
                                            <th>File Type</th>
                                            <th>Document Type</th>
                                            <th>Action</th>
                                          </tr>

                                          {uploadFiles?.map((upload, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>
                                                {upload.file.type === 'application/pdf' ?
                                                  <iframe src={upload?.previewUrl} style={{ width: '120px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} />
                                                  :
                                                  <img src={upload?.previewUrl} style={{ width: '120px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} />
                                                }
                                              </td>
                                              <td>{upload.file.name}</td>
                                              <td>{(upload.file.size / 1024).toFixed(2)} KB</td>
                                              <td>{upload.file.type}</td>
                                              <td>
                                                <select className="form-control form-select-sm w-50" onChange={(e) => setCustomCategoryToDocument(upload, e.target.value)}>
                                                  <option value="">Select Document Type</option>
                                                  <option value="AADHAR_CARD">AADHAR CARD</option>
                                                  <option value="ADDRESS">ADDRESS</option>
                                                  <option value="AFTER_DESTUFFING">AFTER DESTUFFING</option>
                                                  <option value="AFTER_STUFFING">AFTER STUFFING</option>
                                                  <option value="AGREEMENT">AGREEMENT</option>
                                                  <option value="APPRAISAL_LETTER">APPRAISAL LETTER</option>
                                                  <option value="BEFORE_DESTUFFING">BEFORE DESTUFFING</option>
                                                  <option value="BEFORE_STUFFING">BEFORE STUFFING</option>
                                                  <option value="BL_COPY">BL COPY</option>
                                                  <option value="BOND_LETTER">BOND LETTER</option>
                                                  <option value="CHA__LOA_AUTHORITY_LETTER">CHA / LOA AUTHORITY LETTER</option>
                                                  <option value="CHARGER">CHARGER</option>
                                                  <option value="CLA_SAFFLA">CLA/SAFFLA</option>
                                                  <option value="COMMUNICATION_LETTER">COMMUNICATION LETTER</option>
                                                  <option value="CONNECTOR">CONNECTOR</option>
                                                  <option value="CONTAINER_PHOTO">CONTAINER PHOTO</option>
                                                  <option value="COUNSELLING_LETTER">COUNSELLING LETTER</option>
                                                  <option value="CUSTOM_DOCUMENTS">CUSTOM DOCUMENTS</option>
                                                  <option value="CV">CV</option>
                                                  <option value="DAMAGE_PIC">DAMAGE PIC</option>
                                                  <option value="EXPERIENCE_LETTER">EXPERIENCE LETTER</option>
                                                  <option value="EXPORT_PERMIT">EXPORT PERMIT</option>
                                                  <option value="FIRST_ORIGINAL">FIRST ORIGINAL</option>
                                                  <option value="FORM_16">FORM 16</option>
                                                  <option value="GST">GST</option>
                                                  <option value="HAZ_DOCS">HAZ DOCS</option>
                                                  <option value="HSS_AGREEMENT">HSS AGREEMENT</option>
                                                  <option value="IAL_COPY">IAL COPY</option>
                                                  <option value="IAuthority_Letter">IAuthority Letter</option>
                                                  <option value="IEC_COPY">IEC COPY</option>
                                                  <option value="IMPORT_PERMIT">IMPORT PERMIT</option>
                                                  <option value="ITR">ITR</option>
                                                  <option value="KYC">KYC</option>
                                                  <option value="LAPTOP">LAPTOP</option>
                                                  <option value="LOA_LETTER">LOA LETTER</option>
                                                  <option value="OTHER_IMPORT_DOCS">OTHER IMPORT DOCS</option>
                                                  <option value="OTHERS">OTHERS</option>
                                                  <option value="PAN">PAN</option>
                                                  <option value="PAYMENT_DETAILS">PAYMENT DETAILS</option>
                                                  <option value="POL_BL">POL BL</option>
                                                  <option value="POST_REPAIR_PIC">POST REPAIR PIC</option>
                                                  <option value="REPAIR_CYCLE_CHAT_UPLOAD">REPAIR CYCLE CHAT UPLOAD</option>
                                                  <option value="REPAIR_CYCLE_UPLOAD">REPAIR CYCLE UPLOAD</option>
                                                  <option value="REPAIR_TARIFF">REPAIR TARIFF</option>
                                                  <option value="RR_COPY">RR COPY</option>
                                                  <option value="SALARY_SLIP">SALARY SLIP</option>
                                                  <option value="SECOND_ORIGINAL">SECOND ORIGINAL</option>
                                                  <option value="SHIPPING_BILL">SHIPPING BILL</option>
                                                  <option value="SIGNED_EXPRESS_BL">SIGNED EXPRESS BL</option>
                                                  <option value="SIGNED_FIRST_ORIGINAL">SIGNED FIRST ORIGINAL</option>
                                                  <option value="SIGNED_SECOND_ORIGINAL">SIGNED SECOND ORIGINAL</option>
                                                  <option value="SIGNED_SEAWAY_BL">SIGNED SEAWAY BL</option>
                                                  <option value="SIGNED_SURRRENDER_BL">SIGNED SURRENDER BL</option>
                                                  <option value="SIGNED_THIRD_ORIGINAL">SIGNED THIRD ORIGINAL</option>
                                                  <option value="SLOT_INVOICE">SLOT INVOICE</option>
                                                  <option value="SMTP_COPY">SMTP COPY</option>
                                                  <option value="SOP">SOP</option>
                                                  <option value="STUFFING_REPORT">STUFFING REPORT</option>
                                                  <option value="TAN">TAN</option>
                                                  <option value="THIRD_ORIGINAL">THIRD ORIGINAL</option>
                                                  <option value="UNDERTAKING_LOI">UNDERTAKING/LOI</option>
                                                  <option value="VGM">VGM</option>
                                                  <option value="WARNING_LETTER">WARNING LETTER</option>
                                                </select>
                                              </td>
                                              <td>
                                                <Button className="btn btn-sm btn-danger" onClick={() => removeDocument(index)}>
                                                  <i className="fa fa-trash" title="Remove"></i>
                                                </Button>
                                              </td>
                                            </tr>
                                          ))}
                                        </table>
                                      </div>
                                    </div>
                                    : ""}
                                </form>


                                {updateShipmentUploads?.length > 0 ?
                                  <DataTable
                                    columns={shipmentuploadcolumns}
                                    data={updateShipmentUploads}
                                    progressPending={shipmentUploadDataPending}
                                    progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                    noDataComponent={<p className="text-center table-no-data">No Uploads Found</p>}
                                    pagination
                                    paginationPerPage={shipmentUploadsPerPage}
                                    paginationRowsPerPageOptions={[5, 10, 20, 50]}
                                    onChangeRowsPerPage={(currentRowsPerPage) => setShipmentUploadsPerPage(currentRowsPerPage)}
                                    highlightOnHover
                                    fixedHeader
                                    customStyles={shipmentUploadsTableCustomStyles}
                                    dense
                                  />
                                  :
                                  ""
                                }

                                <Modal size="md" show={deleteShippingUploadModal} onHide={() => setDeleteShippingUploadModal(false)} centered>
                                  <Modal.Header closeButton>
                                    <Modal.Title>Delete <span style={{ fontSize: 10 }}>({deleteUploadFileName})</span></Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>Do you want to delete this file?</Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setDeleteShippingUploadModal(false)}>Close</Button>
                                    <Button variant="danger" onClick={(e) => deleteShippingUploads(e)}>
                                      {showDeleteUploadFilesLoader ?
                                        <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        :
                                        "Delete"
                                      }

                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                          :
                          <></>
                        }

                        {shipmentExist && updateBookingLineItem.some(item => item.cargo_type == 'HAZARDOUS') ?
                          <Accordion.Item eventKey="1">
                            <Accordion.Header>
                              Hazardous Documents
                            </Accordion.Header>
                            <Accordion.Body>
                              <div class="d-flex mb-3">
                                <div style={{ width: "90%" }}>
                                  <ul class="nav nav-tabs" id="hazardous_documents_tabs" role="tablist">
                                    <li class="nav-item" role="presentation">
                                      <button class="nav-link active text-inox-green" id="haz-documents-tab" data-bs-toggle="tab" data-bs-target="#haz-documents" type="button" role="tab" aria-controls="profile" aria-selected="false">Documents</button>
                                    </li>

                                    {loggedInUser?.role_array?.includes("superadmin") ?
                                      <li class="nav-item" role="presentation">
                                        <button class="nav-link text-inox-green" id="haz-class-tab" data-bs-toggle="tab" data-bs-target="#haz-class" type="button" role="tab" aria-controls="haz-class" aria-selected="true">Class Information</button>
                                      </li>
                                      : ""}

                                    {loggedInUser?.role_array?.includes("superadmin") && updateShipmentHazardousClassInformation.length > 0 && updateShipmentHazardousUploads.length > 1 ?
                                      <li class="nav-item" role="presentation">
                                        <button class="nav-link text-inox-green" id="haz-request-tab" data-bs-toggle="tab" data-bs-target="#haz-request" type="button" role="tab" aria-controls="contact" aria-selected="false">Request</button>
                                      </li>
                                      : ""}
                                  </ul>
                                </div>
                                <div class="ms-auto">
                                  {updateShipmentHazardousUploads?.length > 1 ?
                                    <Button className="btn-success border-0 btn-sm" onClick={() => setShowHazardousEmailModal(true)}>
                                      <span className="px-1">Send Email</span>
                                    </Button>
                                    :
                                    ""}
                                </div>
                              </div>

                              <div class="tab-content" id="hazardous_documents_tabs_content">
                                <div class="tab-pane fade" id="haz-class" role="tabpanel" aria-labelledby="haz-class-tab">
                                  <form ref={shipmentHazardousClassFormRef} onSubmit={(e) => addDraftbookingHazardousClassInformation(e)}>
                                    <div class="d-flex align-content-end flex-wrap">
                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_class" class="col-sm-12 col-form-label font-12px">Class</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_class" name="haz_class" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_un_number" class="col-sm-12 col-form-label font-12px">UN No</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_un_number" name="haz_un_number" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_packaging_group" class="col-sm-12 col-form-label font-12px">Packaging Group</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_packaging_group" name="haz_packaging_group" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_ems_group" class="col-sm-12 col-form-label font-12px">EMS/PSA Group</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_ems_group" name="haz_ems_group" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_marine_pollutant" class="col-sm-12 col-form-label font-12px">Marine Pollutant</label>
                                          <div class="col-sm-11">
                                            <select class="form form-select form-select-sm" id="haz_marine_pollutant" name="haz_marine_pollutant">
                                              <option value="YES">YES</option>
                                              <option value="NO">NO</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_flash_point" class="col-sm-12 col-form-label font-12px">Flash Point</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_flash_point" name="haz_flash_point" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_segregation_group" class="col-sm-12 col-form-label font-12px">Segregation Group</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_segregation_group" name="haz_segregation_group" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_un_packing_code" class="col-sm-12 col-form-label font-12px">UN Packing Code</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_un_packing_code" name="haz_un_packing_code" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <div class="form-group mb-2">
                                          <label for="haz_sub_risk_label" class="col-sm-12 col-form-label font-12px">Sub Risk Label</label>
                                          <div class="col-sm-11">
                                            <input type="text" class="form form-control form-control-sm" id="haz_sub_risk_label" name="haz_sub_risk_label" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex-fill" style={{ width: "10%" }}>
                                        <Button type="submit" className="btn btn-sm btn-success" style={{ marginTop: 30, float: 'right', width: 100 }} >
                                          <i className="fa fa-plus mr-2"></i>Add
                                        </Button>
                                      </div>
                                    </div>
                                  </form>

                                  {updateShipmentHazardousClassInformation?.length > 0 ?
                                    <DataTable
                                      columns={shipmenthazardousclasscolumns}
                                      data={updateShipmentHazardousClassInformation}
                                      progressPending={shipmentHazardousClassDataPending}
                                      progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                      noDataComponent={<p className="text-center table-no-data">No Class Data Found</p>}
                                      pagination
                                      paginationPerPage={shipmentUploadsPerPage}
                                      paginationRowsPerPageOptions={[5, 10, 20, 50]}
                                      onChangeRowsPerPage={(currentRowsPerPage) => setShipmentUploadsPerPage(currentRowsPerPage)}
                                      highlightOnHover
                                      fixedHeader
                                      customStyles={hazardousDataTableCustomStyles}
                                      dense
                                    />
                                    :
                                    ""
                                  }

                                  <Modal size="md" show={showDeleteHazardousClassInformationModal} onHide={() => setShowDeleteHazardousClassInformationModal(false)} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Delete </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>Do you want to delete this class information?</Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => setShowDeleteHazardousClassInformationModal(false)}>Close</Button>
                                      <Button variant="danger" onClick={(e) => deleteShippingHazardousClassInformation(e)}>
                                        {showDeleteHazardousClassInformationLoader ?
                                          <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                          :
                                          "Delete"
                                        }
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>

                                  <Modal size="xl" show={showUpdateHazardousClassInformationModal} onHide={() => setShowUpdateHazardousClassInformationModal(false)} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Update </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <form>
                                        <div class="d-flex align-content-end flex-wrap">
                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_class" class="col-sm-12 col-form-label font-12px">Class</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_class" name="haz_class" value={updateHazardousClass} onChange={(e) => setUpdateHazardousClass(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_un_number" class="col-sm-12 col-form-label font-12px">UN No</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_un_number" name="haz_un_number" value={updateHazardousUnNumber} onChange={(e) => setUpdateHazardousUnNumber(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_packaging_group" class="col-sm-12 col-form-label font-12px">Packaging Group</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_packaging_group" name="haz_packaging_group" value={updateHazardousPackagingGroup} onChange={(e) => setUpdateHazardousPackagingGroup(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_ems_group" class="col-sm-12 col-form-label font-12px">EMS/PSA Group</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_ems_group" name="haz_ems_group" value={updateHazardousEmsGroup} onChange={(e) => setUpdateHazardousEmsGroup(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_marine_pollutant" class="col-sm-12 col-form-label font-12px">Marine Pollutant</label>
                                              <div class="col-sm-11">
                                                <select class="form form-select form-select-sm" id="haz_marine_pollutant" name="haz_marine_pollutant" value={updateHazardousMarinePollutant} onChange={(e) => setUpdateHazardousMarinePollutant(e.target.value)}>
                                                  <option value="YES">YES</option>
                                                  <option value="NO">NO</option>
                                                </select>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_flash_point" class="col-sm-12 col-form-label font-12px">Flash Point</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_flash_point" name="haz_flash_point" value={updateHazardousFlashPoint} onChange={(e) => setUpdateHazardousFlashPoint(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_segregation_group" class="col-sm-12 col-form-label font-12px">Segregation Group</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_segregation_group" name="haz_segregation_group" value={updateHazardousSegregationGroup} onChange={(e) => setUpdateHazardousSegregationGroup(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_un_packing_code" class="col-sm-12 col-form-label font-12px">UN Packing Code</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_un_packing_code" name="haz_un_packing_code" value={updateHazardousUnPackingCode} onChange={(e) => setUpdateHazardousUnPackingCode(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_sub_risk_label" class="col-sm-12 col-form-label font-12px">Sub Risk Label</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_sub_risk_label" name="haz_sub_risk_label" value={updateHazardousSubRiskLabel} onChange={(e) => setUpdateHazardousSubRiskLabel(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => setShowUpdateHazardousClassInformationModal(false)}>Close</Button>
                                      <Button variant="success" onClick={(e) => updateShippingHazardousClassInformation(e)}>
                                        {showUpdateHazardousClassInformationLoader ?
                                          <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                          :
                                          "Update"
                                        }
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </div>

                                <div class="tab-pane fade show active" id="haz-documents" role="tabpanel" aria-labelledby="haz-documents-tab">
                                  <div>
                                    <form>
                                      <div className="row">
                                        <div class="form-group col-md-2 text-left mb-4">
                                          <input type="file"
                                            class="form-control form-control-sm"
                                            id="hazardousuploads"
                                            name="hazardousuploads"
                                            accept=".pdf, .xlsx, .xls"
                                            ref={shipmentHazardousUploadFileInputRef}
                                            onChange={(e) => handleHazardousUploadsFileChange(e)}
                                            multiple
                                          />
                                        </div>

                                        <div class="form-group col-md-3 text-left mb-4">
                                          <Button className="btn-inox-green border-0 btn-sm" onClick={(e) => addDraftbookingHazardousUploads(e)} disabled={hazardousUploadFiles?.length < 1 ? true : false}>
                                            {showHazardousUploadFilesLoader ?
                                              <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                              :
                                              <span className="px-1">Upload</span>
                                            }
                                          </Button>

                                          <a href="/DG_FORMAT.xls" download="DG_FORMAT.xls">
                                            <Button className="btn btn-success btn-sm mx-3" title="Download DG Format">
                                              <i className="fa fa-file-excel-o"></i>
                                            </Button>
                                          </a>
                                        </div>

                                        {
                                          hazardousDocumentData?.['Product Name'] ?
                                            <div class="form-group col-md-8 text-left mb-4">
                                              <Button className="btn-secondary border-0 btn-sm" onClick={() => setShowHazardousDataModal(true)}>
                                                <span className="px-1">View Data</span>
                                              </Button>
                                            </div>
                                            :
                                            ""
                                        }

                                        {/* <Modal size="lg" show={showHazardousDataModal} onHide={() => setShowHazardousDataModal(false)} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Hazardous Document Details </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <table>
                                        <tr>
                                          <td className="fw-bold">Product Name</td>
                                          <td>{hazardousDocumentData?.['Product Name'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">IMO Class</td>
                                          <td>{hazardousDocumentData?.['IMO Class'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">UNNO No.</td>
                                          <td>{hazardousDocumentData?.['UNNO No.'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">IMDG Page No.</td>
                                          <td>{hazardousDocumentData?.['IMDG Page No.'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">Sub Risk Label</td>
                                          <td>{hazardousDocumentData?.['Sub Risk Label'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">Packing Group</td>
                                          <td>{hazardousDocumentData?.['Packing Group'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">EMS / PSA Group</td>
                                          <td>{hazardousDocumentData?.['EMS / PSA Group'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">Marine Pollutant</td>
                                          <td>{hazardousDocumentData?.['Marine Pollutant'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">Flash Point</td>
                                          <td>{hazardousDocumentData?.['Flash Point'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold">UN PACKING CODE</td>
                                          <td>{hazardousDocumentData?.['UN Packing Type Codes']? 
                                          hazardousDocumentData?.['UN Packing Type Codes'].map(code => <><span>{code}</span><br></br></>): <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>

                                        <tr>
                                          <td className="fw-bold" style={{ paddingRight: 40 }}>SEGREGATION GROUP</td>
                                          <td>{hazardousDocumentData?.['SEGREGATION GROUP'] ?? <span className="text-danger fw-bold">-</span>}</td>
                                        </tr>
                                      </table>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => setShowHazardousDataModal(false)}>Close</Button>
                                    </Modal.Footer>
                                  </Modal> */}


                                        <Modal size="xl" show={showHazardousEmailModal} onHide={() => setShowHazardousEmailModal(false)} centered>
                                          <Modal.Header closeButton>
                                            <Modal.Title>Send Email to Operator</Modal.Title>
                                          </Modal.Header>
                                          <Modal.Body>
                                            <form>
                                              <div class="form-group row mb-2">
                                                <label for="operator_email" class="col-sm-2 col-form-label">Email:</label>
                                                <div class="col-sm-10">
                                                  <input type="email" class="form form-control" id="operator_email" value={updateSlotOperatorEmail} onChange={(e) => setUpdateSlotOperatorEmail(e.target.value)} />
                                                </div>
                                              </div>

                                              <div class="form-group row mb-2">
                                                <label for="email_subject" class="col-sm-2 col-form-label">Subject:</label>
                                                <div class="col-sm-10">
                                                  <input type="text" class="form form-control" id="email_subject" value={updateEmailSubject} onChange={(e) => setUpdateEmailSubject(e.target.value)} />
                                                </div>
                                              </div>

                                              <div class="form-group row mb-2">
                                                <label for="email_message" class="col-sm-2 col-form-label">Message:</label>
                                                <div class="col-sm-10">
                                                  <CKEditor
                                                    editor={ClassicEditor}
                                                    id="email_message"
                                                    data={updateEmailMessage}
                                                    onChange={(event, editor) => {
                                                      const data = editor.getData();
                                                      setUpdateEmailMessage(data);
                                                    }}
                                                    config={{
                                                      toolbar: [
                                                        'heading', '|',
                                                        'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                                                        'undo', 'redo', 'sourceEditing'
                                                      ]
                                                    }}
                                                  />
                                                </div>
                                              </div>

                                              <div class="form-group row mb-2">
                                                <label for="email_attachment" class="col-sm-2 col-form-label">Attachment:</label>
                                                <div class="col-sm-10">
                                                  <div class="d-flex bd-highlight mb-3">
                                                    {updateShipmentHazardousUploads.map(document => (
                                                      <div class="py-2 bd-highlight" style={{ paddingRight: 10 }}>
                                                        <a href={`${document?.file}`} target="_blank">
                                                          {document?.file_type == 'application/pdf' ?
                                                            <img className="img" style={{ border: '1px solid lightgrey' }} src={`${document?.screenshot}`} width={100} title={document?.document_category.replaceAll("_", " ")}></img>
                                                            :
                                                            document?.file_type == 'application/vnd.ms-excel' | document?.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ?
                                                              <img src={ExcelIcon} style={{ width: '100px', height: '100%', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} title={document?.document_category.replaceAll("_", " ")} />
                                                              :
                                                              <img className="img" style={{ border: '1px solid lightgrey' }} src={`${document?.file}`} width={100} title={document?.document_category.replaceAll("_", " ")}></img>
                                                          }
                                                        </a>
                                                      </div>
                                                    ))}
                                                  </div>
                                                </div>
                                              </div>
                                            </form>
                                          </Modal.Body>
                                          <Modal.Footer>
                                            <Button variant="success" onClick={(e) => sendHazardousDocumentEmail(e)}>
                                              {showSendHazardousDocumentEmailLoader ?
                                                <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                :
                                                <span className="px-1">Send</span>
                                              }
                                            </Button>
                                            <Button variant="secondary" onClick={() => setShowHazardousEmailModal(false)}>Close</Button>
                                          </Modal.Footer>
                                        </Modal>
                                      </div>

                                      {hazardousUploadFiles?.target?.files}
                                      {hazardousUploadFiles?.length > 0 ?
                                        <div className="row">
                                          <div className="col-12" style={{ fontSize: 12, textAlign: 'left' }}>
                                            <table width={'100%'}>
                                              <tr>
                                                <th style={{ paddingBottom: 20 }}>Sr. No.</th>
                                                <th style={{ paddingBottom: 20 }}>Preview</th>
                                                <th style={{ paddingBottom: 20 }}>File Name</th>
                                                <th style={{ paddingBottom: 20 }}>File Size</th>
                                                <th style={{ paddingBottom: 20 }}>File Type</th>
                                                <th style={{ paddingBottom: 20 }}>Document Type</th>
                                                <th style={{ paddingBottom: 20 }}>Status</th>
                                                <th style={{ paddingBottom: 20 }}>Remarks</th>
                                                <th style={{ paddingBottom: 20 }}>Action</th>
                                              </tr>

                                              {hazardousUploadFiles?.map((upload, index) => (
                                                <tr>
                                                  <td>{index + 1}</td>

                                                  <td>
                                                    {upload.file.type === 'application/pdf' ?
                                                      <iframe src={upload?.previewUrl} style={{ width: '120px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} />
                                                      :
                                                      upload.file.type === 'application/vnd.ms-excel' | upload.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ?
                                                        <img src={ExcelIcon} style={{ width: '120px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} />
                                                        :
                                                        <img src={upload?.previewUrl} style={{ width: '120px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} />
                                                    }
                                                  </td>

                                                  <td style={{ width: "200px" }}>
                                                    <p style={{ width: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 0 }}>
                                                      {upload.file.name}
                                                    </p>
                                                  </td>

                                                  <td>{(upload.file.size / 1024).toFixed(2)} KB</td>

                                                  <td>{upload.file.type}</td>

                                                  <td style={{ width: '250px', paddingRight: 20 }}>
                                                    <select className="form-control form-select-sm" onChange={(e) => setHazardousCategoryToDocument(upload, e.target.value)}>
                                                      <option value="">Select Document Type</option>
                                                      <option value="SDS_SHEET">Safety Data Sheet</option>
                                                      <option value="UN_PACKAGING">UN Certificate of Packaging</option>
                                                      <option value="DG_FORMAT">DG FORMAT</option>
                                                    </select>
                                                  </td>

                                                  <td>
                                                    <Button className="btn btn-sm btn-danger" onClick={() => removeHazardousDocument(index)}>
                                                      <i className="fa fa-trash" title="Remove"></i>
                                                    </Button>
                                                  </td>
                                                </tr>
                                              ))}
                                            </table>
                                          </div>
                                        </div>
                                        : ""}
                                    </form>


                                    {updateShipmentHazardousUploads?.length > 0 ?
                                      <DataTable
                                        columns={shipmenthazardousuploadcolumns}
                                        data={updateShipmentHazardousUploads}
                                        progressPending={shipmentHazardousUploadDataPending}
                                        progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                        noDataComponent={<p className="text-center table-no-data">No Uploads Found</p>}
                                        pagination
                                        paginationPerPage={shipmentUploadsPerPage}
                                        paginationRowsPerPageOptions={[5, 10, 20, 50]}
                                        onChangeRowsPerPage={(currentRowsPerPage) => setShipmentUploadsPerPage(currentRowsPerPage)}
                                        highlightOnHover
                                        fixedHeader
                                        customStyles={shipmentUploadsTableCustomStyles}
                                        dense
                                      />
                                      :
                                      ""
                                    }

                                    <Modal size="md" show={deleteShippingHazardousUploadModal} onHide={() => setDeleteShippingHazardousUploadModal(false)} centered>
                                      <Modal.Header closeButton>
                                        <Modal.Title>Delete <span style={{ fontSize: 10 }}>({deleteShippingHazardousUploadFileName})</span></Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>Do you want to delete this file?</Modal.Body>
                                      <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setDeleteShippingHazardousUploadModal(false)}>Close</Button>
                                        <Button variant="danger" onClick={(e) => deleteShippingHazardousUploads(e)}>
                                          {showDeleteShippingHazardousUploadFilesLoader ?
                                            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                            :
                                            "Delete"
                                          }

                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                  </div>
                                </div>

                                <div class="tab-pane fade" id="haz-request" role="tabpanel" aria-labelledby="haz-request-tab">
                                  <div className="mx-3">
                                    <h4>Hazardous Cargo Request</h4>
                                    <form ref={shipmentHazardousRequestFormRef}>
                                      <div class="d-flex align-content-end flex-wrap">
                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_cargo" class="col-sm-12 col-form-label font-12px">Cargo</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_cargo" name="haz_request_cargo" value="Hazardous" disabled />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_commodity" class="col-sm-12 col-form-label font-12px">Commodity</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_commodity" name="haz_request_commodity" value={updateBookingLineItem[0]?.commodity?.name} disabled />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_dg_ref_number" class="col-sm-12 col-form-label font-12px">DG Ref No</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_dg_ref_number" name="haz_request_dg_ref_number" />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_shipper" class="col-sm-12 col-form-label font-12px">Shipper</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_shipper" name="haz_request_shipper" value={updateShipper} />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_inner_pkg_desc" class="col-sm-12 col-form-label font-12px">Inner Pkg Desc</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_inner_pkg_desc" name="haz_request_inner_pkg_desc" />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_outer_pkg_desc" class="col-sm-12 col-form-label font-12px">Outer Pkg Desc</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_outer_pkg_desc" name="haz_request_outer_pkg_desc" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="d-flex align-content-end flex-wrap">
                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_iip_code_number" class="col-sm-12 col-form-label font-12px">IIP Code No</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_iip_code_number" name="haz_request_iip_code_number" />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_imdg_reg_number" class="col-sm-12 col-form-label font-12px">IMDG Reg No</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_imdg_reg_number" name="haz_request_imdg_reg_number" />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_shipping_name" class="col-sm-12 col-form-label font-12px">Shipping Name</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_shipping_name" name="haz_request_shipping_name" />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_technical_name" class="col-sm-12 col-form-label font-12px">Technical Name</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_technical_name" name="haz_request_technical_name" />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_emergency_number" class="col-sm-12 col-form-label font-12px">Emergency Number</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_emergency_number" name="haz_request_emergency_number" />
                                            </div>
                                          </div>
                                        </div>

                                        <div class="flex-fill" style={{ width: "10%" }}>
                                          <div class="form-group mb-2">
                                            <label for="haz_request_remarks" class="col-sm-12 col-form-label font-12px">Remarks</label>
                                            <div class="col-sm-11">
                                              <input type="text" class="form form-control form-control-sm" id="haz_request_remarks" name="haz_request_remarks" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="d-flex align-content-center flex-wrap">
                                        <div class="flex-fill" style={{ width: "100%", marginTop: 20 }}>
                                          <Button className="btn btn-inox-green btn-sm border-0 px-3" onClick={(e) => addDraftbookingHazardousRequestInformation(e)}>
                                            {showHazardousRequestLoader ?
                                              <Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                              :
                                              "Add Request Information"
                                            }
                                          </Button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>

                                  <div className="mx-3 mt-5">
                                    {updateShipmentHazardousRequestInformation.length > 0 ?
                                      <DataTable
                                        columns={shipmenthazardousRequestInformationcolumns}
                                        data={updateShipmentHazardousRequestInformation}
                                        progressPending={shipmentHazardousRequestDataPending}
                                        progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                        noDataComponent={<p className="text-center table-no-data">No Uploads Found</p>}
                                        highlightOnHover
                                        fixedHeader
                                        customStyles={shipmentUploadsTableCustomStyles}
                                        dense
                                      />
                                      : ""}
                                  </div>

                                  <Modal size="md" show={showDeleteHazardousRequestInformationModal} onHide={() => setShowDeleteHazardousRequestInformationModal(false)} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Delete </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>Do you want to delete this request information?</Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => setShowDeleteHazardousRequestInformationModal(false)}>Close</Button>
                                      <Button variant="danger" onClick={(e) => deleteShippingHazardousRequestInformation(e)}>
                                        {showDeleteHazardousRequestInformationLoader ?
                                          <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                          :
                                          "Delete"
                                        }
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>

                                  <Modal size="xl" show={showUpdateHazardousRequestInformationModal} onHide={() => setShowUpdateHazardousRequestInformationModal(false)} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Update Request</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <form>
                                        <div class="d-flex align-content-end flex-wrap">
                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_cargo" class="col-sm-12 col-form-label font-12px">Cargo</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_cargo" name="haz_request_cargo" value={updateHazardousRequestCargo} disabled />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_commodity" class="col-sm-12 col-form-label font-12px">Commodity</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_commodity" name="haz_request_commodity" value={updateHazardousRequestCommodity} disabled />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_dg_ref_number" class="col-sm-12 col-form-label font-12px">DG Ref No</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_dg_ref_number" name="haz_request_dg_ref_number" value={updateHazardousRequestDgRefNumber}
                                                  onChange={(e) => setUpdateHazardousRequestDgRefNumber(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_shipper" class="col-sm-12 col-form-label font-12px">Shipper</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_shipper" name="haz_request_shipper" value={updateHazardousRequestShipper}
                                                  onChange={(e) => setUpdateHazardousRequestShipper(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_inner_pkg_desc" class="col-sm-12 col-form-label font-12px">Inner Pkg Desc</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_inner_pkg_desc" name="haz_request_inner_pkg_desc" value={updateHazardousRequestInnerPkgDesc}
                                                  onChange={(e) => setUpdateHazardousRequestInnerPkgDesc(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_outer_pkg_desc" class="col-sm-12 col-form-label font-12px">Outer Pkg Desc</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_outer_pkg_desc" name="haz_request_outer_pkg_desc" value={updateHazardousRequestOuterPkgDesc}
                                                  onChange={(e) => setUpdateHazardousRequestOuterPkgDesc(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="d-flex align-content-end flex-wrap">
                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_iip_code_number" class="col-sm-12 col-form-label font-12px">IIP Code No</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_iip_code_number" name="haz_request_iip_code_number" value={updateHazardousRequestIipCodeNumber}
                                                  onChange={(e) => setUpdateHazardousRequestIipCodeNumber(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_imdg_reg_number" class="col-sm-12 col-form-label font-12px">IMDG Reg No</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_imdg_reg_number" name="haz_request_imdg_reg_number" value={updateHazardousRequestImdgRegNumber}
                                                  onChange={(e) => setUpdateHazardousRequestImdgRegNumber(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_shipping_name" class="col-sm-12 col-form-label font-12px">Shipping Name</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_shipping_name" name="haz_request_shipping_name" value={updateHazardousRequestShippingName}
                                                  onChange={(e) => setUpdateHazardousRequestShippingName(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_technical_name" class="col-sm-12 col-form-label font-12px">Technical Name</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_technical_name" name="haz_request_technical_name" value={updateHazardousRequestTechnicalName}
                                                  onChange={(e) => setUpdateHazardousRequestTechnicalName(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_emergency_number" class="col-sm-12 col-form-label font-12px">Emergency Number</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_emergency_number" name="haz_request_emergency_number" value={updateHazardousRequestEmergencyNumber}
                                                  onChange={(e) => setUpdateHazardousRequestEmergencyNumber(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="flex-fill" style={{ width: "10%" }}>
                                            <div class="form-group mb-2">
                                              <label for="haz_request_remarks" class="col-sm-12 col-form-label font-12px">Remarks</label>
                                              <div class="col-sm-11">
                                                <input type="text" class="form form-control form-control-sm" id="haz_request_remarks" name="haz_request_remarks" value={updateHazardousRequestRemarks}
                                                  onChange={(e) => setUpdateHazardousRequestRemarks(e.target.value)} />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => setShowUpdateHazardousRequestInformationModal(false)}>Close</Button>
                                      <Button variant="success" onClick={(e) => updateShippingHazardousRequestInformation(e)}>
                                        {showUpdateHazardousRequestInformationLoader ?
                                          <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                          :
                                          "Update"
                                        }
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                          : ""}

                        <Accordion.Item eventKey="2">
                          <Accordion.Header>Miscellaneous Charges</Accordion.Header>
                          <Accordion.Body>
                            <p><b className="text-danger">Note : </b>miscellaneous charges will be applicable in the local invoice if the booking scenario falls under the category of miscellaneous expenditure list</p>
                            {miscellaneousChargeRows.map((row, index) => (
                              <div class={`row tarrif-add-charge-form ${index != 0 ? 'mt-2' : ''}`}>
                                <div class="col-2">
                                  <input type="text"
                                    id={"miscellaneous_charge_name" + index}
                                    name={"miscellaneous_charge_name" + index}
                                    className="form-control"
                                    placeholder={miscellaneousChargeRows[index]['charge_name'] ? miscellaneousChargeRows[index]['charge_name'] : "Charge Name"}
                                    onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "charge_name", e.target.value)}
                                  />
                                </div>

                                <div class="col-2">
                                  <input
                                    type="number"
                                    id={"miscellaneous_charge_amount" + index}
                                    name={"miscellaneous_charge_amount" + index}
                                    className="form-control"
                                    placeholder={miscellaneousChargeRows[index]['amount'] ? miscellaneousChargeRows[index]['amount'] : "Amount"}
                                    onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "amount", e.target.value)}
                                  />
                                </div>

                                <div class="col-1">
                                  <input
                                    type="number"
                                    id={"miscellaneous_charge_quantity" + index}
                                    name={"miscellaneous_charge_quantity" + index}
                                    className="form-control"
                                    placeholder={miscellaneousChargeRows[index]['quantity'] ? miscellaneousChargeRows[index]['quantity'] : "Quantity"}
                                    onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "quantity", e.target.value)}
                                  />
                                </div>

                                <div class="col-1">
                                  <input
                                    type="number"
                                    id={"miscellaneous_charge_requested" + index}
                                    name={"miscellaneous_charge_requested" + index}
                                    className="form-control"
                                    placeholder={miscellaneousChargeRows[index]['requested'] ? miscellaneousChargeRows[index]['requested'] : "Requested"}
                                    onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "requested", e.target.value)}
                                    disabled
                                  />
                                </div>

                                <div class="col-1">
                                  <input
                                    type="number"
                                    id={"miscellaneous_charge_approved" + index}
                                    name={"miscellaneous_charge_approved" + index}
                                    className="form-control"
                                    placeholder={miscellaneousChargeRows[index]['approved'] ? miscellaneousChargeRows[index]['approved'] : "Approved"}
                                    onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "approved", e.target.value)}
                                    disabled
                                  />
                                </div>

                                <div class="col-2">
                                  <Select
                                    options={currencyList}
                                    id={"miscellaneous_charge_currency" + index}
                                    name={"miscellaneous_charge_currency" + index}
                                    onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "currency_data", e)}
                                    value={miscellaneousChargeRows[index]['currency_data']}
                                    isMulti={false}
                                    isClearable
                                    className="px-0"
                                    placeholder="Currency"
                                  />
                                </div>

                                <div class="col-2">
                                  <select
                                    id={"miscellaneous_charge_paid_by" + index}
                                    name={"miscellaneous_charge_paid_by" + index}
                                    className="form-select text-muted"
                                    onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "paid_by", e.target.value)}>
                                    <option value="" disabled>Paid By</option>
                                    <option value="NA">NA</option>
                                    <option value="SHIPPER">Shipper</option>
                                    <option value="CONSIGNEE">Consignee</option>
                                  </select>
                                </div>

                                <div class="col-1 px-0">
                                  <Button
                                    className="btn btn-danger mx-1"
                                    title="Remove Cargo"
                                    onClick={() => removeMiscellaneousChargeRow(row, index)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Button>

                                  <Button
                                    className="btn btn-inox-green border-0"
                                    title="Add Charge"
                                    onClick={() => addMiscellaneousChargeRow()}
                                  >
                                    <i className="fa fa-plus"></i>
                                  </Button>
                                </div>
                              </div>
                            ))}

                            {/* <div className="row">
                          <div className="col-12" style={{ fontSize: 12, textAlign: 'left' }}>
                            <table width={'100%'}>
                              <tr>
                                <th>Charge</th>
                                <th>Amount</th>
                                <th>Quantity</th>
                                <th>Currency</th>
                              </tr>

                              {updateMiscellaneousCharge.map(charge => {
                              <tr>
                                <td>{charge?.charge_name}</td>
                                <td>{charge?.amount}</td>
                                <td>{charge?.quantity}</td>
                                <td>{charge?.currency?.label}</td>
                              </tr>
                              })}
                            </table>
                          </div>
                        </div> */}
                          </Accordion.Body>
                        </Accordion.Item>

                        {selectedShipmentType?.value == "VIA" || updateSelectedShipmentType?.value == "VIA"?
                        <Accordion.Item eventKey="3">
                          <Accordion.Header>Transhipment Charges</Accordion.Header>
                          <Accordion.Body>
                            <DataTable
                              columns={transhipmentchargescolumns}
                              data={totalTranshipmentCharge?.transhipment_charges}
                              progressPending={transhipmentChargesPending}
                              progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                              noDataComponent={<p className="text-center">No Transhipment Charges Found</p>}
                              pagination
                              highlightOnHover
                              fixedHeader
                              dense
                              customStyles={importExportTableCustomStyles}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                        :""}

                        <Accordion.Item eventKey="4">
                          <Accordion.Header width={1000}>
                            <div class="d-flex justify-content-end">
                              <span>Local Charges</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="row">
                              <div className="col-6">
                                <div className="row mb-3">
                                  <div className="col-6">
                                    <h5>Approximate Export Local Charges</h5>
                                  </div>
                                  <div className="col-6">
                                    <Button className="btn btn-inox-green border-0 btn-sm float-right" onClick={() => setShowAddExportModal(true)}>Add Charge</Button>
                                  </div>
                                </div>

                                {/* --------------------- Add Export Charges ---------------------- */}

                                <Modal size="xl" dialogClassName="custom-modal-width" show={showAddExportModal} onHide={() => [setShowAddExportModal(false), clearExportChargeRow(), setShowExtraExportChargeSelect(true)]} centered>
                                  <Modal.Header closeButton>
                                    <Modal.Title>Add New Export Charge</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <div class="row tarrif-add-charge-form">
                                      <div class="col-3 font-12px">Charge Name</div>
                                      <div class="col-2 font-12px">Amount</div>
                                      <div class="col-1 font-12px">Amount Type</div>
                                      <div class="col-1 font-12px">Charge Type</div>
                                      <div class="col-1 font-12px">Quantity</div>
                                      <div class="col-1 font-12px">Requested</div>
                                      <div class="col-1 font-12px">Approved</div>
                                      <div class="col-2 font-12px">Currency</div>
                                    </div>

                                    {exportChargeRows.map((row, index) => (
                                      <div class={`row tarrif-add-charge-form ${index != 0 ? 'mt-2' : ''}`}>
                                        <div class="col-3">
                                          {showExtraExportChargeSelect ?
                                            <Select
                                              options={shipmentExtraChargeList.filter(item => item.charge_type == "EXPORT")}
                                              id={"export_charge_name" + index}
                                              name={"export_charge_name" + index}
                                              onChange={(e) => [
                                                handleExportChargeChange(index, row.id, "charge_name", e?.value),
                                                setExtraExportChargeDetails(index, e),
                                                setShowExtraExportChargeText(e?.value)
                                              ]}
                                              isMulti={false}
                                              isClearable
                                              className="px-0"
                                              placeholder="Charge"
                                              noOptionsMessage={(e) => [setShowExtraExportChargeSelect(false), setShowExtraExportChargeText(e?.inputValue)]}
                                            />
                                            :
                                            <input
                                              ref={inputExtraExportChargeTextRef}
                                              type="text"
                                              className="form-control"
                                              value={showExtraExportChargeText}
                                              onChange={(e) => {
                                                if (e.target.value.length < 1) {
                                                  setShowExtraExportChargeSelect(true)
                                                  setNewShipmentExportExtraCharge(false)
                                                }
                                                else {
                                                  setShowExtraExportChargeText(e.target.value)
                                                  handleExportChargeChange(index, row.id, "charge_name", e.target.value)
                                                  setNewShipmentExportExtraCharge(true)
                                                }
                                              }}
                                            />
                                          }
                                        </div>

                                        <div class="col-2">
                                          <input
                                            type="number"
                                            id={"export_charge_amount" + index}
                                            name={"export_charge_amount" + index}
                                            className="form-control"
                                            placeholder={exportChargeRows[index]['amount'] ? exportChargeRows[index]['amount'] : "Amount"}
                                            onChange={(e) => handleExportChargeChange(index, row.id, "amount", e.target.value)}
                                          />
                                        </div>

                                        <div class="col-1">
                                          <select id={"export_charge_amount_type" + index}
                                            name={"export_charge_amount_type" + index}
                                            className="form-control"
                                            onChange={(e) => handleExportChargeChange(index, row.id, "amount_type", e.target.value)}>
                                            <option value="AMOUNT" selected>AMOUNT</option>
                                            <option value="PERCENTAGE">PERCENTAGE</option>
                                          </select>
                                        </div>

                                        <div class="col-1">
                                          <select id={"export_charge_type" + index}
                                            name={"export_charge_type" + index}
                                            className="form-control"
                                            onChange={(e) => handleExportChargeChange(index, row.id, "charge_type", e.target.value)} disabled>
                                            <option value="IMPORT" selected>IMPORT</option>
                                            <option value="EXPORT">EXPORT</option>
                                          </select>
                                        </div>

                                        <div class="col-1">
                                          <input
                                            type="number"
                                            id={"export_charge_quantity" + index}
                                            name={"export_charge_quantity" + index}
                                            className="form-control"
                                            placeholder={exportChargeRows[index]['quantity'] ? exportChargeRows[index]['quantity'] : "Quantity"}
                                            onChange={(e) => handleExportChargeChange(index, row.id, "quantity", e.target.value)}
                                            defaultValue={1}
                                          />
                                        </div>

                                        <div class="col-1">
                                          <input
                                            type="number"
                                            id={"export_charge_requested" + index}
                                            name={"export_charge_requested" + index}
                                            className="form-control"
                                            placeholder={exportChargeRows[index]['requested'] ? exportChargeRows[index]['requested'] : "Requested"}
                                            onChange={(e) => handleExportChargeChange(index, row.id, "requested", e.target.value)}
                                            disabled
                                          />
                                        </div>

                                        <div class="col-1">
                                          <input
                                            type="number"
                                            id={"export_charge_approved" + index}
                                            name={"export_charge_approved" + index}
                                            className="form-control"
                                            placeholder={exportChargeRows[index]['approved'] ? exportChargeRows[index]['approved'] : "Approved"}
                                            onChange={(e) => handleExportChargeChange(index, row.id, "approved", e.target.value)}
                                            disabled
                                          />
                                        </div>

                                        <div class="col-2">
                                          {newShipmentExportExtraCharge ?
                                            <Select
                                              options={currencyList}
                                              id={"export_charge_currency" + index}
                                              name={"export_charge_currency" + index}
                                              onChange={(e) => handleExportChargeChange(index, row.id, "currency_data", e)}
                                              isMulti={false}
                                              isClearable
                                              className="px-0"
                                              placeholder="Currency"
                                            />
                                            :
                                            <Select
                                              options={currencyList}
                                              id={"export_charge_currency" + index}
                                              name={"export_charge_currency" + index}
                                              onChange={(e) => handleExportChargeChange(index, row.id, "currency_data", e)}
                                              value={exportChargeRows[index]['currency_data']}
                                              isMulti={false}
                                              isClearable
                                              className="px-0"
                                              placeholder="Currency"
                                            />
                                          }
                                        </div>
                                      </div>
                                    ))}
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" style={{ width: 150 }} onClick={() => [setShowAddExportModal(false), clearExportChargeRow(), setShowExtraExportChargeSelect(true)]}>Close</Button>
                                    <Button class="btn btn-inox-green border-0 text-white" style={{ width: 150 }} onClick={() => [saveAdhocExportCharges(), setShowExtraExportChargeSelect(true)]}>Add Charges</Button>
                                  </Modal.Footer>
                                </Modal>

                                {/* --------------------- Update Export Charges ---------------------- */}
                                <Modal size="xl" dialogClassName="custom-modal-width" show={showUpdateExportModal} onHide={() => [setShowUpdateExportModal(false), setShowExtraExportChargeSelect(true)]} centered>
                                  <Modal.Header>
                                    <Modal.Title>Update Export Charge</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <div class="row tarrif-add-charge-form">
                                      <div class="col-3 font-12px">Charge Name</div>
                                      <div class="col-2 font-12px">Amount</div>
                                      <div class="col-1 font-12px">Amount Type</div>
                                      <div class="col-1 font-12px">Charge Type</div>
                                      <div class="col-1 font-12px">Quantity</div>
                                      <div class="col-1 font-12px">Requested</div>
                                      <div class="col-1 font-12px">Approved</div>
                                      <div class="col-2 font-12px">Currency</div>
                                    </div>

                                    <div class="row tarrif-add-charge-form mt-2">
                                      <div class="col-3">
                                        <Select
                                          options={shipmentExtraChargeList.filter(item => item.charge_type == "EXPORT")}
                                          value={{ "value": updateExportChargeRows?.charge_name, "label": updateExportChargeRows?.charge_name }}
                                          isMulti={false}
                                          isClearable
                                          className="px-0"
                                          placeholder="Charge"
                                          isDisabled
                                        />
                                      </div>

                                      <div class="col-2">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateExportChargeRows?.amount}
                                          onChange={(e) => setUpdateExportChargeRows(prev => ({ ...prev, amount: e.target.value }))}
                                          disabled
                                        />
                                      </div>

                                      <div class="col-1">
                                        <select className="form-control" disabled>
                                          <option value="AMOUNT" selected={updateExportChargeRows?.amount_type == "AMOUNT" ? true : false}>AMOUNT</option>
                                          <option value="PERCENTAGE" selected={updateExportChargeRows?.amount_type == "PERCENTAGE" ? true : false}>PERCENTAGE</option>
                                        </select>
                                      </div>

                                      <div class="col-1">
                                        <select className="form-control" disabled>
                                          <option value="IMPORT" selected={updateExportChargeRows?.charge_type == "IMPORT" ? true : false}>IMPORT</option>
                                          <option value="EXPORT" selected={updateExportChargeRows?.charge_type == "EXPORT" ? true : false}>EXPORT</option>
                                        </select>
                                      </div>

                                      <div class="col-1">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateExportChargeRows?.quantity}
                                          onChange={(e) => setUpdateExportChargeRows(prev => ({ ...prev, quantity: e.target.value }))}
                                        />
                                      </div>

                                      <div class="col-1">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateExportChargeRows?.requested}
                                          onChange={(e) => setUpdateExportChargeRows(prev => ({ ...prev, requested: e.target.value }))}
                                          disabled={loggedInUser?.role_array?.includes("customer") ? false : true}
                                        />
                                      </div>

                                      <div class="col-1">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateExportChargeRows?.approved}
                                          onChange={(e) => setUpdateExportChargeRows(prev => ({ ...prev, approved: e.target.value, amount: e.target.value }))}
                                          disabled={loggedInUser?.role_array?.includes("superadmin") ? false : true}
                                        />
                                      </div>

                                      <div class="col-2">
                                        <Select
                                          options={currencyList}
                                          onChange={(e) => setUpdateExportChargeRows(prev => ({ ...prev, currency_data: e }))}
                                          value={updateExportChargeRows?.currency_data}
                                          isMulti={false}
                                          isClearable
                                          className="px-0"
                                          placeholder="Currency"
                                        />
                                      </div>
                                    </div>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" style={{ width: 150 }} onClick={() => setShowUpdateExportModal(false)}>Close</Button>
                                    <Button class="btn btn-inox-green border-0 text-white" style={{ width: 150 }} onClick={() => updateAdhocExportCharges()}>Update Charge</Button>
                                  </Modal.Footer>
                                </Modal>

                                <DataTable
                                  columns={localexportchargescolumns}
                                  data={exportLocal.filter(item => item.amount != 0)}
                                  progressPending={tarrifChargeDataPending}
                                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                  noDataComponent={<p className="text-center">No Export Charges Found</p>}
                                  pagination
                                  highlightOnHover
                                  fixedHeader
                                  dense
                                  customStyles={importExportTableCustomStyles}
                                />
                              </div>

                              <div className="col-6">
                                <div className="row mb-3">
                                  <div className="col-6">
                                    <h5>Approximate Import Local Charges</h5>
                                  </div>
                                  <div className="col-6">
                                    <Button className="btn btn-inox-green border-0 btn-sm float-right" onClick={() => setShowAddImportModal(true)}>Add Charge</Button>
                                  </div>
                                </div>

                                {/* --------------------- Add Import Charges ---------------------- */}

                                <Modal size="xl" dialogClassName="custom-modal-width" show={showAddImportModal} onHide={() => [setShowAddImportModal(false), clearImportChargeRow(), setShowExtraImportChargeSelect(true)]} centered>
                                  <Modal.Header closeButton>
                                    <Modal.Title>Add New Import Charge</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <div class="row tarrif-add-charge-form">
                                      <div class="col-3 font-12px">Charge Name</div>
                                      <div class="col-2 font-12px">Amount</div>
                                      <div class="col-1 font-12px">Amount Type</div>
                                      <div class="col-1 font-12px">Charge Type</div>
                                      <div class="col-1 font-12px">Quantity</div>
                                      <div class="col-1 font-12px">Requested</div>
                                      <div class="col-1 font-12px">Approved</div>
                                      <div class="col-2 font-12px">Currency</div>
                                      {/* <div class="col-1 font-12px text-center">Action</div> */}
                                    </div>

                                    {importChargeRows.map((row, index) => (
                                      <div class={`row tarrif-add-charge-form ${index != 0 ? 'mt-2' : ''}`}>
                                        <div class="col-3">
                                          {showExtraImportChargeSelect ?
                                            <Select
                                              options={shipmentExtraChargeList.filter(item => item.charge_type == "IMPORT")}
                                              id={"import_charge_name" + index}
                                              name={"import_charge_name" + index}
                                              onChange={(e) => [
                                                handleImportChargeChange(index, row.id, "charge_name", e?.value),
                                                setExtraImportChargeDetails(index, e),
                                                setShowExtraImportChargeText(e?.value)
                                              ]}
                                              isMulti={false}
                                              isClearable
                                              className="px-0"
                                              placeholder="Charge"
                                              noOptionsMessage={(e) => [setShowExtraImportChargeSelect(false), setShowExtraImportChargeText(e?.inputValue)]}
                                            />
                                            :
                                            <input
                                              ref={inputExtraImportChargeTextRef}
                                              type="text"
                                              className="form-control"
                                              value={showExtraImportChargeText}
                                              onChange={(e) => {
                                                if (e.target.value.length < 1) {
                                                  setShowExtraImportChargeSelect(true)
                                                  setNewShipmentImportExtraCharge(false)
                                                }
                                                else {
                                                  setShowExtraImportChargeText(e.target.value)
                                                  handleImportChargeChange(index, row.id, "charge_name", e.target.value)
                                                  setNewShipmentImportExtraCharge(true)
                                                }
                                              }}
                                            />
                                          }
                                        </div>

                                        <div class="col-2">
                                          <input
                                            type="number"
                                            id={"import_charge_amount" + index}
                                            name={"import_charge_amount" + index}
                                            className="form-control"
                                            placeholder={importChargeRows[index]['amount'] ? importChargeRows[index]['amount'] : "Amount"}
                                            onChange={(e) => handleImportChargeChange(index, row.id, "amount", e.target.value)}
                                          />
                                        </div>

                                        <div class="col-1">
                                          <select id={"import_charge_amount_type" + index}
                                            name={"import_charge_amount_type" + index}
                                            className="form-control"
                                            onChange={(e) => handleImportChargeChange(index, row.id, "amount_type", e.target.value)}>
                                            <option value="AMOUNT" selected>AMOUNT</option>
                                            <option value="PERCENTAGE">PERCENTAGE</option>
                                          </select>
                                        </div>

                                        <div class="col-1">
                                          <select id={"import_charge_type" + index}
                                            name={"import_charge_type" + index}
                                            className="form-control"
                                            onChange={(e) => handleImportChargeChange(index, row.id, "charge_type", e.target.value)} disabled>
                                            <option value="IMPORT" selected>IMPORT</option>
                                            <option value="EXPORT">EXPORT</option>
                                          </select>
                                        </div>

                                        <div class="col-1">
                                          <input
                                            type="number"
                                            id={"import_charge_quantity" + index}
                                            name={"import_charge_quantity" + index}
                                            className="form-control"
                                            placeholder={importChargeRows[index]['quantity'] ? importChargeRows[index]['quantity'] : "Quantity"}
                                            onChange={(e) => handleImportChargeChange(index, row.id, "quantity", e.target.value)}
                                            defaultValue={1}
                                          />
                                        </div>

                                        <div class="col-1">
                                          <input
                                            type="number"
                                            id={"import_charge_requested" + index}
                                            name={"import_charge_requested" + index}
                                            className="form-control"
                                            placeholder={importChargeRows[index]['requested'] ? importChargeRows[index]['requested'] : "Requested"}
                                            onChange={(e) => handleImportChargeChange(index, row.id, "requested", e.target.value)}
                                            disabled
                                          />
                                        </div>

                                        <div class="col-1">
                                          <input
                                            type="number"
                                            id={"import_charge_approved" + index}
                                            name={"import_charge_approved" + index}
                                            className="form-control"
                                            placeholder={importChargeRows[index]['approved'] ? importChargeRows[index]['approved'] : "Approved"}
                                            onChange={(e) => handleImportChargeChange(index, row.id, "approved", e.target.value)}
                                            disabled
                                          />
                                        </div>

                                        <div class="col-2">
                                          {newShipmentImportExtraCharge ?
                                            <Select
                                              options={currencyList}
                                              id={"import_charge_currency" + index}
                                              name={"import_charge_currency" + index}
                                              onChange={(e) => handleImportChargeChange(index, row.id, "currency_data", e)}
                                              isMulti={false}
                                              isClearable
                                              className="px-0"
                                              placeholder="Currency"
                                            />
                                            :
                                            <Select
                                              options={currencyList}
                                              id={"import_charge_currency" + index}
                                              name={"import_charge_currency" + index}
                                              onChange={(e) => handleImportChargeChange(index, row.id, "currency_data", e)}
                                              value={importChargeRows[index]['currency_data']}
                                              isMulti={false}
                                              isClearable
                                              className="px-0"
                                              placeholder="Currency"
                                            />
                                          }
                                        </div>

                                        {/* <div class="col-1 px-0 text-center">
                                  <Button 
                                    className="btn btn-danger mx-1"
                                    title="Remove Cargo"
                                    onClick={() => removeImportChargeRow(row.id)}
                                    disabled={index == 0 ? true : false}
                                  >
                                      <i className="fa fa-trash"></i>
                                  </Button>

                                  <Button 
                                    className="btn btn-inox-green border-0"
                                    title="Add Charge"
                                    onClick={() => addImportChargeRow()}
                                  >
                                      <i className="fa fa-plus"></i>
                                  </Button>
                                </div> */}
                                      </div>
                                    ))}
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" style={{ width: 150 }} onClick={() => [setShowAddImportModal(false), clearImportChargeRow(), setShowExtraImportChargeSelect(true)]}>Close</Button>
                                    <Button class="btn btn-inox-green border-0 text-white" style={{ width: 150 }} onClick={() => [saveAdhocImportCharges(), setShowExtraImportChargeSelect(true)]}>Add Charges</Button>
                                  </Modal.Footer>
                                </Modal>


                                {/* --------------------- Update Import Charges ---------------------- */}
                                <Modal size="xl" dialogClassName="custom-modal-width" show={showUpdateImportModal} onHide={() => [setShowAddImportModal(false), setShowExtraImportChargeSelect(true)]} centered>
                                  <Modal.Header>
                                    <Modal.Title>Update Import Charge</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <div class="row tarrif-add-charge-form">
                                      <div class="col-3 font-12px">Charge Name</div>
                                      <div class="col-2 font-12px">Amount</div>
                                      <div class="col-1 font-12px">Amount Type</div>
                                      <div class="col-1 font-12px">Charge Type</div>
                                      <div class="col-1 font-12px">Quantity</div>
                                      <div class="col-1 font-12px">Requested</div>
                                      <div class="col-1 font-12px">Approved</div>
                                      <div class="col-2 font-12px">Currency</div>
                                    </div>

                                    <div class="row tarrif-add-charge-form mt-2">
                                      <div class="col-3">
                                        <Select
                                          options={shipmentExtraChargeList.filter(item => item.charge_type == "IMPORT")}
                                          value={{ "value": updateImportChargeRows?.charge_name, "label": updateImportChargeRows?.charge_name }}
                                          isMulti={false}
                                          isClearable
                                          className="px-0"
                                          placeholder="Charge"
                                          isDisabled
                                        />
                                      </div>

                                      <div class="col-2">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateImportChargeRows?.amount}
                                          onChange={(e) => setUpdateImportChargeRows(prev => ({ ...prev, amount: e.target.value }))}
                                          disabled
                                        />
                                      </div>

                                      <div class="col-1">
                                        <select className="form-control" disabled>
                                          <option value="AMOUNT" selected={updateImportChargeRows?.amount_type == "AMOUNT" ? true : false}>AMOUNT</option>
                                          <option value="PERCENTAGE" selected={updateImportChargeRows?.amount_type == "PERCENTAGE" ? true : false}>PERCENTAGE</option>
                                        </select>
                                      </div>

                                      <div class="col-1">
                                        <select className="form-control" disabled>
                                          <option value="IMPORT" selected={updateImportChargeRows?.charge_type == "IMPORT" ? true : false}>IMPORT</option>
                                          <option value="EXPORT" selected={updateImportChargeRows?.charge_type == "EXPORT" ? true : false}>EXPORT</option>
                                        </select>
                                      </div>

                                      <div class="col-1">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateImportChargeRows?.quantity}
                                          onChange={(e) => setUpdateImportChargeRows(prev => ({ ...prev, quantity: e.target.value }))}
                                        />
                                      </div>

                                      <div class="col-1">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateImportChargeRows?.requested}
                                          onChange={(e) => setUpdateImportChargeRows(prev => ({ ...prev, requested: e.target.value }))}
                                          disabled={loggedInUser?.role_array?.includes("customer") ? false : true}
                                        />
                                      </div>

                                      <div class="col-1">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={updateImportChargeRows?.approved}
                                          onChange={(e) => setUpdateImportChargeRows(prev => ({ ...prev, approved: e.target.value, amount: e.target.value }))}
                                          disabled={loggedInUser?.role_array?.includes("superadmin") ? false : true}
                                        />
                                      </div>

                                      <div class="col-2">
                                        <Select
                                          options={currencyList}
                                          onChange={(e) => setUpdateImportChargeRows(prev => ({ ...prev, currency_data: e }))}
                                          value={updateImportChargeRows?.currency_data}
                                          isMulti={false}
                                          isClearable
                                          className="px-0"
                                          placeholder="Currency"
                                        />
                                      </div>
                                    </div>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" style={{ width: 150 }} onClick={() => setShowUpdateImportModal(false)}>Close</Button>
                                    <Button class="btn btn-inox-green border-0 text-white" style={{ width: 150 }} onClick={() => updateAdhocImportCharges()}>Update Charge</Button>
                                  </Modal.Footer>
                                </Modal>


                                <DataTable
                                  columns={localimportchargescolumns}
                                  data={importLocal.filter(item => item.amount != 0)}
                                  progressPending={tarrifChargeDataPending}
                                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                  noDataComponent={<p className="text-center">No Import Charges Found</p>}
                                  pagination
                                  highlightOnHover
                                  fixedHeader
                                  dense
                                  customStyles={importExportTableCustomStyles}
                                />
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="5">
                          <Accordion.Header>
                            <div class="d-flex justify-content-end">
                              <span>Local Expenses</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="row">
                              <div className="col-6">
                                <DataTable
                                  columns={localexpensescolumns}
                                  data={exportLocal.filter(item => item.expense != 0)}
                                  progressPending={tarrifChargeDataPending}
                                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                  noDataComponent={<p className="text-center">No Export Expenses Found</p>}
                                  pagination
                                  highlightOnHover
                                  fixedHeader
                                  dense
                                  customStyles={importExportTableCustomStyles}
                                  title="Approximate Export Local Expenses"
                                />
                              </div>
                              <div className="col-6">
                                <DataTable
                                  columns={localexpensescolumns}
                                  data={importLocal.filter(item => item.expense != 0)}
                                  progressPending={tarrifChargeDataPending}
                                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                                  noDataComponent={<p className="text-center">No Import Expenses Found</p>}
                                  pagination
                                  highlightOnHover
                                  fixedHeader
                                  dense
                                  customStyles={importExportTableCustomStyles}
                                  title="Approximate Import Local Expenses"
                                />
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                    <div className="row mt-4">
                      <div className="col-4 px-5">
                        <h5>Total Export Income:
                          <b className={`${totalExportCharge < 0 ? "text-danger" : ""}`}> {FormatCurrency(totalExportCharge.toFixed(2), "USD")}</b>
                        </h5>
                        <h5>Total Export Expense:
                          <b className={`${totalExportExpense < 0 ? "text-danger" : ""}`}> {FormatCurrency(totalExportExpense.toFixed(2), "USD")}</b>
                        </h5>
                        <h5>MPE (Margin Per Export):
                          <b className={`${marginPerExport < 0 ? "text-danger" : ""}`}> {FormatCurrency(marginPerExport.toFixed(2), "USD")}</b>
                        </h5>
                      </div>

                      <div className="col-4 px-5 text-center">
                        <h5>Total Transhipment Charge:
                          <b> {FormatCurrency(totalTranshipmentCharge?.total_transhipment_charge?.toFixed(2), "USD")}</b>
                        </h5>
                      </div>

                      <div className="col-4 px-5 text-right">
                        <h5>Total Import Income:
                          <b className={`${totalImportCharge < 0 ? "text-danger" : ""}`}> {FormatCurrency(totalImportCharge.toFixed(2), "USD")}</b>
                        </h5>
                        <h5>Total Import Expense:
                          <b className={`${totalImportExpense < 0 ? "text-danger" : ""}`}> {FormatCurrency(totalImportExpense.toFixed(2), "USD")}</b>
                        </h5>
                        <h5>MPI (Margin Per Import):
                          <b className={`${marginPerImport < 0 ? "text-danger" : ""}`}> {FormatCurrency(marginPerImport.toFixed(2), "USD")}</b>
                        </h5>
                      </div>
                    </div>
                  </div>

                  {shipmentExist ?
                    <div className="col-12 mb-4">
                      <div className="row">
                        <div className="col-7">
                          <div className="btn-group dropup float-right">
                            <button type="button" 
                                    className="btn btn-inox-green border-0 text-white" 
                                    style={{ borderRadius: '5px 0px 0px 5px', width: 200 }} 
                                    onClick={(e) => updateBooking(e)}
                                    disabled={
                                      // updateOption=="approve" && updateStatus=="APPROVED"?true:false || 
                                      updateOption=="waiting_approval" && updateStatus=="WAITING_APPROVAL"?true:false
                                    }
                                    >
                              {showUpdateDraftBookingLoader ?
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                :
                                <span>Update Booking</span>
                              }
                            </button>

                            <button
                              type="button"
                              className="btn btn-inox-green border-0 text-white dropdown-toggle dropdown-toggle-split"
                              style={{ borderRadius: '0px 5px 5px 0px' }}
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span className="fa fa-caret-up"></span>
                            </button>

                            <div className="dropdown-menu dropdown-menu-start custom-topnavbar-dropdown-menu" style={{ top: 'auto', bottom: '100%', right: 0 }}>
                              {loggedInUser?.role_array?.includes("customer") ?
                                <span className={`dropdown-item pointer ${updateOption == 'draft' ? "bg-muted" : ""} ${updateStatus == "DRAFT" ? 'display-none' : ''}`}
                                  onClick={() => setUpdateOption("draft")}>
                                  <i className="fa fa-file-text text-inox-green"></i>
                                  <span className="mx-3">Back To Draft</span>
                                </span>
                                :
                                ""
                              }

                              {loggedInUser?.role_array?.includes("superadmin") ?
                                <span className={`dropdown-item pointer ${updateOption == 'waiting_approval' ? "bg-muted" : ""} ${updateStatus == "WAITING_APPROVAL" ? 'display-none' : ''}`} 
                                  onClick={() => setUpdateOption("waiting_approval")}>
                                  <i className="fa fa-clock-o text-warning"></i>
                                  <span className="mx-3">Send For Approval</span>
                                </span> : ""}

                              {loggedInUser?.role_array?.includes("superadmin") ?
                                <span className={`dropdown-item pointer ${updateOption == 'approve' ? "bg-muted" : ""} `} 
                                  onClick={() => setUpdateOption("approve")}>
                                  <i className="fa fa-check text-success"></i>
                                  <span className="mx-3">Approve</span>
                                </span>
                                : ""}

                              {loggedInUser?.role_array?.includes("superadmin") ?
                                <span className={`dropdown-item pointer ${updateOption == 'reject' ? "bg-muted" : ""} ${updateStatus == "REJECTED" ? 'display-none' : ''}`} 
                                  onClick={() => setUpdateOption("reject")}>
                                  <i className="fa fa-times text-danger"></i>
                                  <span className="mx-3">Reject</span>
                                </span>
                                : ""}

                              {loggedInUser?.role_array?.includes("customer") ?
                                <span className={`dropdown-item pointer ${updateOption == 'cancel' ? "bg-muted" : ""} ${updateStatus == "CANCELLED" ? 'display-none' : ''}`} 
                                  onClick={() => setUpdateOption("cancel")}>
                                  <i className="fa fa-ban text-muted"></i>
                                  <span className="mx-3">Cancel</span>
                                </span>
                                :
                                ""
                              }
                            </div>
                          </div>
                        </div>

                        <div className="col-5">
                          <input type="number"
                            className={`form-control ${submitOption == 'multiple' || submitOption == 'frequent_multiple' ? "" : "display-none"}`}
                            style={{ width: 100 }}
                            min={1}
                            max={10}
                            defaultValue={1}
                            onChange={(e) => setMultipleBookingCount(e.target.value)}>
                          </input>
                        </div>
                      </div>
                    </div>
                    :
                    <div className="col-12 mb-4">
                      <div className="row">
                        <div className="col-7">
                          <div className="btn-group dropup float-right">
                            <button type="button"
                              className="btn btn-inox-green border-0 text-white"
                              style={{ borderRadius: '5px 0px 0px 5px' }}
                              onClick={(e) => addNewBooking(e)}
                              disabled={enableCreateButton ? false : true}
                            >
                              {showDraftBookingLoader ?
                                <Spinner className="mx-5" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                :
                                <span className="px-3">Create Booking</span>
                              }
                            </button>

                            <button
                              type="button"
                              className="btn btn-inox-green border-0 text-white dropdown-toggle dropdown-toggle-split"
                              style={{ borderRadius: '0px 5px 5px 0px' }}
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span className="fa fa-caret-up"></span>
                            </button>

                            <div className="dropdown-menu dropdown-menu-start custom-topnavbar-dropdown-menu" style={{ top: 'auto', bottom: '100%', right: 0 }}>
                              <span className={`dropdown-item pointer ${submitOption == 'draft' ? "bg-muted" : ""}`} onClick={() => setSubmitOption("draft")}>
                                <span>Save As Draft Only</span>
                              </span>
                              <span className={`dropdown-item pointer ${submitOption == 'frequent' ? "bg-muted" : ""}`} onClick={() => setSubmitOption("frequent")}>
                                <span>Add To Frequent Route</span>
                              </span>
                              <span className={`dropdown-item pointer ${submitOption == 'multiple' ? "bg-muted" : ""}`} onClick={() => setSubmitOption("multiple")}>
                                <span>Create Multiple Bookings</span>
                              </span>
                              <span className={`dropdown-item pointer ${submitOption == 'frequent_multiple' ? "bg-muted" : ""}`} onClick={() => setSubmitOption("frequent_multiple")}>
                                <span>Add To Frequent & Create Multiple Bookings</span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="col-5">
                          <input type="number"
                            className={`form-control ${submitOption == 'multiple' || submitOption == 'frequent_multiple' ? "" : "display-none"}`}
                            style={{ width: 100 }}
                            min={1}
                            max={10}
                            defaultValue={1}
                            onChange={(e) => setMultipleBookingCount(e.target.value)}>
                          </input>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                :
                <DeadFreightDraftBookingRequest />
              }
            </div>
            }
          </div>
    </div>
  );
}

export default DraftBookingRequest;